(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44],{

/***/ 54799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94780);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41796);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71657);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(616);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98216);
/* harmony import */ var _iconButtonClasses__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96239);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];












const useUtilityClasses = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(color)}`, edge && `edge${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(edge)}`, `size${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(size)}`]
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(slots, _iconButtonClasses__WEBPACK_IMPORTED_MODULE_4__/* .getIconButtonUtilityClass */ .r, classes);
};
const IconButtonRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ownerState.color)}`], ownerState.edge && styles[`edge${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ownerState.edge)}`], styles[`size${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,_mui_system__WEBPACK_IMPORTED_MODULE_8__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => {
  var _palette;
  const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, palette && {
      backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,_mui_system__WEBPACK_IMPORTED_MODULE_8__/* .alpha */ .Fq)(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, {
    [`&.${_iconButtonClasses__WEBPACK_IMPORTED_MODULE_4__/* ["default"].disabled */ .Z.disabled}`]: {
      backgroundColor: 'transparent',
      color: (theme.vars || theme).palette.action.disabled
    }
  });
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
const IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiIconButton'
  });
  const {
      edge = false,
      children,
      className,
      color = 'default',
      disabled = false,
      disableFocusRipple = false,
      size = 'medium'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconButtonRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (IconButton);

/***/ }),

/***/ 96239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getIconButtonUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getIconButtonUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiIconButton', slot);
}
const iconButtonClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
/* harmony default export */ __webpack_exports__["Z"] = (iconButtonClasses);

/***/ }),

/***/ 96897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parent-login",
      function () {
        return __webpack_require__(98997);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ parent_login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./src/imports/LanguageSelect/index.js + 1 modules
var LanguageSelect = __webpack_require__(99612);
// EXTERNAL MODULE: ./src/assets/icons/register-drawings.svg
var register_drawings = __webpack_require__(39880);
// EXTERNAL MODULE: ./src/assets/icons/register-drawings-small.svg
var register_drawings_small = __webpack_require__(55802);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js
var Autocomplete = __webpack_require__(23776);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/Public.js


/* harmony default export */ var Public = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
}), 'Public'));
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/SchoolOutlined.js


/* harmony default export */ var SchoolOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 3 1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"
}), 'SchoolOutlined'));
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/components/FlatTextField/index.js + 1 modules
var FlatTextField = __webpack_require__(35133);
// EXTERNAL MODULE: ./src/components/FlatButton/index.js + 1 modules
var FlatButton = __webpack_require__(54075);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/api/httpClient.js + 4 modules
var httpClient = __webpack_require__(16799);
;// CONCATENATED MODULE: ./src/api/school.js


const KEYS = {
    SCHOOLS: "schools"
};
const getSchools = async function() {
    let country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", schoolName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const response = await httpClient/* httpClient.get */.M.get("/school/autocomplete", {
        params: {
            q: schoolName === null || schoolName === void 0 ? void 0 : schoolName.toLocaleLowerCase(),
            country
        }
    });
    return response.data;
};
const useSchools = function() {
    let country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", schoolName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0,useQuery/* useQuery */.a)([
        KEYS.SCHOOLS,
        "country=".concat(country),
        "school=".concat(schoolName)
    ], async ()=>getSchools(country, schoolName), {
        enabled: Boolean((schoolName === null || schoolName === void 0 ? void 0 : schoolName.length) >= 3 && country)
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(21987);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./src/assets/logo.png
var logo = __webpack_require__(18630);
// EXTERNAL MODULE: ./src/assets/logo-small.png
var logo_small = __webpack_require__(93347);
;// CONCATENATED MODULE: ./src/sections/parentLogin/components/CreateAccountLayout.js








function CreateAccountLayout(param) {
    let { children , title , subtitle  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "register"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 4,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                sx: {
                    borderRadius: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    py: {
                        xs: 4,
                        md: 5
                    },
                    px: {
                        xs: 3,
                        md: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            sx: {
                                                fontSize: {
                                                    xs: "25px !important",
                                                    md: "40px !important"
                                                },
                                                mb: 2
                                            },
                                            textTransform: "capitalize",
                                            children: title || t("register:create_your_account")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            color: "neutral.dark",
                                            fontWeight: 400,
                                            children: subtitle || t("register:Get_started_in_just_3_simple_steps")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: 150,
                                            sx: {
                                                display: {
                                                    xs: "none",
                                                    sm: "block"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                href: "/",
                                                "aria-label": "home page",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    style: {
                                                        width: "100%",
                                                        height: "auto",
                                                        objectFit: "contain"
                                                    },
                                                    alt: t("common:blue_assembly_logo"),
                                                    src: logo/* default */.Z
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: 25,
                                            sx: {
                                                display: {
                                                    xs: "block",
                                                    sm: "none"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                href: "/",
                                                "aria-label": t("common:home_page"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    style: {
                                                        width: "100%",
                                                        height: "auto",
                                                        objectFit: "contain"
                                                    },
                                                    alt: t("common:blue_assembly_logo"),
                                                    src: logo_small/* default */.Z
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 2,
                            children: children
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var components_CreateAccountLayout = (CreateAccountLayout);

;// CONCATENATED MODULE: ./src/sections/parentLogin/components/countries.js
const countries = [
    {
        id: "af",
        ar: "أفغانستان",
        bg: "Афганистан",
        cs: "Afgh\xe1nist\xe1n",
        da: "Afghanistan",
        de: "Afghanistan",
        el: "Αφγανιστάν",
        en: "Afghanistan",
        eo: "Afganio",
        es: "Afganist\xe1n",
        et: "Afganistan",
        eu: "Afganistan",
        fi: "Afganistan",
        fr: "Afghanistan",
        hu: "Afganiszt\xe1n",
        hy: "Աֆղանստան",
        it: "Afghanistan",
        ja: "アフガニスタン",
        ko: "아프가니스탄",
        lt: "Afganistanas",
        nl: "Afghanistan",
        no: "Afghanistan",
        pl: "Afganistan",
        pt: "Afeganist\xe3o",
        ro: "Afganistan",
        ru: "Афганистан",
        sk: "Afganistan",
        sv: "Afghanistan",
        th: "อัฟกานิสถาน",
        uk: "Афганістан",
        zh: "阿富汗",
        "zh-tw": "阿富汗"
    },
    {
        id: "al",
        ar: "ألبانيا",
        bg: "Албания",
        cs: "Alb\xe1nie",
        da: "Albanien",
        de: "Albanien",
        el: "Αλβανία",
        en: "Albania",
        eo: "Albanio",
        es: "Albania",
        et: "Albaania",
        eu: "Albania",
        fi: "Albania",
        fr: "Albanie",
        hu: "Alb\xe1nia",
        hy: "Ալբանիա",
        it: "Albania",
        ja: "アルバニア",
        ko: "알바니아",
        lt: "Albanija",
        nl: "Albani\xeb",
        no: "Albania",
        pl: "Albania",
        pt: "Alb\xe2nia",
        ro: "Albania",
        ru: "Албания",
        sk: "Alb\xe1nsko",
        sv: "Albanien",
        th: "แอลเบเนีย",
        uk: "Албанія",
        zh: "阿尔巴尼亚",
        "zh-tw": "阿爾巴尼亞"
    },
    {
        id: "dz",
        ar: "الجزائر",
        bg: "Алжир",
        cs: "Alž\xedrsko",
        da: "Algeriet",
        de: "Algerien",
        el: "Αλγερία",
        en: "Algeria",
        eo: "Alĝerio",
        es: "Argelia",
        et: "Alžeeria",
        eu: "Aljeria",
        fi: "Algeria",
        fr: "Alg\xe9rie",
        hu: "Alg\xe9ria",
        hy: "Ալժիր",
        it: "Algeria",
        ja: "アルジェリア",
        ko: "알제리",
        lt: "Alžyras",
        nl: "Algerije",
        no: "Algerie",
        pl: "Algieria",
        pt: "Arg\xe9lia",
        ro: "Algeria",
        ru: "Алжир",
        sk: "Alž\xedrsko",
        sv: "Algeriet",
        th: "แอลจีเรีย",
        uk: "Алжир",
        zh: "阿尔及利亚",
        "zh-tw": "阿爾及利亞"
    },
    {
        id: "ad",
        ar: "أندورا",
        bg: "Андора",
        cs: "Andorra",
        da: "Andorra",
        de: "Andorra",
        el: "Ανδόρρα",
        en: "Andorra",
        eo: "Andoro",
        es: "Andorra",
        et: "Andorra",
        eu: "Andorra",
        fi: "Andorra",
        fr: "Andorre",
        hu: "Andorra",
        hy: "Անդորրա",
        it: "Andorra",
        ja: "アンドラ",
        ko: "안도라",
        lt: "Andora",
        nl: "Andorra",
        no: "Andorra",
        pl: "Andora",
        pt: "Andorra",
        ro: "Andorra",
        ru: "Андорра",
        sk: "Andorra",
        sv: "Andorra",
        th: "อันดอร์รา",
        uk: "Андорра",
        zh: "安道尔",
        "zh-tw": "安道爾"
    },
    {
        id: "ao",
        ar: "أنغولا",
        bg: "Ангола",
        cs: "Angola",
        da: "Angola",
        de: "Angola",
        el: "Ανγκόλα",
        en: "Angola",
        eo: "Angolo",
        es: "Angola",
        et: "Angola",
        eu: "Angola",
        fi: "Angola",
        fr: "Angola",
        hu: "Angola",
        hy: "Անգոլա",
        it: "Angola",
        ja: "アンゴラ",
        ko: "앙골라",
        lt: "Angola",
        nl: "Angola",
        no: "Angola",
        pl: "Angola",
        pt: "Angola",
        ro: "Angola",
        ru: "Ангола",
        sk: "Angola",
        sv: "Angola",
        th: "แองโกลา",
        uk: "Ангола",
        zh: "安哥拉",
        "zh-tw": "安哥拉"
    },
    {
        id: "ag",
        ar: "أنتيغوا وباربودا",
        bg: "Антигуа и Барбуда",
        cs: "Antigua a Barbuda",
        da: "Antigua og Barbuda",
        de: "Antigua und Barbuda",
        el: "Αντίγκουα και Μπαρμπούντα",
        en: "Antigua and Barbuda",
        eo: "Antigvo kaj Barbudo",
        es: "Antigua y Barbuda",
        et: "Antigua ja Barbuda",
        eu: "Antigua eta Barbuda",
        fi: "Antigua ja Barbuda",
        fr: "Antigua-et-Barbuda",
        hu: "Antigua \xe9s Barbuda",
        hy: "Անտիգուա և Բարբուդա",
        it: "Antigua e Barbuda",
        ja: "アンティグア・バーブーダ",
        ko: "앤티가 바부다",
        lt: "Antigva ir Barbuda",
        nl: "Antigua en Barbuda",
        no: "Antigua og Barbuda",
        pl: "Antigua i Barbuda",
        pt: "Ant\xedgua e Barbuda",
        ro: "Antigua și Barbuda",
        ru: "Антигуа и Барбуда",
        sk: "Antigua a Barbuda",
        sv: "Antigua och Barbuda",
        th: "แอนทีกาและบาร์บิวดา",
        uk: "Антигуа і Барбуда",
        zh: "安提瓜和巴布达",
        "zh-tw": "安地卡及巴布達"
    },
    {
        id: "ar",
        ar: "الأرجنتين",
        bg: "Аржентина",
        cs: "Argentina",
        da: "Argentina",
        de: "Argentinien",
        el: "Αργεντινή",
        en: "Argentina",
        eo: "Argentino",
        es: "Argentina",
        et: "Argentina",
        eu: "Argentina",
        fi: "Argentiina",
        fr: "Argentine",
        hu: "Argent\xedna",
        hy: "Արգենտինա",
        it: "Argentina",
        ja: "アルゼンチン",
        ko: "아르헨티나",
        lt: "Argentina",
        nl: "Argentini\xeb",
        no: "Argentina",
        pl: "Argentyna",
        pt: "Argentina",
        ro: "Argentina",
        ru: "Аргентина",
        sk: "Argent\xedna",
        sv: "Argentina",
        th: "อาร์เจนตินา",
        uk: "Аргентина",
        zh: "阿根廷",
        "zh-tw": "阿根廷"
    },
    {
        id: "am",
        ar: "أرمينيا",
        bg: "Армения",
        cs: "Arm\xe9nie",
        da: "Armenien",
        de: "Armenien",
        el: "Αρμενία",
        en: "Armenia",
        eo: "Armenio",
        es: "Armenia",
        et: "Armeenia",
        eu: "Armenia",
        fi: "Armenia",
        fr: "Arm\xe9nie",
        hu: "\xd6rm\xe9nyorsz\xe1g",
        hy: "Հայաստան",
        it: "Armenia",
        ja: "アルメニア",
        ko: "아르메니아",
        lt: "Armėnija",
        nl: "Armeni\xeb",
        no: "Armenia",
        pl: "Armenia",
        pt: "Arm\xeania",
        ro: "Armenia",
        ru: "Армения",
        sk: "Arm\xe9nsko",
        sv: "Armenien",
        th: "อาร์มีเนีย",
        uk: "Вірменія",
        zh: "亚美尼亚",
        "zh-tw": "亞美尼亞"
    },
    {
        id: "au",
        ar: "أستراليا",
        bg: "Австралия",
        cs: "Austr\xe1lie",
        da: "Australien",
        de: "Australien",
        el: "Αυστραλία",
        en: "Australia",
        eo: "Aŭstralio",
        es: "Australia",
        et: "Austraalia",
        eu: "Australia",
        fi: "Australia",
        fr: "Australie",
        hu: "Ausztr\xe1lia",
        hy: "Ավստրալիա",
        it: "Australia",
        ja: "オーストラリア",
        ko: "오스트레일리아",
        lt: "Australija",
        nl: "Australi\xeb",
        no: "Australia",
        pl: "Australia",
        pt: "Austr\xe1lia",
        ro: "Australia",
        ru: "Австралия",
        sk: "Austr\xe1lia",
        sv: "Australien",
        th: "ออสเตรเลีย",
        uk: "Австралія",
        zh: "澳大利亚",
        "zh-tw": "澳大利亞"
    },
    {
        id: "at",
        ar: "النمسا",
        bg: "Австрия",
        cs: "Rakousko",
        da: "\xd8strig",
        de: "\xd6sterreich",
        el: "Αυστρία",
        en: "Austria",
        eo: "Aŭstrio",
        es: "Austria",
        et: "Austria",
        eu: "Austria",
        fi: "It\xe4valta",
        fr: "Autriche",
        hu: "Ausztria",
        hy: "Ավստրիա",
        it: "Austria",
        ja: "オーストリア",
        ko: "오스트리아",
        lt: "Austrija",
        nl: "Oostenrijk",
        no: "\xd8sterrike",
        pl: "Austria",
        pt: "\xc1ustria",
        ro: "Austria",
        ru: "Австрия",
        sk: "Rak\xfasko",
        sv: "\xd6sterrike",
        th: "ออสเตรีย",
        uk: "Австрія",
        zh: "奥地利",
        "zh-tw": "奧地利"
    },
    {
        id: "az",
        ar: "أذربيجان",
        bg: "Азербайджан",
        cs: "\xc1zerb\xe1jdž\xe1n",
        da: "Aserbajdsjan",
        de: "Aserbaidschan",
        el: "Αζερμπαϊτζάν",
        en: "Azerbaijan",
        eo: "Azerbajĝano",
        es: "Azerbaiy\xe1n",
        et: "Aserbaidžaan",
        eu: "Azerbaijan",
        fi: "Azerbaidžan",
        fr: "Azerba\xefdjan",
        hu: "Azerbajdzs\xe1n",
        hy: "Ադրբեջան",
        it: "Azerbaigian",
        ja: "アゼルバイジャン",
        ko: "아제르바이잔",
        lt: "Azerbaidžanas",
        nl: "Azerbeidzjan",
        no: "Aserbajdsjan",
        pl: "Azerbejdżan",
        pt: "Azerbaij\xe3o",
        ro: "Azerbaidjan",
        ru: "Азербайджан",
        sk: "Azerbajdžan",
        sv: "Azerbajdzjan",
        th: "อาเซอร์ไบจาน",
        uk: "Азербайджан",
        zh: "阿塞拜疆",
        "zh-tw": "亞塞拜然"
    },
    {
        id: "bs",
        ar: "باهاماس",
        bg: "Бахамски острови",
        cs: "Bahamy",
        da: "Bahamas",
        de: "Bahamas",
        el: "Μπαχάμες",
        en: "Bahamas",
        eo: "Bahamoj",
        es: "Bahamas",
        et: "Bahama",
        eu: "Bahamak",
        fi: "Bahama",
        fr: "Bahamas",
        hu: "Bahama-szigetek",
        hy: "Բահամներ",
        it: "Bahamas",
        ja: "バハマ",
        ko: "바하마",
        lt: "Bahamos",
        nl: "Bahama's",
        no: "Bahamas",
        pl: "Bahamy",
        pt: "Bahamas",
        ro: "Bahamas",
        ru: "Багамские Острова",
        sk: "Bahamy",
        sv: "Bahamas",
        th: "บาฮามาส",
        uk: "Багамські Острови",
        zh: "巴哈马",
        "zh-tw": "巴哈馬"
    },
    {
        id: "bh",
        ar: "البحرين",
        bg: "Бахрейн",
        cs: "Bahrajn",
        da: "Bahrain",
        de: "Bahrain",
        el: "Μπαχρέιν",
        en: "Bahrain",
        eo: "Barejno",
        es: "Bar\xe9in",
        et: "Bahrein",
        eu: "Bahrain",
        fi: "Bahrain",
        fr: "Bahre\xefn",
        hu: "Bahrein",
        hy: "Բահրեյն",
        it: "Bahrein",
        ja: "バーレーン",
        ko: "바레인",
        lt: "Bahreinas",
        nl: "Bahrein",
        no: "Bahrain",
        pl: "Bahrajn",
        pt: "Bar\xe9m",
        ro: "Bahrain",
        ru: "Бахрейн",
        sk: "Bahrajn",
        sv: "Bahrain",
        th: "บาห์เรน",
        uk: "Бахрейн",
        zh: "巴林",
        "zh-tw": "巴林"
    },
    {
        id: "bd",
        ar: "بنغلاديش",
        bg: "Бангладеш",
        cs: "Banglad\xe9š",
        da: "Bangladesh",
        de: "Bangladesch",
        el: "Μπανγκλαντές",
        en: "Bangladesh",
        eo: "Bangladeŝo",
        es: "Banglad\xe9s",
        et: "Bangladesh",
        eu: "Bangladesh",
        fi: "Bangladesh",
        fr: "Bangladesh",
        hu: "Banglades",
        hy: "Բանգլադեշ",
        it: "Bangladesh",
        ja: "バングラデシュ",
        ko: "방글라데시",
        lt: "Bangladešas",
        nl: "Bangladesh",
        no: "Bangladesh",
        pl: "Bangladesz",
        pt: "Bangladexe",
        ro: "Bangladesh",
        ru: "Бангладеш",
        sk: "Banglad\xe9š",
        sv: "Bangladesh",
        th: "บังกลาเทศ",
        uk: "Бангладеш",
        zh: "孟加拉国",
        "zh-tw": "孟加拉"
    },
    {
        id: "bb",
        ar: "باربادوس",
        bg: "Барбадос",
        cs: "Barbados",
        da: "Barbados",
        de: "Barbados",
        el: "Μπαρμπάντος",
        en: "Barbados",
        eo: "Barbado",
        es: "Barbados",
        et: "Barbados",
        eu: "Barbados",
        fi: "Barbados",
        fr: "Barbade",
        hu: "Barbados",
        hy: "Բարբադոս",
        it: "Barbados",
        ja: "バルバドス",
        ko: "바베이도스",
        lt: "Barbadosas",
        nl: "Barbados",
        no: "Barbados",
        pl: "Barbados",
        pt: "Barbados",
        ro: "Barbados",
        ru: "Барбадос",
        sk: "Barbados",
        sv: "Barbados",
        th: "บาร์เบโดส",
        uk: "Барбадос",
        zh: "巴巴多斯",
        "zh-tw": "巴貝多"
    },
    {
        id: "by",
        ar: "بيلاروس",
        bg: "Беларус",
        cs: "Bělorusko",
        da: "Hviderusland",
        de: "Belarus",
        el: "Λευκορωσία",
        en: "Belarus",
        eo: "Belorusio",
        es: "Bielorrusia",
        et: "Valgevene",
        eu: "Bielorrusia",
        fi: "Valko-Ven\xe4j\xe4",
        fr: "Bi\xe9lorussie",
        hu: "Feh\xe9roroszorsz\xe1g",
        hy: "Բելառուս",
        it: "Bielorussia",
        ja: "ベラルーシ",
        ko: "벨라루스",
        lt: "Baltarusija",
        nl: "Wit-Rusland",
        no: "Belarus",
        pl: "Białoruś",
        pt: "Bielorr\xfassia",
        ro: "Belarus",
        ru: "Белоруссия",
        sk: "Bielorusko",
        sv: "Belarus",
        th: "เบลารุส",
        uk: "Білорусь",
        zh: "白俄罗斯",
        "zh-tw": "白俄羅斯"
    },
    {
        id: "be",
        ar: "بلجيكا",
        bg: "Белгия",
        cs: "Belgie",
        da: "Belgien",
        de: "Belgien",
        el: "Βέλγιο",
        en: "Belgium",
        eo: "Belgio",
        es: "B\xe9lgica",
        et: "Belgia",
        eu: "Belgika",
        fi: "Belgia",
        fr: "Belgique",
        hu: "Belgium",
        hy: "Բելգիա",
        it: "Belgio",
        ja: "ベルギー",
        ko: "벨기에",
        lt: "Belgija",
        nl: "Belgi\xeb",
        no: "Belgia",
        pl: "Belgia",
        pt: "B\xe9lgica",
        ro: "Belgia",
        ru: "Бельгия",
        sk: "Belgicko",
        sv: "Belgien",
        th: "เบลเยียม",
        uk: "Бельгія",
        zh: "比利时",
        "zh-tw": "比利時"
    },
    {
        id: "bz",
        ar: "بليز",
        bg: "Белиз",
        cs: "Belize",
        da: "Belize",
        de: "Belize",
        el: "Μπελίζ",
        en: "Belize",
        eo: "Belizo",
        es: "Belice",
        et: "Belize",
        eu: "Belize",
        fi: "Belize",
        fr: "Belize",
        hu: "Belize",
        hy: "Բելիզ",
        it: "Belize",
        ja: "ベリーズ",
        ko: "벨리즈",
        lt: "Belizas",
        nl: "Belize",
        no: "Belize",
        pl: "Belize",
        pt: "Belize",
        ro: "Belize",
        ru: "Белиз",
        sk: "Belize",
        sv: "Belize",
        th: "เบลีซ",
        uk: "Беліз",
        zh: "伯利兹",
        "zh-tw": "貝里斯"
    },
    {
        id: "bj",
        ar: "بنين",
        bg: "Бенин",
        cs: "Benin",
        da: "Benin",
        de: "Benin",
        el: "Μπενίν",
        en: "Benin",
        eo: "Benino",
        es: "Ben\xedn",
        et: "Benin",
        eu: "Benin",
        fi: "Benin",
        fr: "B\xe9nin",
        hu: "Benin",
        hy: "Բենին",
        it: "Benin",
        ja: "ベナン",
        ko: "베냉",
        lt: "Beninas",
        nl: "Benin",
        no: "Benin",
        pl: "Benin",
        pt: "Benim",
        ro: "Benin",
        ru: "Бенин",
        sk: "Benin",
        sv: "Benin",
        th: "เบนิน",
        uk: "Бенін",
        zh: "贝宁",
        "zh-tw": "貝南"
    },
    {
        id: "bt",
        ar: "بوتان",
        bg: "Бутан",
        cs: "Bh\xfat\xe1n",
        da: "Bhutan",
        de: "Bhutan",
        el: "Μπουτάν",
        en: "Bhutan",
        eo: "Butano",
        es: "But\xe1n",
        et: "Bhutan",
        eu: "Bhutan",
        fi: "Bhutan",
        fr: "Bhoutan",
        hu: "Bhut\xe1n",
        hy: "Բութան",
        it: "Bhutan",
        ja: "ブータン",
        ko: "부탄",
        lt: "Butanas",
        nl: "Bhutan",
        no: "Bhutan",
        pl: "Bhutan",
        pt: "But\xe3o",
        ro: "Bhutan",
        ru: "Бутан",
        sk: "Bhut\xe1n",
        sv: "Bhutan",
        th: "ภูฏาน",
        uk: "Бутан",
        zh: "不丹",
        "zh-tw": "不丹"
    },
    {
        id: "bo",
        ar: "بوليفيا",
        bg: "Боливия",
        cs: "Bol\xedvie",
        da: "Bolivia",
        de: "Bolivien",
        el: "Βολιβία",
        en: "Bolivia (Plurinational State of)",
        eo: "Bolivio",
        es: "Bolivia",
        et: "Boliivia",
        eu: "Bolivia",
        fi: "Bolivia",
        fr: "Bolivie",
        hu: "Bol\xedvia",
        hy: "Բոլիվիա",
        it: "Bolivia",
        ja: "ボリビア多民族国",
        ko: "볼리비아",
        lt: "Bolivija",
        nl: "Bolivia",
        no: "Bolivia",
        pl: "Boliwia",
        pt: "Bol\xedvia",
        ro: "Bolivia",
        ru: "Боливия",
        sk: "Bol\xedvia",
        sv: "Bolivia",
        th: "โบลิเวีย",
        uk: "Болівія",
        zh: "玻利维亚",
        "zh-tw": "玻利維亞"
    },
    {
        id: "ba",
        ar: "البوسنة والهرسك",
        bg: "Босна и Херцеговина",
        cs: "Bosna a Hercegovina",
        da: "Bosnien-Hercegovina",
        de: "Bosnien und Herzegowina",
        el: "Βοσνία-Ερζεγοβίνη",
        en: "Bosnia and Herzegovina",
        eo: "Bosnio kaj Hercegovino",
        es: "Bosnia y Herzegovina",
        et: "Bosnia ja Hertsegoviina",
        eu: "Bosnia-Herzegovina",
        fi: "Bosnia ja Hertsegovina",
        fr: "Bosnie-Herz\xe9govine",
        hu: "Bosznia-Hercegovina",
        hy: "Բոսնիա և Հերցեգովինա",
        it: "Bosnia ed Erzegovina",
        ja: "ボスニア・ヘルツェゴビナ",
        ko: "보스니아 헤르체고비나",
        lt: "Bosnija ir Hercegovina",
        nl: "Bosni\xeb en Herzegovina",
        no: "Bosnia-Hercegovina",
        pl: "Bośnia i Hercegowina",
        pt: "B\xf3snia e Herzegovina",
        ro: "Bosnia și Herțegovina",
        ru: "Босния и Герцеговина",
        sk: "Bosna a Hercegovina",
        sv: "Bosnien och Hercegovina",
        th: "บอสเนียและเฮอร์เซโกวีนา",
        uk: "Боснія і Герцеговина",
        zh: "波黑",
        "zh-tw": "波士尼亞與赫塞哥維納"
    },
    {
        id: "bw",
        ar: "بوتسوانا",
        bg: "Ботсвана",
        cs: "Botswana",
        da: "Botswana",
        de: "Botswana",
        el: "Μποτσουάνα",
        en: "Botswana",
        eo: "Bocvano",
        es: "Botsuana",
        et: "Botswana",
        eu: "Botswana",
        fi: "Botswana",
        fr: "Botswana",
        hu: "Botswana",
        hy: "Բոտսվանա",
        it: "Botswana",
        ja: "ボツワナ",
        ko: "보츠와나",
        lt: "Botsvana",
        nl: "Botswana",
        no: "Botswana",
        pl: "Botswana",
        pt: "Botsuana",
        ro: "Botswana",
        ru: "Ботсвана",
        sk: "Botswana",
        sv: "Botswana",
        th: "บอตสวานา",
        uk: "Ботсвана",
        zh: "博茨瓦纳",
        "zh-tw": "波札那"
    },
    {
        id: "br",
        ar: "البرازيل",
        bg: "Бразилия",
        cs: "Braz\xedlie",
        da: "Brasilien",
        de: "Brasilien",
        el: "Βραζιλία",
        en: "Brazil",
        eo: "Brazilo",
        es: "Brasil",
        et: "Brasiilia",
        eu: "Brasil",
        fi: "Brasilia",
        fr: "Br\xe9sil",
        hu: "Braz\xedlia",
        hy: "Բրազիլիա",
        it: "Brasile",
        ja: "ブラジル",
        ko: "브라질",
        lt: "Brazilija",
        nl: "Brazili\xeb",
        no: "Brasil",
        pl: "Brazylia",
        pt: "Brasil",
        ro: "Brazilia",
        ru: "Бразилия",
        sk: "Braz\xedlia",
        sv: "Brasilien",
        th: "บราซิล",
        uk: "Бразилія",
        zh: "巴西",
        "zh-tw": "巴西"
    },
    {
        id: "bn",
        ar: "بروناي",
        bg: "Бруней",
        cs: "Brunej",
        da: "Brunei",
        de: "Brunei",
        el: "Μπρουνέι",
        en: "Brunei Darussalam",
        eo: "Brunejo",
        es: "Brun\xe9i",
        et: "Brunei",
        eu: "Brunei",
        fi: "Brunei",
        fr: "Brunei",
        hu: "Brunei",
        hy: "Բրունեյ",
        it: "Brunei",
        ja: "ブルネイ・ダルサラーム",
        ko: "브루나이",
        lt: "Brunėjus",
        nl: "Brunei",
        no: "Brunei",
        pl: "Brunei",
        pt: "Brunei",
        ro: "Brunei",
        ru: "Бруней",
        sk: "Brunej",
        sv: "Brunei",
        th: "บรูไน",
        uk: "Бруней",
        zh: "文莱",
        "zh-tw": "汶萊"
    },
    {
        id: "bg",
        ar: "بلغاريا",
        bg: "България",
        cs: "Bulharsko",
        da: "Bulgarien",
        de: "Bulgarien",
        el: "Βουλγαρία",
        en: "Bulgaria",
        eo: "Bulgario",
        es: "Bulgaria",
        et: "Bulgaaria",
        eu: "Bulgaria",
        fi: "Bulgaria",
        fr: "Bulgarie",
        hu: "Bulg\xe1ria",
        hy: "Բուլղարիա",
        it: "Bulgaria",
        ja: "ブルガリア",
        ko: "불가리아",
        lt: "Bulgarija",
        nl: "Bulgarije",
        no: "Bulgaria",
        pl: "Bułgaria",
        pt: "Bulg\xe1ria",
        ro: "Bulgaria",
        ru: "Болгария",
        sk: "Bulharsko",
        sv: "Bulgarien",
        th: "บัลแกเรีย",
        uk: "Болгарія",
        zh: "保加利亚",
        "zh-tw": "保加利亞"
    },
    {
        id: "bf",
        ar: "بوركينا فاسو",
        bg: "Буркина Фасо",
        cs: "Burkina Faso",
        da: "Burkina Faso",
        de: "Burkina Faso",
        el: "Μπουρκίνα Φάσο",
        en: "Burkina Faso",
        eo: "Burkino",
        es: "Burkina Faso",
        et: "Burkina Faso",
        eu: "Burkina Faso",
        fi: "Burkina Faso",
        fr: "Burkina Faso",
        hu: "Burkina Faso",
        hy: "Բուրկինա Ֆասո",
        it: "Burkina Faso",
        ja: "ブルキナファソ",
        ko: "부르키나파소",
        lt: "Burkina Faso",
        nl: "Burkina Faso",
        no: "Burkina Faso",
        pl: "Burkina Faso",
        pt: "Burquina Fasso",
        ro: "Burkina Faso",
        ru: "Буркина-Фасо",
        sk: "Burkina",
        sv: "Burkina Faso",
        th: "บูร์กินาฟาโซ",
        uk: "Буркіна-Фасо",
        zh: "布基纳法索",
        "zh-tw": "布吉納法索"
    },
    {
        id: "bi",
        ar: "بوروندي",
        bg: "Бурунди",
        cs: "Burundi",
        da: "Burundi",
        de: "Burundi",
        el: "Μπουρούντι",
        en: "Burundi",
        eo: "Burundo",
        es: "Burundi",
        et: "Burundi",
        eu: "Burundi",
        fi: "Burundi",
        fr: "Burundi",
        hu: "Burundi",
        hy: "Բուրունդի",
        it: "Burundi",
        ja: "ブルンジ",
        ko: "부룬디",
        lt: "Burundis",
        nl: "Burundi",
        no: "Burundi",
        pl: "Burundi",
        pt: "Burundi",
        ro: "Burundi",
        ru: "Бурунди",
        sk: "Burundi",
        sv: "Burundi",
        th: "บุรุนดี",
        uk: "Бурунді",
        zh: "布隆迪",
        "zh-tw": "蒲隆地"
    },
    {
        id: "kh",
        ar: "كمبوديا",
        bg: "Камбоджа",
        cs: "Kambodža",
        da: "Cambodja",
        de: "Kambodscha",
        el: "Καμπότζη",
        en: "Cambodia",
        eo: "Kamboĝo",
        es: "Camboya",
        et: "Kambodža",
        eu: "Kanbodia",
        fi: "Kambodža",
        fr: "Cambodge",
        hu: "Kambodzsa",
        hy: "Կամբոջա",
        it: "Cambogia",
        ja: "カンボジア",
        ko: "캄보디아",
        lt: "Kambodža",
        nl: "Cambodja",
        no: "Kambodsja",
        pl: "Kambodża",
        pt: "Camboja",
        ro: "Cambodgia",
        ru: "Камбоджа",
        sk: "Kambodža",
        sv: "Kambodja",
        th: "กัมพูชา",
        uk: "Камбоджа",
        zh: "柬埔寨",
        "zh-tw": "柬埔寨"
    },
    {
        id: "cm",
        ar: "الكاميرون",
        bg: "Камерун",
        cs: "Kamerun",
        da: "Cameroun",
        de: "Kamerun",
        el: "Καμερούν",
        en: "Cameroon",
        eo: "Kameruno",
        es: "Camer\xfan",
        et: "Kamerun",
        eu: "Kamerun",
        fi: "Kamerun",
        fr: "Cameroun",
        hu: "Kamerun",
        hy: "Կամերուն",
        it: "Camerun",
        ja: "カメルーン",
        ko: "카메룬",
        lt: "Kamerūnas",
        nl: "Kameroen",
        no: "Kamerun",
        pl: "Kamerun",
        pt: "Camar\xf5es",
        ro: "Camerun",
        ru: "Камерун",
        sk: "Kamerun",
        sv: "Kamerun",
        th: "แคเมอรูน",
        uk: "Камерун",
        zh: "喀麦隆",
        "zh-tw": "喀麥隆"
    },
    {
        id: "ca",
        ar: "كندا",
        bg: "Канада",
        cs: "Kanada",
        da: "Canada",
        de: "Kanada",
        el: "Καναδάς",
        en: "Canada",
        eo: "Kanado",
        es: "Canad\xe1",
        et: "Kanada",
        eu: "Kanada",
        fi: "Kanada",
        fr: "Canada",
        hu: "Kanada",
        hy: "Կանադա",
        it: "Canada",
        ja: "カナダ",
        ko: "캐나다",
        lt: "Kanada",
        nl: "Canada",
        no: "Canada",
        pl: "Kanada",
        pt: "Canad\xe1",
        ro: "Canada",
        ru: "Канада",
        sk: "Kanada",
        sv: "Kanada",
        th: "แคนาดา",
        uk: "Канада",
        zh: "加拿大",
        "zh-tw": "加拿大"
    },
    {
        id: "cv",
        ar: "الرأس الأخضر",
        bg: "Кабо Верде",
        cs: "Kapverdy",
        da: "Kap Verde",
        de: "Kap Verde",
        el: "Πράσινο Ακρωτήρι",
        en: "Cabo Verde",
        eo: "Kaboverdo",
        es: "Cabo Verde",
        et: "Roheneemesaared",
        eu: "Cabo Verde",
        fi: "Kap Verde",
        fr: "Cap-Vert",
        hu: "Z\xf6ld-foki K\xf6zt\xe1rsas\xe1g",
        hy: "Կաբո Վերդե",
        it: "Capo Verde",
        ja: "カーボベルデ",
        ko: "카보베르데",
        lt: "Žaliasis Kyšulys",
        nl: "Kaapverdi\xeb",
        no: "Kapp Verde",
        pl: "Republika Zielonego Przylądka",
        pt: "Cabo Verde",
        ro: "Republica Capului Verde",
        ru: "Кабо-Верде",
        sk: "Kapverdy",
        sv: "Kap Verde",
        th: "กาบูเวร์ดี",
        uk: "Кабо-Верде",
        zh: "佛得角",
        "zh-tw": "維德角"
    },
    {
        id: "cf",
        ar: "جمهورية أفريقيا الوسطى",
        bg: "Централноафриканска република",
        cs: "Středoafrick\xe1 republika",
        da: "Centralafrikanske Republik",
        de: "Zentralafrikanische Republik",
        el: "Κεντροαφρικανική Δημοκρατία",
        en: "Central African Republic",
        eo: "Centr-Afrika Respubliko",
        es: "Rep\xfablica Centroafricana",
        et: "Kesk-Aafrika Vabariik",
        eu: "Afrika Erdiko Errepublika",
        fi: "Keski-Afrikan tasavalta",
        fr: "R\xe9publique centrafricaine",
        hu: "K\xf6z\xe9p-Afrika",
        hy: "Կենտրոնաաֆրիկյան Հանրապետություն",
        it: "Rep. Centrafricana",
        ja: "中央アフリカ共和国",
        ko: "중앙아프리카 공화국",
        lt: "Centrinės Afrikos Respublika",
        nl: "Centraal-Afrikaanse Republiek",
        no: "Den sentralafrikanske republikk",
        pl: "Republika Środkowoafrykańska",
        pt: "Rep\xfablica Centro-Africana",
        ro: "Republica Centrafricană",
        ru: "ЦАР",
        sk: "Stredoafrick\xe1 republika",
        sv: "Centralafrikanska republiken",
        th: "สาธารณรัฐแอฟริกากลาง",
        uk: "Центральноафриканська Республіка",
        zh: "中非",
        "zh-tw": "中非"
    },
    {
        id: "td",
        ar: "تشاد",
        bg: "Чад",
        cs: "Čad",
        da: "Tchad",
        de: "Tschad",
        el: "Τσαντ",
        en: "Chad",
        eo: "Ĉado",
        es: "Chad",
        et: "Tšaad",
        eu: "Txad",
        fi: "Tšad",
        fr: "Tchad",
        hu: "Cs\xe1d",
        hy: "Չադ",
        it: "Ciad",
        ja: "チャド",
        ko: "차드",
        lt: "Čadas",
        nl: "Tsjaad",
        no: "Tsjad",
        pl: "Czad",
        pt: "Chade",
        ro: "Ciad",
        ru: "Чад",
        sk: "Čad",
        sv: "Tchad",
        th: "ชาด",
        uk: "Чад",
        zh: "乍得",
        "zh-tw": "查德"
    },
    {
        id: "cl",
        ar: "تشيلي",
        bg: "Чили",
        cs: "Chile",
        da: "Chile",
        de: "Chile",
        el: "Χιλή",
        en: "Chile",
        eo: "Ĉilio",
        es: "Chile",
        et: "Tšiili",
        eu: "Txile",
        fi: "Chile",
        fr: "Chili",
        hu: "Chile",
        hy: "Չիլի",
        it: "Cile",
        ja: "チリ",
        ko: "칠레",
        lt: "Čilė",
        nl: "Chili",
        no: "Chile",
        pl: "Chile",
        pt: "Chile",
        ro: "Chile",
        ru: "Чили",
        sk: "Čile",
        sv: "Chile",
        th: "ชิลี",
        uk: "Чилі",
        zh: "智利",
        "zh-tw": "智利"
    },
    {
        id: "cn",
        ar: "الصين",
        bg: "Китай",
        cs: "Č\xedna",
        da: "Kina",
        de: "Volksrepublik China",
        el: "Κίνα",
        en: "China",
        eo: "Ĉinio",
        es: "China",
        et: "Hiina",
        eu: "Txina",
        fi: "Kiina",
        fr: "Chine",
        hu: "K\xedna",
        hy: "Չինաստան",
        it: "Cina",
        ja: "中華人民共和国",
        ko: "중국",
        lt: "Kinija",
        nl: "China",
        no: "Kina",
        pl: "Chiny",
        pt: "China",
        ro: "Republica Populară Chineză",
        ru: "Китай (Китайская Народная Республика)",
        sk: "Č\xedna",
        sv: "Kina",
        th: "จีน",
        uk: "Китайська Народна Республіка",
        zh: "中国",
        "zh-tw": "中國"
    },
    {
        id: "co",
        ar: "كولومبيا",
        bg: "Колумбия",
        cs: "Kolumbie",
        da: "Colombia",
        de: "Kolumbien",
        el: "Κολομβία",
        en: "Colombia",
        eo: "Kolombio",
        es: "Colombia",
        et: "Colombia",
        eu: "Kolonbia",
        fi: "Kolumbia",
        fr: "Colombie",
        hu: "Kolumbia",
        hy: "Կոլումբիա",
        it: "Colombia",
        ja: "コロンビア",
        ko: "콜롬비아",
        lt: "Kolumbija",
        nl: "Colombia",
        no: "Colombia",
        pl: "Kolumbia",
        pt: "Col\xf4mbia",
        ro: "Columbia",
        ru: "Колумбия",
        sk: "Kolumbia",
        sv: "Colombia",
        th: "โคลอมเบีย",
        uk: "Колумбія",
        zh: "哥伦比亚",
        "zh-tw": "哥倫比亞"
    },
    {
        id: "km",
        ar: "جزر القمر",
        bg: "Коморски острови",
        cs: "Komory",
        da: "Comorerne",
        de: "Komoren",
        el: "Κομόρες",
        en: "Comoros",
        eo: "Komoroj",
        es: "Comoras",
        et: "Komoorid",
        eu: "Komoreak",
        fi: "Komorit",
        fr: "Comores",
        hu: "Comore-szigetek",
        hy: "Կոմորներ",
        it: "Comore",
        ja: "コモロ",
        ko: "코모로",
        lt: "Komorai",
        nl: "Comoren",
        no: "Komorene",
        pl: "Komory",
        pt: "Comores",
        ro: "Comore",
        ru: "Коморы",
        sk: "Komory",
        sv: "Komorerna",
        th: "คอโมโรส",
        uk: "Коморські Острови",
        zh: "科摩罗",
        "zh-tw": "葛摩"
    },
    {
        id: "cg",
        ar: "جمهورية الكونغو",
        bg: "Република Конго",
        cs: "Kongo",
        da: "Congo",
        de: "Kongo, Republik",
        el: "Κογκό",
        en: "Congo",
        eo: "Respubliko Kongo",
        es: "Rep\xfablica del Congo",
        et: "Kongo Vabariik",
        eu: "Kongoko Errepublika",
        fi: "Kongon tasavalta",
        fr: "R\xe9publique du Congo",
        hu: "Kong\xf3i K\xf6zt\xe1rsas\xe1g (Kong\xf3)",
        hy: "Կոնգոյի Հանրապետություն",
        it: "Rep. del Congo",
        ja: "コンゴ共和国",
        ko: "콩고 공화국",
        lt: "Kongo Respublika",
        nl: "Congo-Brazzaville",
        no: "Kongo, Republikken",
        pl: "Kongo",
        pt: "Rep\xfablica do Congo",
        ro: "Congo",
        ru: "Республика Конго",
        sk: "Kongo",
        sv: "Kongo-Brazzaville",
        th: "สาธารณรัฐคองโก",
        uk: "Республіка Конго",
        zh: "刚果共和国",
        "zh-tw": "剛果共和國"
    },
    {
        id: "cd",
        ar: "جمهورية الكونغو الديمقراطية",
        bg: "Демократична република Конго",
        cs: "Konžsk\xe1 demokratick\xe1 republika",
        da: "Demokratiske Republik Congo",
        de: "Kongo, Demokratische Republik",
        el: "Λαϊκή Δημοκρατία του Κογκό",
        en: "Congo, Democratic Republic of the",
        eo: "Demokratia Respubliko Kongo",
        es: "Rep\xfablica Democr\xe1tica del Congo",
        et: "Kongo Demokraatlik Vabariik",
        eu: "Kongoko Errepublika Demokratikoa",
        fi: "Kongon demokraattinen tasavalta",
        fr: "R\xe9publique d\xe9mocratique du Congo",
        hu: "Kong\xf3i Demokratikus K\xf6zt\xe1rsas\xe1g (Zaire)",
        hy: "Կոնգոյի Դեմոկրատական Հանրապետություն",
        it: "RD del Congo",
        ja: "コンゴ民主共和国",
        ko: "콩고 민주 공화국",
        lt: "Kongo Demokratinė Respublika",
        nl: "Congo-Kinshasa",
        no: "Kongo, Den demokratiske republikken",
        pl: "Demokratyczna Republika Konga",
        pt: "Rep\xfablica Democr\xe1tica do Congo",
        ro: "Republica Democrată Congo",
        ru: "ДР Конго",
        sk: "Konžsk\xe1 demokratick\xe1 republika",
        sv: "Kongo-Kinshasa",
        th: "สาธารณรัฐประชาธิปไตยคองโก",
        uk: "ДР Конго",
        zh: "刚果民主共和国",
        "zh-tw": "剛果民主共和國"
    },
    {
        id: "cr",
        ar: "كوستاريكا",
        bg: "Коста Рика",
        cs: "Kostarika",
        da: "Costa Rica",
        de: "Costa Rica",
        el: "Κόστα Ρίκα",
        en: "Costa Rica",
        eo: "Kostariko",
        es: "Costa Rica",
        et: "Costa Rica",
        eu: "Costa Rica",
        fi: "Costa Rica",
        fr: "Costa Rica",
        hu: "Costa Rica",
        hy: "Կոստա Ռիկա",
        it: "Costa Rica",
        ja: "コスタリカ",
        ko: "코스타리카",
        lt: "Kosta Rika",
        nl: "Costa Rica",
        no: "Costa Rica",
        pl: "Kostaryka",
        pt: "Costa Rica",
        ro: "Costa Rica",
        ru: "Коста-Рика",
        sk: "Kostarika",
        sv: "Costa Rica",
        th: "คอสตาริกา",
        uk: "Коста-Рика",
        zh: "哥斯达黎加",
        "zh-tw": "哥斯大黎加"
    },
    {
        id: "ci",
        ar: "ساحل العاج",
        bg: "Кот д'Ивоар",
        cs: "Pobřež\xed slonoviny",
        da: "Elfenbenskysten",
        de: "Elfenbeink\xfcste",
        el: "Ακτή Ελεφαντοστού",
        en: "C\xf4te d'Ivoire",
        eo: "Ebura Bordo",
        es: "Costa de Marfil",
        et: "Elevandiluurannik",
        eu: "Boli Kosta",
        fi: "Norsunluurannikko",
        fr: "C\xf4te d'Ivoire",
        hu: "Elef\xe1ntcsontpart",
        hy: "Կոտ դ'Իվուար",
        it: "Costa d'Avorio",
        ja: "コートジボワール",
        ko: "코트디부아르",
        lt: "Dramblio Kaulo Krantas",
        nl: "Ivoorkust",
        no: "Elfenbenskysten",
        pl: "Wybrzeże Kości Słoniowej",
        pt: "Costa do Marfim",
        ro: "Coasta de Fildeș",
        ru: "Кот-д’Ивуар",
        sk: "Pobrežie Slonoviny",
        sv: "Elfenbenskusten",
        th: "โกตดิวัวร์",
        uk: "Кот-д'Івуар",
        zh: "科特迪瓦",
        "zh-tw": "象牙海岸"
    },
    {
        id: "hr",
        ar: "كرواتيا",
        bg: "Хърватия",
        cs: "Chorvatsko",
        da: "Kroatien",
        de: "Kroatien",
        el: "Κροατία",
        en: "Croatia",
        eo: "Kroatio",
        es: "Croacia",
        et: "Horvaatia",
        eu: "Kroazia",
        fi: "Kroatia",
        fr: "Croatie",
        hu: "Horv\xe1torsz\xe1g",
        hy: "Խորվաթիա",
        it: "Croazia",
        ja: "クロアチア",
        ko: "크로아티아",
        lt: "Kroatija",
        nl: "Kroati\xeb",
        no: "Kroatia",
        pl: "Chorwacja",
        pt: "Cro\xe1cia",
        ro: "Croația",
        ru: "Хорватия",
        sk: "Chorv\xe1tsko",
        sv: "Kroatien",
        th: "โครเอเชีย",
        uk: "Хорватія",
        zh: "克罗地亚",
        "zh-tw": "克羅埃西亞"
    },
    {
        id: "cu",
        ar: "كوبا",
        bg: "Куба",
        cs: "Kuba",
        da: "Cuba",
        de: "Kuba",
        el: "Κούβα",
        en: "Cuba",
        eo: "Kubo",
        es: "Cuba",
        et: "Kuuba",
        eu: "Kuba",
        fi: "Kuuba",
        fr: "Cuba",
        hu: "Kuba",
        hy: "Կուբա",
        it: "Cuba",
        ja: "キューバ",
        ko: "쿠바",
        lt: "Kuba",
        nl: "Cuba",
        no: "Cuba",
        pl: "Kuba",
        pt: "Cuba",
        ro: "Cuba",
        ru: "Куба",
        sk: "Kuba",
        sv: "Kuba",
        th: "คิวบา",
        uk: "Куба",
        zh: "古巴",
        "zh-tw": "古巴"
    },
    {
        id: "cy",
        ar: "قبرص",
        bg: "Кипър",
        cs: "Kypr",
        da: "Cypern",
        de: "Zypern",
        el: "Κύπρος",
        en: "Cyprus",
        eo: "Kipro",
        es: "Chipre",
        et: "K\xfcpros",
        eu: "Zipre",
        fi: "Kypros",
        fr: "Chypre",
        hu: "Ciprus",
        hy: "Կիպրոս",
        it: "Cipro",
        ja: "キプロス",
        ko: "키프로스",
        lt: "Kipras",
        nl: "Cyprus",
        no: "Kypros",
        pl: "Cypr",
        pt: "Chipre",
        ro: "Cipru",
        ru: "Кипр",
        sk: "Cyprus",
        sv: "Cypern",
        th: "ไซปรัส",
        uk: "Кіпр",
        zh: "塞浦路斯",
        "zh-tw": "賽普勒斯"
    },
    {
        id: "cz",
        ar: "جمهورية التشيك",
        bg: "Чехия",
        cs: "Česko",
        da: "Tjekkiet",
        de: "Tschechien",
        el: "Τσεχία",
        en: "Czechia",
        eo: "Ĉeĥio",
        es: "Rep\xfablica Checa",
        et: "Tšehhi",
        eu: "Txekia",
        fi: "Tšekki",
        fr: "Tch\xe9quie",
        hu: "Csehorsz\xe1g",
        hy: "Չեխիա",
        it: "Rep. Ceca",
        ja: "チェコ",
        ko: "체코",
        lt: "Čekija",
        nl: "Tsjechi\xeb",
        no: "Tsjekkia",
        pl: "Czechy",
        pt: "Ch\xe9quia",
        ro: "Cehia",
        ru: "Чехия",
        sk: "Česko",
        sv: "Tjeckien",
        th: "เช็กเกีย",
        uk: "Чехія",
        zh: "捷克",
        "zh-tw": "捷克"
    },
    {
        id: "dk",
        ar: "الدنمارك",
        bg: "Дания",
        cs: "D\xe1nsko",
        da: "Danmark",
        de: "D\xe4nemark",
        el: "Δανία",
        en: "Denmark",
        eo: "Danio",
        es: "Dinamarca",
        et: "Taani",
        eu: "Danimarka",
        fi: "Tanska",
        fr: "Danemark",
        hu: "D\xe1nia",
        hy: "Դանիա",
        it: "Danimarca",
        ja: "デンマーク",
        ko: "덴마크",
        lt: "Danija",
        nl: "Denemarken",
        no: "Danmark",
        pl: "Dania",
        pt: "Dinamarca",
        ro: "Danemarca",
        ru: "Дания",
        sk: "D\xe1nsko",
        sv: "Danmark",
        th: "เดนมาร์ก",
        uk: "Данія",
        zh: "丹麦",
        "zh-tw": "丹麥"
    },
    {
        id: "dj",
        ar: "جيبوتي",
        bg: "Джибути",
        cs: "Džibutsko",
        da: "Djibouti",
        de: "Dschibuti",
        el: "Τζιμπουτί",
        en: "Djibouti",
        eo: "Ĝibutio",
        es: "Yibuti",
        et: "Djibouti",
        eu: "Djibuti",
        fi: "Djibouti",
        fr: "Djibouti",
        hu: "Dzsibuti",
        hy: "Ջիբութի",
        it: "Gibuti",
        ja: "ジブチ",
        ko: "지부티",
        lt: "Džibutis",
        nl: "Djibouti",
        no: "Djibouti",
        pl: "Dżibuti",
        pt: "Djibuti",
        ro: "Djibouti",
        ru: "Джибути",
        sk: "Džibutsko",
        sv: "Djibouti",
        th: "จิบูตี",
        uk: "Джибуті",
        zh: "吉布提",
        "zh-tw": "吉布地"
    },
    {
        id: "dm",
        ar: "دومينيكا",
        bg: "Доминика",
        cs: "Dominika",
        da: "Dominica",
        de: "Dominica",
        el: "Δομινίκα",
        en: "Dominica",
        eo: "Dominiko",
        es: "Dominica",
        et: "Dominica",
        eu: "Dominika",
        fi: "Dominica",
        fr: "Dominique",
        hu: "Dominikai K\xf6z\xf6ss\xe9g",
        hy: "Դոմինիկա",
        it: "Dominica",
        ja: "ドミニカ国",
        ko: "도미니카 연방",
        lt: "Dominika",
        nl: "Dominica",
        no: "Dominica",
        pl: "Dominika",
        pt: "Dominica",
        ro: "Dominica",
        ru: "Доминика",
        sk: "Dominika",
        sv: "Dominica",
        th: "ดอมินีกา",
        uk: "Домініка",
        zh: "多米尼克",
        "zh-tw": "多米尼克"
    },
    {
        id: "do",
        ar: "جمهورية الدومينيكان",
        bg: "Доминиканска република",
        cs: "Dominik\xe1nsk\xe1 republika",
        da: "Dominikanske Republik",
        de: "Dominikanische Republik",
        el: "Δομινικανή Δημοκρατία",
        en: "Dominican Republic",
        eo: "Dominika Respubliko",
        es: "Rep\xfablica Dominicana",
        et: "Dominikaani Vabariik",
        eu: "Dominikar Errepublika",
        fi: "Dominikaaninen tasavalta",
        fr: "R\xe9publique dominicaine",
        hu: "Dominikai K\xf6zt\xe1rsas\xe1g",
        hy: "Դոմինիկյան Հանրապետություն",
        it: "Rep. Dominicana",
        ja: "ドミニカ共和国",
        ko: "도미니카 공화국",
        lt: "Dominikos Respublika",
        nl: "Dominicaanse Republiek",
        no: "Den dominikanske republikk",
        pl: "Dominikana",
        pt: "Rep\xfablica Dominicana",
        ro: "Republica Dominicană",
        ru: "Доминиканская Республика",
        sk: "Dominik\xe1nska republika",
        sv: "Dominikanska republiken",
        th: "สาธารณรัฐโดมินิกัน",
        uk: "Домініканська Республіка",
        zh: "多米尼加",
        "zh-tw": "多明尼加"
    },
    {
        id: "ec",
        ar: "الإكوادور",
        bg: "Еквадор",
        cs: "Ekv\xe1dor",
        da: "Ecuador",
        de: "Ecuador",
        el: "Ισημερινός",
        en: "Ecuador",
        eo: "Ekvadoro",
        es: "Ecuador",
        et: "Ecuador",
        eu: "Ekuador",
        fi: "Ecuador",
        fr: "\xc9quateur",
        hu: "Ecuador",
        hy: "Էկվադոր",
        it: "Ecuador",
        ja: "エクアドル",
        ko: "에콰도르",
        lt: "Ekvadoras",
        nl: "Ecuador",
        no: "Ecuador",
        pl: "Ekwador",
        pt: "Equador",
        ro: "Ecuador",
        ru: "Эквадор",
        sk: "Ekv\xe1dor",
        sv: "Ecuador",
        th: "เอกวาดอร์",
        uk: "Еквадор",
        zh: "厄瓜多尔",
        "zh-tw": "厄瓜多"
    },
    {
        id: "eg",
        ar: "مصر",
        bg: "Египет",
        cs: "Egypt",
        da: "Egypten",
        de: "\xc4gypten",
        el: "Αίγυπτος",
        en: "Egypt",
        eo: "Egiptio",
        es: "Egipto",
        et: "Egiptus",
        eu: "Egipto",
        fi: "Egypti",
        fr: "\xc9gypte",
        hu: "Egyiptom",
        hy: "Եգիպտոս",
        it: "Egitto",
        ja: "エジプト",
        ko: "이집트",
        lt: "Egiptas",
        nl: "Egypte",
        no: "Egypt",
        pl: "Egipt",
        pt: "Egito",
        ro: "Egipt",
        ru: "Египет",
        sk: "Egypt",
        sv: "Egypten",
        th: "อียิปต์",
        uk: "Єгипет",
        zh: "埃及",
        "zh-tw": "埃及"
    },
    {
        id: "sv",
        ar: "السلفادور",
        bg: "Салвадор",
        cs: "Salvador",
        da: "El Salvador",
        de: "El Salvador",
        el: "Ελ Σαλβαδόρ",
        en: "El Salvador",
        eo: "Salvadoro",
        es: "El Salvador",
        et: "El Salvador",
        eu: "El Salvador",
        fi: "El Salvador",
        fr: "Salvador",
        hu: "Salvador",
        hy: "Սալվադոր",
        it: "El Salvador",
        ja: "エルサルバドル",
        ko: "엘살바도르",
        lt: "Salvadoras",
        nl: "El Salvador",
        no: "El Salvador",
        pl: "Salwador",
        pt: "El Salvador",
        ro: "El Salvador",
        ru: "Сальвадор",
        sk: "Salv\xe1dor",
        sv: "El Salvador",
        th: "เอลซัลวาดอร์",
        uk: "Сальвадор",
        zh: "萨尔瓦多",
        "zh-tw": "薩爾瓦多"
    },
    {
        id: "gq",
        ar: "غينيا الاستوائية",
        bg: "Екваториална Гвинея",
        cs: "Rovn\xedkov\xe1 Guinea",
        da: "\xc6kvatorialguinea",
        de: "\xc4quatorialguinea",
        el: "Ισημερινή Γουινέα",
        en: "Equatorial Guinea",
        eo: "Ekvatora Gvineo",
        es: "Guinea Ecuatorial",
        et: "Ekvatoriaal-Guinea",
        eu: "Ekuatore Ginea",
        fi: "P\xe4iv\xe4ntasaajan Guinea",
        fr: "Guin\xe9e \xe9quatoriale",
        hu: "Egyenl\xedtői-Guinea",
        hy: "Հասարակածային Գվինեա",
        it: "Guinea Equatoriale",
        ja: "赤道ギニア",
        ko: "적도 기니",
        lt: "Pusiaujo Gvinėja",
        nl: "Equatoriaal-Guinea",
        no: "Ekvatorial-Guinea",
        pl: "Gwinea R\xf3wnikowa",
        pt: "Guin\xe9 Equatorial",
        ro: "Guineea Ecuatorială",
        ru: "Экваториальная Гвинея",
        sk: "Rovn\xedkov\xe1 Guinea",
        sv: "Ekvatorialguinea",
        th: "อิเควทอเรียลกินี",
        uk: "Екваторіальна Гвінея",
        zh: "赤道几内亚",
        "zh-tw": "赤道幾內亞"
    },
    {
        id: "er",
        ar: "إريتريا",
        bg: "Еритрея",
        cs: "Eritrea",
        da: "Eritrea",
        de: "Eritrea",
        el: "Ερυθραία",
        en: "Eritrea",
        eo: "Eritreo",
        es: "Eritrea",
        et: "Eritrea",
        eu: "Eritrea",
        fi: "Eritrea",
        fr: "\xc9rythr\xe9e",
        hu: "Eritrea",
        hy: "Էրիտրեա",
        it: "Eritrea",
        ja: "エリトリア",
        ko: "에리트레아",
        lt: "Eritrėja",
        nl: "Eritrea",
        no: "Eritrea",
        pl: "Erytrea",
        pt: "Eritreia",
        ro: "Eritreea",
        ru: "Эритрея",
        sk: "Eritrea",
        sv: "Eritrea",
        th: "เอริเทรีย",
        uk: "Еритрея",
        zh: "厄立特里亚",
        "zh-tw": "厄利垂亞"
    },
    {
        id: "ee",
        ar: "إستونيا",
        bg: "Естония",
        cs: "Estonsko",
        da: "Estland",
        de: "Estland",
        el: "Εσθονία",
        en: "Estonia",
        eo: "Estonio",
        es: "Estonia",
        et: "Eesti",
        eu: "Estonia",
        fi: "Viro",
        fr: "Estonie",
        hu: "\xc9sztorsz\xe1g",
        hy: "Էստոնիա",
        it: "Estonia",
        ja: "エストニア",
        ko: "에스토니아",
        lt: "Estija",
        nl: "Estland",
        no: "Estland",
        pl: "Estonia",
        pt: "Est\xf3nia",
        ro: "Estonia",
        ru: "Эстония",
        sk: "Est\xf3nsko",
        sv: "Estland",
        th: "เอสโตเนีย",
        uk: "Естонія",
        zh: "爱沙尼亚",
        "zh-tw": "愛沙尼亞"
    },
    {
        id: "et",
        ar: "إثيوبيا",
        bg: "Етиопия",
        cs: "Etiopie",
        da: "Etiopien",
        de: "\xc4thiopien",
        el: "Αιθιοπία",
        en: "Ethiopia",
        eo: "Etiopio",
        es: "Etiop\xeda",
        et: "Etioopia",
        eu: "Etiopia",
        fi: "Etiopia",
        fr: "\xc9thiopie",
        hu: "Eti\xf3pia",
        hy: "Եթովպիա",
        it: "Etiopia",
        ja: "エチオピア",
        ko: "에티오피아",
        lt: "Etiopija",
        nl: "Ethiopi\xeb",
        no: "Etiopia",
        pl: "Etiopia",
        pt: "Eti\xf3pia",
        ro: "Etiopia",
        ru: "Эфиопия",
        sk: "Eti\xf3pia",
        sv: "Etiopien",
        th: "เอธิโอเปีย",
        uk: "Ефіопія",
        zh: "埃塞俄比亚",
        "zh-tw": "衣索比亞"
    },
    {
        id: "fj",
        ar: "فيجي",
        bg: "Фиджи",
        cs: "Fidži",
        da: "Fiji",
        de: "Fidschi",
        el: "Φίτζι",
        en: "Fiji",
        eo: "Fiĝio",
        es: "Fiyi",
        et: "Fidži",
        eu: "Fiji",
        fi: "Fidži",
        fr: "Fidji",
        hu: "Fidzsi",
        hy: "Ֆիջի",
        it: "Figi",
        ja: "フィジー",
        ko: "피지",
        lt: "Fidžis",
        nl: "Fiji",
        no: "Fiji",
        pl: "Fidżi",
        pt: "Fiji",
        ro: "Fiji",
        ru: "Фиджи",
        sk: "Fidži",
        sv: "Fiji",
        th: "ฟีจี",
        uk: "Фіджі",
        zh: "斐济",
        "zh-tw": "斐濟"
    },
    {
        id: "fi",
        ar: "فنلندا",
        bg: "Финландия",
        cs: "Finsko",
        da: "Finland",
        de: "Finnland",
        el: "Φινλανδία",
        en: "Finland",
        eo: "Finnlando",
        es: "Finlandia",
        et: "Soome",
        eu: "Finlandia",
        fi: "Suomi",
        fr: "Finlande",
        hu: "Finnorsz\xe1g",
        hy: "Ֆինլանդիա",
        it: "Finlandia",
        ja: "フィンランド",
        ko: "핀란드",
        lt: "Suomija",
        nl: "Finland",
        no: "Finland",
        pl: "Finlandia",
        pt: "Finl\xe2ndia",
        ro: "Finlanda",
        ru: "Финляндия",
        sk: "F\xednsko",
        sv: "Finland",
        th: "ฟินแลนด์",
        uk: "Фінляндія",
        zh: "芬兰",
        "zh-tw": "芬蘭"
    },
    {
        id: "fr",
        ar: "فرنسا",
        bg: "Франция",
        cs: "Francie",
        da: "Frankrig",
        de: "Frankreich",
        el: "Γαλλία",
        en: "France",
        eo: "Francio",
        es: "Francia",
        et: "Prantsusmaa",
        eu: "Frantzia",
        fi: "Ranska",
        fr: "France",
        hu: "Franciaorsz\xe1g",
        hy: "Ֆրանսիա",
        it: "Francia",
        ja: "フランス",
        ko: "프랑스",
        lt: "Prancūzija",
        nl: "Frankrijk",
        no: "Frankrike",
        pl: "Francja",
        pt: "Fran\xe7a",
        ro: "Franța",
        ru: "Франция",
        sk: "Franc\xfazsko",
        sv: "Frankrike",
        th: "ฝรั่งเศส",
        uk: "Франція",
        zh: "法国",
        "zh-tw": "法國"
    },
    {
        id: "ga",
        ar: "الغابون",
        bg: "Габон",
        cs: "Gabon",
        da: "Gabon",
        de: "Gabun",
        el: "Γκαμπόν",
        en: "Gabon",
        eo: "Gabono",
        es: "Gab\xf3n",
        et: "Gabon",
        eu: "Gabon",
        fi: "Gabon",
        fr: "Gabon",
        hu: "Gabon",
        hy: "Գաբոն",
        it: "Gabon",
        ja: "ガボン",
        ko: "가봉",
        lt: "Gabonas",
        nl: "Gabon",
        no: "Gabon",
        pl: "Gabon",
        pt: "Gab\xe3o",
        ro: "Gabon",
        ru: "Габон",
        sk: "Gabon",
        sv: "Gabon",
        th: "กาบอง",
        uk: "Габон",
        zh: "加蓬",
        "zh-tw": "加彭"
    },
    {
        id: "gm",
        ar: "غامبيا",
        bg: "Гамбия",
        cs: "Gambie",
        da: "Gambia",
        de: "Gambia",
        el: "Γκάμπια",
        en: "Gambia",
        eo: "Gambio",
        es: "Gambia",
        et: "Gambia",
        eu: "Gambia",
        fi: "Gambia",
        fr: "Gambie",
        hu: "Gambia",
        hy: "Գամբիա",
        it: "Gambia",
        ja: "ガンビア",
        ko: "감비아",
        lt: "Gambija",
        nl: "Gambia",
        no: "Gambia",
        pl: "Gambia",
        pt: "G\xe2mbia",
        ro: "Gambia",
        ru: "Гамбия",
        sk: "Gambia",
        sv: "Gambia",
        th: "แกมเบีย",
        uk: "Гамбія",
        zh: "冈比亚",
        "zh-tw": "甘比亞"
    },
    {
        id: "ge",
        ar: "جورجيا",
        bg: "Грузия",
        cs: "Gruzie",
        da: "Georgien",
        de: "Georgien",
        el: "Γεωργία",
        en: "Georgia",
        eo: "Kartvelio",
        es: "Georgia",
        et: "Gruusia",
        eu: "Georgia",
        fi: "Georgia",
        fr: "G\xe9orgie",
        hu: "Gr\xfazia",
        hy: "Վրաստան",
        it: "Georgia",
        ja: "ジョージア",
        ko: "조지아",
        lt: "Gruzija",
        nl: "Georgi\xeb",
        no: "Georgia",
        pl: "Gruzja",
        pt: "Ge\xf3rgia",
        ro: "Georgia",
        ru: "Грузия",
        sk: "Gruz\xednsko",
        sv: "Georgien",
        th: "จอร์เจีย",
        uk: "Грузія",
        zh: "格鲁吉亚",
        "zh-tw": "喬治亞"
    },
    {
        id: "de",
        ar: "ألمانيا",
        bg: "Германия",
        cs: "Německo",
        da: "Tyskland",
        de: "Deutschland",
        el: "Γερμανία",
        en: "Germany",
        eo: "Germanio",
        es: "Alemania",
        et: "Saksamaa",
        eu: "Alemania",
        fi: "Saksa",
        fr: "Allemagne",
        hu: "N\xe9metorsz\xe1g",
        hy: "Գերմանիա",
        it: "Germania",
        ja: "ドイツ",
        ko: "독일",
        lt: "Vokietija",
        nl: "Duitsland",
        no: "Tyskland",
        pl: "Niemcy",
        pt: "Alemanha",
        ro: "Germania",
        ru: "Германия",
        sk: "Nemecko",
        sv: "Tyskland",
        th: "เยอรมนี",
        uk: "Німеччина",
        zh: "德国",
        "zh-tw": "德國"
    },
    {
        id: "gh",
        ar: "غانا",
        bg: "Гана",
        cs: "Ghana",
        da: "Ghana",
        de: "Ghana",
        el: "Γκάνα",
        en: "Ghana",
        eo: "Ganao",
        es: "Ghana",
        et: "Ghana",
        eu: "Ghana",
        fi: "Ghana",
        fr: "Ghana",
        hu: "Gh\xe1na",
        hy: "Գանա",
        it: "Ghana",
        ja: "ガーナ",
        ko: "가나",
        lt: "Gana",
        nl: "Ghana",
        no: "Ghana",
        pl: "Ghana",
        pt: "Gana",
        ro: "Ghana",
        ru: "Гана",
        sk: "Ghana",
        sv: "Ghana",
        th: "กานา",
        uk: "Гана",
        zh: "加纳",
        "zh-tw": "迦納"
    },
    {
        id: "gr",
        ar: "اليونان",
        bg: "Гърция",
        cs: "Řecko",
        da: "Gr\xe6kenland",
        de: "Griechenland",
        el: "Ελλάδα",
        en: "Greece",
        eo: "Grekio",
        es: "Grecia",
        et: "Kreeka",
        eu: "Grezia",
        fi: "Kreikka",
        fr: "Gr\xe8ce",
        hu: "G\xf6r\xf6gorsz\xe1g",
        hy: "Հունաստան",
        it: "Grecia",
        ja: "ギリシャ",
        ko: "그리스",
        lt: "Graikija",
        nl: "Griekenland",
        no: "Hellas",
        pl: "Grecja",
        pt: "Gr\xe9cia",
        ro: "Grecia",
        ru: "Греция",
        sk: "Gr\xe9cko",
        sv: "Grekland",
        th: "กรีซ",
        uk: "Греція",
        zh: "希腊",
        "zh-tw": "希臘"
    },
    {
        id: "gd",
        ar: "غرينادا",
        bg: "Гренада",
        cs: "Grenada",
        da: "Grenada",
        de: "Grenada",
        el: "Γρενάδα",
        en: "Grenada",
        eo: "Grenado",
        es: "Granada",
        et: "Grenada",
        eu: "Grenada",
        fi: "Grenada",
        fr: "Grenade",
        hu: "Grenada",
        hy: "Գրենադա",
        it: "Grenada",
        ja: "グレナダ",
        ko: "그레나다",
        lt: "Grenada",
        nl: "Grenada",
        no: "Grenada",
        pl: "Grenada",
        pt: "Granada",
        ro: "Grenada",
        ru: "Гренада",
        sk: "Grenada",
        sv: "Grenada",
        th: "กรีเนดา",
        uk: "Гренада",
        zh: "格林纳达",
        "zh-tw": "格瑞那達"
    },
    {
        id: "gt",
        ar: "غواتيمالا",
        bg: "Гватемала",
        cs: "Guatemala",
        da: "Guatemala",
        de: "Guatemala",
        el: "Γουατεμάλα",
        en: "Guatemala",
        eo: "Gvatemalo",
        es: "Guatemala",
        et: "Guatemala",
        eu: "Guatemala",
        fi: "Guatemala",
        fr: "Guatemala",
        hu: "Guatemala",
        hy: "Գվատեմալա",
        it: "Guatemala",
        ja: "グアテマラ",
        ko: "과테말라",
        lt: "Gvatemala",
        nl: "Guatemala",
        no: "Guatemala",
        pl: "Gwatemala",
        pt: "Guatemala",
        ro: "Guatemala",
        ru: "Гватемала",
        sk: "Guatemala",
        sv: "Guatemala",
        th: "กัวเตมาลา",
        uk: "Гватемала",
        zh: "危地马拉",
        "zh-tw": "瓜地馬拉"
    },
    {
        id: "gn",
        ar: "غينيا",
        bg: "Гвинея",
        cs: "Guinea",
        da: "Guinea",
        de: "Guinea",
        el: "Γουινέα",
        en: "Guinea",
        eo: "Gvineo",
        es: "Guinea",
        et: "Guinea",
        eu: "Ginea",
        fi: "Guinea",
        fr: "Guin\xe9e",
        hu: "Guinea",
        hy: "Գվինեա",
        it: "Guinea",
        ja: "ギニア",
        ko: "기니",
        lt: "Gvinėja",
        nl: "Guinee",
        no: "Guinea",
        pl: "Gwinea",
        pt: "Guin\xe9",
        ro: "Guineea",
        ru: "Гвинея",
        sk: "Guinea",
        sv: "Guinea",
        th: "กินี",
        uk: "Гвінея",
        zh: "几内亚",
        "zh-tw": "幾內亞"
    },
    {
        id: "gw",
        ar: "غينيا بيساو",
        bg: "Гвинея-Бисау",
        cs: "Guinea-Bissau",
        da: "Guinea-Bissau",
        de: "Guinea-Bissau",
        el: "Γουινέα-Μπισσάου",
        en: "Guinea-Bissau",
        eo: "Gvineo Bisaŭa",
        es: "Guinea-Bis\xe1u",
        et: "Guinea-Bissau",
        eu: "Ginea-Bissau",
        fi: "Guinea-Bissau",
        fr: "Guin\xe9e-Bissau",
        hu: "Bissau-Guinea",
        hy: "Գվինեա-Բիսաու",
        it: "Guinea-Bissau",
        ja: "ギニアビサウ",
        ko: "기니비사우",
        lt: "Bisau Gvinėja",
        nl: "Guinee-Bissau",
        no: "Guinea-Bissau",
        pl: "Gwinea Bissau",
        pt: "Guin\xe9-Bissau",
        ro: "Guineea-Bissau",
        ru: "Гвинея-Бисау",
        sk: "Guinea-Bissau",
        sv: "Guinea-Bissau",
        th: "กินี-บิสเซา",
        uk: "Гвінея-Бісау",
        zh: "几内亚比绍",
        "zh-tw": "幾內亞比索"
    },
    {
        id: "gy",
        ar: "غيانا",
        bg: "Гвиана",
        cs: "Guyana",
        da: "Guyana",
        de: "Guyana",
        el: "Γουιάνα",
        en: "Guyana",
        eo: "Gujano",
        es: "Guyana",
        et: "Guyana",
        eu: "Guyana",
        fi: "Guyana",
        fr: "Guyana",
        hu: "Guyana",
        hy: "Գայանա",
        it: "Guyana",
        ja: "ガイアナ",
        ko: "가이아나",
        lt: "Gajana",
        nl: "Guyana",
        no: "Guyana",
        pl: "Gujana",
        pt: "Guiana",
        ro: "Guyana",
        ru: "Гайана",
        sk: "Guyana",
        sv: "Guyana",
        th: "กายอานา",
        uk: "Гаяна",
        zh: "圭亚那",
        "zh-tw": "蓋亞那"
    },
    {
        id: "ht",
        ar: "هايتي",
        bg: "Хаити",
        cs: "Haiti",
        da: "Haiti",
        de: "Haiti",
        el: "Αϊτή",
        en: "Haiti",
        eo: "Haitio",
        es: "Hait\xed",
        et: "Haiti",
        eu: "Haiti",
        fi: "Haiti",
        fr: "Ha\xefti",
        hu: "Haiti",
        hy: "Հայիթի",
        it: "Haiti",
        ja: "ハイチ",
        ko: "아이티",
        lt: "Haitis",
        nl: "Ha\xefti",
        no: "Haiti",
        pl: "Haiti",
        pt: "Haiti",
        ro: "Haiti",
        ru: "Гаити",
        sk: "Haiti",
        sv: "Haiti",
        th: "เฮติ",
        uk: "Гаїті",
        zh: "海地",
        "zh-tw": "海地"
    },
    {
        id: "hn",
        ar: "هندوراس",
        bg: "Хондурас",
        cs: "Honduras",
        da: "Honduras",
        de: "Honduras",
        el: "Ονδούρα",
        en: "Honduras",
        eo: "Honduro",
        es: "Honduras",
        et: "Honduras",
        eu: "Honduras",
        fi: "Honduras",
        fr: "Honduras",
        hu: "Honduras",
        hy: "Հոնդուրաս",
        it: "Honduras",
        ja: "ホンジュラス",
        ko: "온두라스",
        lt: "Hondūras",
        nl: "Honduras",
        no: "Honduras",
        pl: "Honduras",
        pt: "Honduras",
        ro: "Honduras",
        ru: "Гондурас",
        sk: "Honduras",
        sv: "Honduras",
        th: "ฮอนดูรัส",
        uk: "Гондурас",
        zh: "洪都拉斯",
        "zh-tw": "宏都拉斯"
    },
    {
        id: "hu",
        ar: "المجر",
        bg: "Унгария",
        cs: "Maďarsko",
        da: "Ungarn",
        de: "Ungarn",
        el: "Ουγγαρία",
        en: "Hungary",
        eo: "Hungario",
        es: "Hungr\xeda",
        et: "Ungari",
        eu: "Hungaria",
        fi: "Unkari",
        fr: "Hongrie",
        hu: "Magyarorsz\xe1g",
        hy: "Հունգարիա",
        it: "Ungheria",
        ja: "ハンガリー",
        ko: "헝가리",
        lt: "Vengrija",
        nl: "Hongarije",
        no: "Ungarn",
        pl: "Węgry",
        pt: "Hungria",
        ro: "Ungaria",
        ru: "Венгрия",
        sk: "Maďarsko",
        sv: "Ungern",
        th: "ฮังการี",
        uk: "Угорщина",
        zh: "匈牙利",
        "zh-tw": "匈牙利"
    },
    {
        id: "is",
        ar: "آيسلندا",
        bg: "Исландия",
        cs: "Island",
        da: "Island",
        de: "Island",
        el: "Ισλανδία",
        en: "Iceland",
        eo: "Islando",
        es: "Islandia",
        et: "Island",
        eu: "Islandia",
        fi: "Islanti",
        fr: "Islande",
        hu: "Izland",
        hy: "Իսլանդիա",
        it: "Islanda",
        ja: "アイスランド",
        ko: "아이슬란드",
        lt: "Islandija",
        nl: "IJsland",
        no: "Island",
        pl: "Islandia",
        pt: "Isl\xe2ndia",
        ro: "Islanda",
        ru: "Исландия",
        sk: "Island",
        sv: "Island",
        th: "ไอซ์แลนด์",
        uk: "Ісландія",
        zh: "冰岛",
        "zh-tw": "冰島"
    },
    {
        id: "in",
        ar: "الهند",
        bg: "Индия",
        cs: "Indie",
        da: "Indien",
        de: "Indien",
        el: "Ινδία",
        en: "India",
        eo: "Barato",
        es: "India",
        et: "India",
        eu: "India",
        fi: "Intia",
        fr: "Inde",
        hu: "India",
        hy: "Հնդկաստան",
        it: "India",
        ja: "インド",
        ko: "인도",
        lt: "Indija",
        nl: "India",
        no: "India",
        pl: "Indie",
        pt: "\xcdndia",
        ro: "India",
        ru: "Индия",
        sk: "India",
        sv: "Indien",
        th: "อินเดีย",
        uk: "Індія",
        zh: "印度",
        "zh-tw": "印度"
    },
    {
        id: "id",
        ar: "إندونيسيا",
        bg: "Индонезия",
        cs: "Indon\xe9sie",
        da: "Indonesien",
        de: "Indonesien",
        el: "Ινδονησία",
        en: "Indonesia",
        eo: "Indonezio",
        es: "Indonesia",
        et: "Indoneesia",
        eu: "Indonesia",
        fi: "Indonesia",
        fr: "Indon\xe9sie",
        hu: "Indon\xe9zia",
        hy: "Ինդոնեզիա",
        it: "Indonesia",
        ja: "インドネシア",
        ko: "인도네시아",
        lt: "Indonezija",
        nl: "Indonesi\xeb",
        no: "Indonesia",
        pl: "Indonezja",
        pt: "Indon\xe9sia",
        ro: "Indonezia",
        ru: "Индонезия",
        sk: "Indon\xe9zia",
        sv: "Indonesien",
        th: "อินโดนีเซีย",
        uk: "Індонезія",
        zh: "印度尼西亚",
        "zh-tw": "印度尼西亞"
    },
    {
        id: "ir",
        ar: "إيران",
        bg: "Иран",
        cs: "\xcdr\xe1n",
        da: "Iran",
        de: "Iran",
        el: "Ιράν",
        en: "Iran (Islamic Republic of)",
        eo: "Irano",
        es: "Ir\xe1n",
        et: "Iraan",
        eu: "Iran",
        fi: "Iran",
        fr: "Iran",
        hu: "Ir\xe1n",
        hy: "Իրան",
        it: "Iran",
        ja: "イラン・イスラム共和国",
        ko: "이란",
        lt: "Iranas",
        nl: "Iran",
        no: "Iran",
        pl: "Iran",
        pt: "Ir\xe3",
        ro: "Iran",
        ru: "Иран",
        sk: "Ir\xe1n",
        sv: "Iran",
        th: "อิหร่าน",
        uk: "Іран",
        zh: "伊朗",
        "zh-tw": "伊朗"
    },
    {
        id: "iq",
        ar: "العراق",
        bg: "Ирак",
        cs: "Ir\xe1k",
        da: "Irak",
        de: "Irak",
        el: "Ιράκ",
        en: "Iraq",
        eo: "Irako",
        es: "Irak",
        et: "Iraak",
        eu: "Irak",
        fi: "Irak",
        fr: "Irak",
        hu: "Irak",
        hy: "Իրաք",
        it: "Iraq",
        ja: "イラク",
        ko: "이라크",
        lt: "Irakas",
        nl: "Irak",
        no: "Irak",
        pl: "Irak",
        pt: "Iraque",
        ro: "Irak",
        ru: "Ирак",
        sk: "Irak",
        sv: "Irak",
        th: "อิรัก",
        uk: "Ірак",
        zh: "伊拉克",
        "zh-tw": "伊拉克"
    },
    {
        id: "ie",
        ar: "أيرلندا",
        bg: "Ирландия",
        cs: "Irsko",
        da: "Irland",
        de: "Irland",
        el: "Ιρλανδία",
        en: "Ireland",
        eo: "Irlando",
        es: "Irlanda",
        et: "Iirimaa",
        eu: "Irlandako Errepublika",
        fi: "Irlanti",
        fr: "Irlande",
        hu: "\xcdrorsz\xe1g",
        hy: "Իռլանդիա",
        it: "Irlanda",
        ja: "アイルランド",
        ko: "아일랜드",
        lt: "Airija",
        nl: "Ierland",
        no: "Irland",
        pl: "Irlandia",
        pt: "Irlanda",
        ro: "Republica Irlanda",
        ru: "Ирландия",
        sk: "\xcdrsko",
        sv: "Irland",
        th: "ไอร์แลนด์",
        uk: "Ірландія",
        zh: "爱尔兰",
        "zh-tw": "愛爾蘭"
    },
    {
        id: "ps",
        ar: "فلسطين",
        bg: "Палестинска автономия",
        cs: "Palestinsk\xe1 autonomie",
        da: "Pal\xe6stina",
        de: "Pal\xe4stina",
        el: "Δυτική Όχθη",
        en: "Palestine, State of",
        eo: "Palestino",
        es: "Palestina",
        et: "Palestiina",
        eu: "Palestina",
        fi: "Palestiina",
        fr: "Palestine",
        hu: "Palesztina",
        hy: "Պաղեստինյան ազգային վարչություն",
        it: "Palestina",
        ja: "パレスチナ",
        ko: "팔레스타인",
        lt: "Palestina",
        nl: "Palestina",
        no: "De palestinske territoriene",
        pl: "Palestyna",
        pt: "Palestina",
        ro: "Teritoriile Palestiniene Ocupate",
        ru: "Государство Палестина",
        sk: "Palest\xedna",
        sv: "Palestina",
        th: "ปาเลสไตน์",
        uk: "Палестина",
        zh: "巴勒斯坦",
        "zh-tw": "巴勒斯坦"
    },
    {
        id: "it",
        ar: "إيطاليا",
        bg: "Италия",
        cs: "It\xe1lie",
        da: "Italien",
        de: "Italien",
        el: "Ιταλία",
        en: "Italy",
        eo: "Italio",
        es: "Italia",
        et: "Itaalia",
        eu: "Italia",
        fi: "Italia",
        fr: "Italie",
        hu: "Olaszorsz\xe1g",
        hy: "Իտալիա",
        it: "Italia",
        ja: "イタリア",
        ko: "이탈리아",
        lt: "Italija",
        nl: "Itali\xeb",
        no: "Italia",
        pl: "Włochy",
        pt: "It\xe1lia",
        ro: "Italia",
        ru: "Италия",
        sk: "Taliansko",
        sv: "Italien",
        th: "อิตาลี",
        uk: "Італія",
        zh: "意大利",
        "zh-tw": "義大利"
    },
    {
        id: "jm",
        ar: "جامايكا",
        bg: "Ямайка",
        cs: "Jamajka",
        da: "Jamaica",
        de: "Jamaika",
        el: "Τζαμάικα",
        en: "Jamaica",
        eo: "Jamajko",
        es: "Jamaica",
        et: "Jamaica",
        eu: "Jamaika",
        fi: "Jamaika",
        fr: "Jama\xefque",
        hu: "Jamaica",
        hy: "Ճամայկա",
        it: "Giamaica",
        ja: "ジャマイカ",
        ko: "자메이카",
        lt: "Jamaika",
        nl: "Jamaica",
        no: "Jamaica",
        pl: "Jamajka",
        pt: "Jamaica",
        ro: "Jamaica",
        ru: "Ямайка",
        sk: "Jamajka",
        sv: "Jamaica",
        th: "จาเมกา",
        uk: "Ямайка",
        zh: "牙买加",
        "zh-tw": "牙買加"
    },
    {
        id: "jp",
        ar: "اليابان",
        bg: "Япония",
        cs: "Japonsko",
        da: "Japan",
        de: "Japan",
        el: "Ιαπωνία",
        en: "Japan",
        eo: "Japanio",
        es: "Jap\xf3n",
        et: "Jaapan",
        eu: "Japonia",
        fi: "Japani",
        fr: "Japon",
        hu: "Jap\xe1n",
        hy: "Ճապոնիա",
        it: "Giappone",
        ja: "日本",
        ko: "일본",
        lt: "Japonija",
        nl: "Japan",
        no: "Japan",
        pl: "Japonia",
        pt: "Jap\xe3o",
        ro: "Japonia",
        ru: "Япония",
        sk: "Japonsko",
        sv: "Japan",
        th: "ญี่ปุ่น",
        uk: "Японія",
        zh: "日本",
        "zh-tw": "日本"
    },
    {
        id: "jo",
        ar: "الأردن",
        bg: "Йордания",
        cs: "Jord\xe1nsko",
        da: "Jordan",
        de: "Jordanien",
        el: "Ιορδανία",
        en: "Jordan",
        eo: "Jordanio",
        es: "Jordania",
        et: "Jordaania",
        eu: "Jordania",
        fi: "Jordania",
        fr: "Jordanie",
        hu: "Jord\xe1nia",
        hy: "Հորդանան",
        it: "Giordania",
        ja: "ヨルダン",
        ko: "요르단",
        lt: "Jordanija",
        nl: "Jordani\xeb",
        no: "Jordan",
        pl: "Jordania",
        pt: "Jord\xe2nia",
        ro: "Iordania",
        ru: "Иордания",
        sk: "Jord\xe1nsko",
        sv: "Jordanien",
        th: "จอร์แดน",
        uk: "Йорданія",
        zh: "约旦",
        "zh-tw": "約旦"
    },
    {
        id: "kz",
        ar: "كازاخستان",
        bg: "Казахстан",
        cs: "Kazachst\xe1n",
        da: "Kasakhstan",
        de: "Kasachstan",
        el: "Καζακστάν",
        en: "Kazakhstan",
        eo: "Kazaĥio",
        es: "Kazajist\xe1n",
        et: "Kasahstan",
        eu: "Kazakhstan",
        fi: "Kazakstan",
        fr: "Kazakhstan",
        hu: "Kazahszt\xe1n",
        hy: "Ղազախստան",
        it: "Kazakistan",
        ja: "カザフスタン",
        ko: "카자흐스탄",
        lt: "Kazachstanas",
        nl: "Kazachstan",
        no: "Kasakhstan",
        pl: "Kazachstan",
        pt: "Cazaquist\xe3o",
        ro: "Kazahstan",
        ru: "Казахстан",
        sk: "Kazachstan",
        sv: "Kazakstan",
        th: "คาซัคสถาน",
        uk: "Казахстан",
        zh: "哈萨克斯坦",
        "zh-tw": "哈薩克"
    },
    {
        id: "ke",
        ar: "كينيا",
        bg: "Кения",
        cs: "Keňa",
        da: "Kenya",
        de: "Kenia",
        el: "Κένυα",
        en: "Kenya",
        eo: "Kenjo",
        es: "Kenia",
        et: "Keenia",
        eu: "Kenya",
        fi: "Kenia",
        fr: "Kenya",
        hu: "Kenya",
        hy: "Քենիա",
        it: "Kenya",
        ja: "ケニア",
        ko: "케냐",
        lt: "Kenija",
        nl: "Kenia",
        no: "Kenya",
        pl: "Kenia",
        pt: "Qu\xeania",
        ro: "Kenya",
        ru: "Кения",
        sk: "Keňa",
        sv: "Kenya",
        th: "เคนยา",
        uk: "Кенія",
        zh: "肯尼亚",
        "zh-tw": "肯亞"
    },
    {
        id: "ki",
        ar: "كيريباتي",
        bg: "Кирибати",
        cs: "Kiribati",
        da: "Kiribati",
        de: "Kiribati",
        el: "Κιριμπάτι",
        en: "Kiribati",
        eo: "Kiribato",
        es: "Kiribati",
        et: "Kiribati",
        eu: "Kiribati",
        fi: "Kiribati",
        fr: "Kiribati",
        hu: "Kiribati",
        hy: "Կիրիբատի",
        it: "Kiribati",
        ja: "キリバス",
        ko: "키리바시",
        lt: "Kiribatis",
        nl: "Kiribati",
        no: "Kiribati",
        pl: "Kiribati",
        pt: "Quirib\xe1ti",
        ro: "Kiribati",
        ru: "Кирибати",
        sk: "Kiribati",
        sv: "Kiribati",
        th: "คิริบาส",
        uk: "Кірибаті",
        zh: "基里巴斯",
        "zh-tw": "吉里巴斯"
    },
    {
        id: "kp",
        ar: "كوريا الشمالية",
        bg: "Северна Корея",
        cs: "Severn\xed Korea",
        da: "Nordkorea",
        de: "Korea, Nord (Nordkorea)",
        el: "Βόρεια Κορέα",
        en: "Korea (Democratic People's Republic of)",
        eo: "Nord-Koreio",
        es: "Corea del Norte",
        et: "P\xf5hja-Korea",
        eu: "Ipar Korea",
        fi: "Korean demokraattinen kansantasavalta",
        fr: "Cor\xe9e du Nord",
        hu: "\xc9szak-Korea (Koreai NDK)",
        hy: "Հյուսիսային Կորեա",
        it: "Corea del Nord",
        ja: "朝鮮民主主義人民共和国",
        ko: "조선민주주의인민공화국",
        lt: "Šiaurės Korėja",
        nl: "Noord-Korea",
        no: "Nord-Korea",
        pl: "Korea P\xf3łnocna",
        pt: "Coreia do Norte",
        ro: "Coreea de Nord",
        ru: "КНДР (Корейская Народно-Демократическая Республика)",
        sk: "K\xf3rejsk\xe1 ľudovodemokratick\xe1 republika",
        sv: "Nordkorea",
        th: "เกาหลีเหนือ",
        uk: "Північна Корея",
        zh: "朝鲜",
        "zh-tw": "北韓"
    },
    {
        id: "kr",
        ar: "كوريا الجنوبية",
        bg: "Южна Корея",
        cs: "Jižn\xed Korea",
        da: "Sydkorea",
        de: "Korea, S\xfcd (S\xfcdkorea)",
        el: "Νότια Κορέα",
        en: "Korea, Republic of",
        eo: "Sud-Koreio",
        es: "Corea del Sur",
        et: "L\xf5una-Korea",
        eu: "Hego Korea",
        fi: "Korean tasavalta",
        fr: "Cor\xe9e du Sud",
        hu: "D\xe9l-Korea (Koreai K\xf6zt\xe1rsas\xe1g)",
        hy: "Հարավային Կորեա",
        it: "Corea del Sud",
        ja: "大韓民国",
        ko: "대한민국",
        lt: "Pietų Korėja",
        nl: "Zuid-Korea",
        no: "S\xf8r-Korea",
        pl: "Korea Południowa",
        pt: "Coreia do Sul",
        ro: "Coreea de Sud",
        ru: "Республика Корея",
        sk: "K\xf3rejsk\xe1 republika",
        sv: "Sydkorea",
        th: "เกาหลีใต้",
        uk: "Південна Корея",
        zh: "韩国",
        "zh-tw": "南韓"
    },
    {
        id: "kw",
        ar: "الكويت",
        bg: "Кувейт",
        cs: "Kuvajt",
        da: "Kuwait",
        de: "Kuwait",
        el: "Κουβέιτ",
        en: "Kuwait",
        eo: "Kuvajto",
        es: "Kuwait",
        et: "Kuveit",
        eu: "Kuwait",
        fi: "Kuwait",
        fr: "Kowe\xeft",
        hu: "Kuvait",
        hy: "Քուվեյթ",
        it: "Kuwait",
        ja: "クウェート",
        ko: "쿠웨이트",
        lt: "Kuveitas",
        nl: "Koeweit",
        no: "Kuwait",
        pl: "Kuwejt",
        pt: "Kuwait",
        ro: "Kuweit",
        ru: "Кувейт",
        sk: "Kuvajt",
        sv: "Kuwait",
        th: "คูเวต",
        uk: "Кувейт",
        zh: "科威特",
        "zh-tw": "科威特"
    },
    {
        id: "kg",
        ar: "قيرغيزستان",
        bg: "Киргизстан",
        cs: "Kyrgyzst\xe1n",
        da: "Kirgisistan",
        de: "Kirgisistan",
        el: "Κιργιζία",
        en: "Kyrgyzstan",
        eo: "Kirgizio",
        es: "Kirguist\xe1n",
        et: "K\xf5rg\xf5zstan",
        eu: "Kirgizistan",
        fi: "Kirgisia",
        fr: "Kirghizistan",
        hu: "Kirgiziszt\xe1n",
        hy: "Ղրղզստան",
        it: "Kirghizistan",
        ja: "キルギス",
        ko: "키르기스스탄",
        lt: "Kirgizija",
        nl: "Kirgizi\xeb",
        no: "Kirgisistan",
        pl: "Kirgistan",
        pt: "Quirguist\xe3o",
        ro: "K\xe2rg\xe2zstan",
        ru: "Киргизия",
        sk: "Kirgizsko",
        sv: "Kirgizistan",
        th: "คีร์กีซสถาน",
        uk: "Киргизстан",
        zh: "吉尔吉斯斯坦",
        "zh-tw": "吉爾吉斯"
    },
    {
        id: "la",
        ar: "لاوس",
        bg: "Лаос",
        cs: "Laos",
        da: "Laos",
        de: "Laos",
        el: "Λάος",
        en: "Lao People's Democratic Republic",
        eo: "Laoso",
        es: "Laos",
        et: "Laos",
        eu: "Laos",
        fi: "Laos",
        fr: "Laos",
        hu: "Laosz",
        hy: "Լաոս",
        it: "Laos",
        ja: "ラオス人民民主共和国",
        ko: "라오스",
        lt: "Laosas",
        nl: "Laos",
        no: "Laos",
        pl: "Laos",
        pt: "Laos",
        ro: "Laos",
        ru: "Лаос",
        sk: "Laos",
        sv: "Laos",
        th: "ลาว",
        uk: "Лаос",
        zh: "老挝",
        "zh-tw": "寮國"
    },
    {
        id: "lv",
        ar: "لاتفيا",
        bg: "Латвия",
        cs: "Lotyšsko",
        da: "Letland",
        de: "Lettland",
        el: "Λεττονία",
        en: "Latvia",
        eo: "Latvio",
        es: "Letonia",
        et: "L\xe4ti",
        eu: "Letonia",
        fi: "Latvia",
        fr: "Lettonie",
        hu: "Lettorsz\xe1g",
        hy: "Լատվիա",
        it: "Lettonia",
        ja: "ラトビア",
        ko: "라트비아",
        lt: "Latvija",
        nl: "Letland",
        no: "Latvia",
        pl: "Łotwa",
        pt: "Let\xf4nia",
        ro: "Letonia",
        ru: "Латвия",
        sk: "Lotyšsko",
        sv: "Lettland",
        th: "ลัตเวีย",
        uk: "Латвія",
        zh: "拉脱维亚",
        "zh-tw": "拉脫維亞"
    },
    {
        id: "lb",
        ar: "لبنان",
        bg: "Ливан",
        cs: "Libanon",
        da: "Libanon",
        de: "Libanon",
        el: "Λίβανος",
        en: "Lebanon",
        eo: "Libano",
        es: "L\xedbano",
        et: "Liibanon",
        eu: "Libano",
        fi: "Libanon",
        fr: "Liban",
        hu: "Libanon",
        hy: "Լիբանան",
        it: "Libano",
        ja: "レバノン",
        ko: "레바논",
        lt: "Libanas",
        nl: "Libanon",
        no: "Libanon",
        pl: "Liban",
        pt: "L\xedbano",
        ro: "Liban",
        ru: "Ливан",
        sk: "Libanon",
        sv: "Libanon",
        th: "เลบานอน",
        uk: "Ліван",
        zh: "黎巴嫩",
        "zh-tw": "黎巴嫩"
    },
    {
        id: "ls",
        ar: "ليسوتو",
        bg: "Лесото",
        cs: "Lesotho",
        da: "Lesotho",
        de: "Lesotho",
        el: "Λεσότο",
        en: "Lesotho",
        eo: "Lesoto",
        es: "Lesoto",
        et: "Lesotho",
        eu: "Lesotho",
        fi: "Lesotho",
        fr: "Lesotho",
        hu: "Lesotho",
        hy: "Լեսոթո",
        it: "Lesotho",
        ja: "レソト",
        ko: "레소토",
        lt: "Lesotas",
        nl: "Lesotho",
        no: "Lesotho",
        pl: "Lesotho",
        pt: "Lesoto",
        ro: "Lesotho",
        ru: "Лесото",
        sk: "Lesotho",
        sv: "Lesotho",
        th: "เลโซโท",
        uk: "Лесото",
        zh: "莱索托",
        "zh-tw": "賴索托"
    },
    {
        id: "lr",
        ar: "ليبيريا",
        bg: "Либерия",
        cs: "Lib\xe9rie",
        da: "Liberia",
        de: "Liberia",
        el: "Λιβερία",
        en: "Liberia",
        eo: "Liberio",
        es: "Liberia",
        et: "Libeeria",
        eu: "Liberia",
        fi: "Liberia",
        fr: "Liberia",
        hu: "Lib\xe9ria",
        hy: "Լիբերիա",
        it: "Liberia",
        ja: "リベリア",
        ko: "라이베리아",
        lt: "Liberija",
        nl: "Liberia",
        no: "Liberia",
        pl: "Liberia",
        pt: "Lib\xe9ria",
        ro: "Liberia",
        ru: "Либерия",
        sk: "Lib\xe9ria",
        sv: "Liberia",
        th: "ไลบีเรีย",
        uk: "Ліберія",
        zh: "利比里亚",
        "zh-tw": "賴比瑞亞"
    },
    {
        id: "ly",
        ar: "ليبيا",
        bg: "Либия",
        cs: "Libye",
        da: "Libyen",
        de: "Libyen",
        el: "Λιβύη",
        en: "Libya",
        eo: "Libio",
        es: "Libia",
        et: "Liib\xfca",
        eu: "Libia",
        fi: "Libya",
        fr: "Libye",
        hu: "L\xedbia",
        hy: "Լիբիա",
        it: "Libia",
        ja: "リビア",
        ko: "리비아",
        lt: "Libija",
        nl: "Libi\xeb",
        no: "Libya",
        pl: "Libia",
        pt: "L\xedbia",
        ro: "Libia",
        ru: "Ливия",
        sk: "L\xedbya",
        sv: "Libyen",
        th: "ลิเบีย",
        uk: "Лівія",
        zh: "利比亚",
        "zh-tw": "利比亞"
    },
    {
        id: "li",
        ar: "ليختنشتاين",
        bg: "Лихтенщайн",
        cs: "Lichtenštejnsko",
        da: "Liechtenstein",
        de: "Liechtenstein",
        el: "Λίχτενσταϊν",
        en: "Liechtenstein",
        eo: "Liĥtenŝtejno",
        es: "Liechtenstein",
        et: "Liechtenstein",
        eu: "Liechtenstein",
        fi: "Liechtenstein",
        fr: "Liechtenstein",
        hu: "Liechtenstein",
        hy: "Լիխտենշտայն",
        it: "Liechtenstein",
        ja: "リヒテンシュタイン",
        ko: "리히텐슈타인",
        lt: "Lichtenšteinas",
        nl: "Liechtenstein",
        no: "Liechtenstein",
        pl: "Liechtenstein",
        pt: "Listenstaine",
        ro: "Liechtenstein",
        ru: "Лихтенштейн",
        sk: "Lichtenštajnsko",
        sv: "Liechtenstein",
        th: "ลีชเทินชไตน์",
        uk: "Ліхтенштейн",
        zh: "列支敦士登",
        "zh-tw": "列支敦斯登"
    },
    {
        id: "lt",
        ar: "ليتوانيا",
        bg: "Литва",
        cs: "Litva",
        da: "Litauen",
        de: "Litauen",
        el: "Λιθουανία",
        en: "Lithuania",
        eo: "Litovio",
        es: "Lituania",
        et: "Leedu",
        eu: "Lituania",
        fi: "Liettua",
        fr: "Lituanie",
        hu: "Litv\xe1nia",
        hy: "Լիտվա",
        it: "Lituania",
        ja: "リトアニア",
        ko: "리투아니아",
        lt: "Lietuva",
        nl: "Litouwen",
        no: "Litauen",
        pl: "Litwa",
        pt: "Litu\xe2nia",
        ro: "Lituania",
        ru: "Литва",
        sk: "Litva",
        sv: "Litauen",
        th: "ลิทัวเนีย",
        uk: "Литва",
        zh: "立陶宛",
        "zh-tw": "立陶宛"
    },
    {
        id: "lu",
        ar: "لوكسمبورغ",
        bg: "Люксембург",
        cs: "Lucembursko",
        da: "Luxembourg",
        de: "Luxemburg",
        el: "Λουξεμβούργο",
        en: "Luxembourg",
        eo: "Luksemburgo",
        es: "Luxemburgo",
        et: "Luksemburg",
        eu: "Luxenburgo",
        fi: "Luxemburg",
        fr: "Luxembourg",
        hu: "Luxemburg",
        hy: "Լյուքսեմբուրգ",
        it: "Lussemburgo",
        ja: "ルクセンブルク",
        ko: "룩셈부르크",
        lt: "Liuksemburgas",
        nl: "Luxemburg",
        no: "Luxembourg",
        pl: "Luksemburg",
        pt: "Luxemburgo",
        ro: "Luxemburg",
        ru: "Люксембург",
        sk: "Luxembursko",
        sv: "Luxemburg",
        th: "ลักเซมเบิร์ก",
        uk: "Люксембург",
        zh: "卢森堡",
        "zh-tw": "盧森堡"
    },
    {
        id: "mk",
        ar: "مقدونيا",
        bg: "Северна Македония",
        cs: "Severn\xed Makedonie",
        da: "Nordmakedonien",
        de: "Nordmazedonien",
        el: "Βόρεια Μακεδονία",
        en: "North Macedonia",
        eo: "Nord-Makedonio",
        es: "Macedonia del Norte",
        et: "P\xf5hja-Makedoonia",
        eu: "Ipar Mazedonia",
        fi: "Pohjois-Makedonia",
        fr: "Mac\xe9doine du Nord",
        hu: "\xc9szak-Maced\xf3nia",
        hy: "Հյուսիսային Մակեդոնիա",
        it: "Macedonia del Nord",
        ja: "北マケドニア",
        ko: "북마케도니아",
        lt: "Makedonija",
        nl: "Noord-Macedoni\xeb",
        no: "Nord-Makedonia, Republikken",
        pl: "Macedonia P\xf3łnocna",
        pt: "Maced\xf4nia do Norte",
        ro: "Republica Macedonia",
        ru: "Северная Македония",
        sk: "Severn\xe9 Maced\xf3nsko",
        sv: "Nordmakedonien",
        th: "นอร์ทมาซิโดเนีย",
        uk: "Північна Македонія",
        zh: "北马其顿",
        "zh-tw": "北馬其頓"
    },
    {
        id: "mg",
        ar: "مدغشقر",
        bg: "Мадагаскар",
        cs: "Madagaskar",
        da: "Madagaskar",
        de: "Madagaskar",
        el: "Μαδαγασκάρη",
        en: "Madagascar",
        eo: "Madagaskaro",
        es: "Madagascar",
        et: "Madagaskar",
        eu: "Madagaskar",
        fi: "Madagaskar",
        fr: "Madagascar",
        hu: "Madagaszk\xe1r",
        hy: "Մադագասկար",
        it: "Madagascar",
        ja: "マダガスカル",
        ko: "마다가스카르",
        lt: "Madagaskaras",
        nl: "Madagaskar",
        no: "Madagaskar",
        pl: "Madagaskar",
        pt: "Madag\xe1scar",
        ro: "Madagascar",
        ru: "Мадагаскар",
        sk: "Madagaskar",
        sv: "Madagaskar",
        th: "มาดากัสการ์",
        uk: "Мадагаскар",
        zh: "马达加斯加",
        "zh-tw": "馬達加斯加"
    },
    {
        id: "mw",
        ar: "مالاوي",
        bg: "Малави",
        cs: "Malawi",
        da: "Malawi",
        de: "Malawi",
        el: "Μαλάουι",
        en: "Malawi",
        eo: "Malavio",
        es: "Malaui",
        et: "Malawi",
        eu: "Malawi",
        fi: "Malawi",
        fr: "Malawi",
        hu: "Malawi",
        hy: "Մալավի",
        it: "Malawi",
        ja: "マラウイ",
        ko: "말라위",
        lt: "Malavis",
        nl: "Malawi",
        no: "Malawi",
        pl: "Malawi",
        pt: "Mal\xe1ui",
        ro: "Malawi",
        ru: "Малави",
        sk: "Malawi",
        sv: "Malawi",
        th: "มาลาวี",
        uk: "Малаві",
        zh: "马拉维",
        "zh-tw": "馬拉威"
    },
    {
        id: "my",
        ar: "ماليزيا",
        bg: "Малайзия",
        cs: "Malajsie",
        da: "Malaysia",
        de: "Malaysia",
        el: "Μαλαισία",
        en: "Malaysia",
        eo: "Malajzio",
        es: "Malasia",
        et: "Malaisia",
        eu: "Malaysia",
        fi: "Malesia",
        fr: "Malaisie",
        hu: "Malajzia",
        hy: "Մալայզիա",
        it: "Malaysia",
        ja: "マレーシア",
        ko: "말레이시아",
        lt: "Malaizija",
        nl: "Maleisi\xeb",
        no: "Malaysia",
        pl: "Malezja",
        pt: "Mal\xe1sia",
        ro: "Malaezia",
        ru: "Малайзия",
        sk: "Malajzia",
        sv: "Malaysia",
        th: "มาเลเซีย",
        uk: "Малайзія",
        zh: "马来西亚",
        "zh-tw": "馬來西亞"
    },
    {
        id: "mv",
        ar: "جزر المالديف",
        bg: "Малдиви",
        cs: "Maledivy",
        da: "Maldiverne",
        de: "Malediven",
        el: "Μαλδίβες",
        en: "Maldives",
        eo: "Maldivoj",
        es: "Maldivas",
        et: "Maldiivid",
        eu: "Maldivak",
        fi: "Malediivit",
        fr: "Maldives",
        hu: "Mald\xedv-szigetek",
        hy: "Մալդիվներ",
        it: "Maldive",
        ja: "モルディブ",
        ko: "몰디브",
        lt: "Maldyvai",
        nl: "Malediven",
        no: "Maldivene",
        pl: "Malediwy",
        pt: "Maldivas",
        ro: "Maldive",
        ru: "Мальдивы",
        sk: "Maldivy",
        sv: "Maldiverna",
        th: "มัลดีฟส์",
        uk: "Мальдіви",
        zh: "马尔代夫",
        "zh-tw": "馬爾地夫"
    },
    {
        id: "ml",
        ar: "مالي",
        bg: "Мали",
        cs: "Mali",
        da: "Mali",
        de: "Mali",
        el: "Μάλι",
        en: "Mali",
        eo: "Malio",
        es: "Mal\xed",
        et: "Mali",
        eu: "Mali",
        fi: "Mali",
        fr: "Mali",
        hu: "Mali",
        hy: "Մալի",
        it: "Mali",
        ja: "マリ",
        ko: "말리",
        lt: "Malis",
        nl: "Mali",
        no: "Mali",
        pl: "Mali",
        pt: "Mali",
        ro: "Mali",
        ru: "Мали",
        sk: "Mali",
        sv: "Mali",
        th: "มาลี",
        uk: "Малі",
        zh: "马里",
        "zh-tw": "馬利"
    },
    {
        id: "mt",
        ar: "مالطا",
        bg: "Малта",
        cs: "Malta",
        da: "Malta",
        de: "Malta",
        el: "Μάλτα",
        en: "Malta",
        eo: "Malto",
        es: "Malta",
        et: "Malta",
        eu: "Malta",
        fi: "Malta",
        fr: "Malte",
        hu: "M\xe1lta",
        hy: "Մալթա",
        it: "Malta",
        ja: "マルタ",
        ko: "몰타",
        lt: "Malta",
        nl: "Malta",
        no: "Malta",
        pl: "Malta",
        pt: "Malta",
        ro: "Malta",
        ru: "Мальта",
        sk: "Malta",
        sv: "Malta",
        th: "มอลตา",
        uk: "Мальта",
        zh: "马耳他",
        "zh-tw": "馬爾他"
    },
    {
        id: "mh",
        ar: "جزر مارشال",
        bg: "Маршалови острови",
        cs: "Marshallovy ostrovy",
        da: "Marshall\xf8erne",
        de: "Marshallinseln",
        el: "Νήσοι Μάρσαλ",
        en: "Marshall Islands",
        eo: "Marŝala Insularo",
        es: "Islas Marshall",
        et: "Marshalli Saared",
        eu: "Marshall Uharteak",
        fi: "Marshallinsaaret",
        fr: "\xceles Marshall",
        hu: "Marshall-szigetek",
        hy: "Մարշալյան կղզիներ",
        it: "Isole Marshall",
        ja: "マーシャル諸島",
        ko: "마셜 제도",
        lt: "Maršalo salos",
        nl: "Marshalleilanden",
        no: "Marshall\xf8yene",
        pl: "Wyspy Marshalla",
        pt: "Ilhas Marshall",
        ro: "Insulele Marshall",
        ru: "Маршалловы Острова",
        sk: "Marshallove ostrovy",
        sv: "Marshall\xf6arna",
        th: "หมู่เกาะมาร์แชลล์",
        uk: "Маршаллові Острови",
        zh: "马绍尔群岛",
        "zh-tw": "馬紹爾群島"
    },
    {
        id: "mr",
        ar: "موريتانيا",
        bg: "Мавритания",
        cs: "Maurit\xe1nie",
        da: "Mauretanien",
        de: "Mauretanien",
        el: "Μαυριτανία",
        en: "Mauritania",
        eo: "Maŭritanio",
        es: "Mauritania",
        et: "Mauritaania",
        eu: "Mauritania",
        fi: "Mauritania",
        fr: "Mauritanie",
        hu: "Maurit\xe1nia",
        hy: "Մավրիտանիա",
        it: "Mauritania",
        ja: "モーリタニア",
        ko: "모리타니",
        lt: "Mauritanija",
        nl: "Mauritani\xeb",
        no: "Mauritania",
        pl: "Mauretania",
        pt: "Maurit\xe2nia",
        ro: "Mauritania",
        ru: "Мавритания",
        sk: "Maurit\xe1nia",
        sv: "Mauretanien",
        th: "มอริเตเนีย",
        uk: "Мавританія",
        zh: "毛里塔尼亚",
        "zh-tw": "茅利塔尼亞"
    },
    {
        id: "mu",
        ar: "موريشيوس",
        bg: "Мавриций",
        cs: "Mauricius",
        da: "Mauritius",
        de: "Mauritius",
        el: "Μαυρίκιος",
        en: "Mauritius",
        eo: "Maŭricio",
        es: "Mauricio",
        et: "Mauritius",
        eu: "Maurizio",
        fi: "Mauritius",
        fr: "Maurice",
        hu: "Mauritius",
        hy: "Մավրիկիոս",
        it: "Mauritius",
        ja: "モーリシャス",
        ko: "모리셔스",
        lt: "Mauricijus",
        nl: "Mauritius",
        no: "Mauritius",
        pl: "Mauritius",
        pt: "Ilhas Maur\xedcias",
        ro: "Mauritius",
        ru: "Маврикий",
        sk: "Maur\xedcius",
        sv: "Mauritius",
        th: "มอริเชียส",
        uk: "Маврикій",
        zh: "毛里求斯",
        "zh-tw": "模里西斯"
    },
    {
        id: "mx",
        ar: "المكسيك",
        bg: "Мексико",
        cs: "Mexiko",
        da: "Mexico",
        de: "Mexiko",
        el: "Μεξικό",
        en: "Mexico",
        eo: "Meksiko",
        es: "M\xe9xico",
        et: "Mehhiko",
        eu: "Mexiko",
        fi: "Meksiko",
        fr: "Mexique",
        hu: "Mexik\xf3",
        hy: "Մեքսիկա",
        it: "Messico",
        ja: "メキシコ",
        ko: "멕시코",
        lt: "Meksika",
        nl: "Mexico",
        no: "Mexico",
        pl: "Meksyk",
        pt: "M\xe9xico",
        ro: "Mexic",
        ru: "Мексика",
        sk: "Mexiko",
        sv: "Mexiko",
        th: "เม็กซิโก",
        uk: "Мексика",
        zh: "墨西哥",
        "zh-tw": "墨西哥"
    },
    {
        id: "fm",
        ar: "ولايات ميكرونيسيا المتحدة",
        bg: "Микронезия",
        cs: "Mikron\xe9sie",
        da: "Mikronesien",
        de: "Mikronesien",
        el: "Ομόσπονδες Πολιτείες της Μικρονησίας",
        en: "Micronesia (Federated States of)",
        eo: "Federacio de Mikronezio",
        es: "Micronesia",
        et: "Mikroneesia Liiduriigid",
        eu: "Mikronesiako Estatu Federatuak",
        fi: "Mikronesian liittovaltio",
        fr: "\xc9tats f\xe9d\xe9r\xe9s de Micron\xe9sie",
        hu: "Mikron\xe9zia",
        hy: "Միկրոնեզիա",
        it: "Micronesia",
        ja: "ミクロネシア連邦",
        ko: "미크로네시아 연방",
        lt: "Mikronezija",
        nl: "Micronesi\xeb",
        no: "Mikronesiaf\xf8derasjonen",
        pl: "Mikronezja",
        pt: "Estados Federados da Micron\xe9sia",
        ro: "Micronezia",
        ru: "Микронезия",
        sk: "Mikron\xe9zia",
        sv: "Mikronesiska federationen",
        th: "ไมโครนีเชีย",
        uk: "Федеративні Штати Мікронезії",
        zh: "密克罗尼西亚联邦",
        "zh-tw": "密克羅尼西亞聯邦"
    },
    {
        id: "ma",
        ar: "المغرب",
        bg: "Мароко",
        cs: "Maroko",
        da: "Marokko",
        de: "Marokko",
        el: "Μαρόκο",
        en: "Morocco",
        eo: "Maroko",
        es: "Marruecos",
        et: "Maroko",
        eu: "Maroko",
        fi: "Marokko",
        fr: "Maroc",
        hu: "Marokk\xf3",
        hy: "Մարոկկո",
        it: "Marocco",
        ja: "モロッコ",
        ko: "모로코",
        lt: "Marokas",
        nl: "Marokko",
        no: "Marokko",
        pl: "Maroko",
        pt: "Marrocos",
        ro: "Maroc",
        ru: "Марокко",
        sk: "Maroko",
        sv: "Marocko",
        th: "โมร็อกโก",
        uk: "Марокко",
        zh: "摩洛哥",
        "zh-tw": "摩洛哥"
    },
    {
        id: "md",
        ar: "مولدوفا",
        bg: "Молдова",
        cs: "Moldavsko",
        da: "Moldova",
        de: "Moldau",
        el: "Μολδαβία",
        en: "Moldova, Republic of",
        eo: "Moldavio",
        es: "Moldavia",
        et: "Moldova",
        eu: "Moldavia",
        fi: "Moldova",
        fr: "Moldavie",
        hu: "Moldova",
        hy: "Մոլդովա",
        it: "Moldavia",
        ja: "モルドバ共和国",
        ko: "몰도바",
        lt: "Moldavija",
        nl: "Moldavi\xeb",
        no: "Moldova",
        pl: "Mołdawia",
        pt: "Mold\xe1via",
        ro: "Republica Moldova",
        ru: "Молдавия",
        sk: "Moldavsko",
        sv: "Moldavien",
        th: "มอลโดวา",
        uk: "Молдова",
        zh: "摩尔多瓦",
        "zh-tw": "摩爾多瓦"
    },
    {
        id: "mc",
        ar: "موناكو",
        bg: "Монако",
        cs: "Monako",
        da: "Monaco",
        de: "Monaco",
        el: "Μονακό",
        en: "Monaco",
        eo: "Monako",
        es: "M\xf3naco",
        et: "Monaco",
        eu: "Monako",
        fi: "Monaco",
        fr: "Monaco",
        hu: "Monaco",
        hy: "Մոնակո",
        it: "Monaco",
        ja: "モナコ",
        ko: "모나코",
        lt: "Monakas",
        nl: "Monaco",
        no: "Monaco",
        pl: "Monako",
        pt: "M\xf3naco",
        ro: "Monaco",
        ru: "Монако",
        sk: "Monako",
        sv: "Monaco",
        th: "โมนาโก",
        uk: "Монако",
        zh: "摩纳哥",
        "zh-tw": "摩納哥"
    },
    {
        id: "mn",
        ar: "منغوليا",
        bg: "Монголия",
        cs: "Mongolsko",
        da: "Mongoliet",
        de: "Mongolei",
        el: "Μογγολία",
        en: "Mongolia",
        eo: "Mongolio",
        es: "Mongolia",
        et: "Mongoolia",
        eu: "Mongolia",
        fi: "Mongolia",
        fr: "Mongolie",
        hu: "Mong\xf3lia",
        hy: "Մոնղոլիա",
        it: "Mongolia",
        ja: "モンゴル",
        ko: "몽골",
        lt: "Mongolija",
        nl: "Mongoli\xeb",
        no: "Mongolia",
        pl: "Mongolia",
        pt: "Mong\xf3lia",
        ro: "Mongolia",
        ru: "Монголия",
        sk: "Mongolsko",
        sv: "Mongoliet",
        th: "มองโกเลีย",
        uk: "Монголія",
        zh: "蒙古",
        "zh-tw": "蒙古"
    },
    {
        id: "me",
        ar: "الجبل الأسود",
        bg: "Черна гора",
        cs: "Čern\xe1 Hora",
        da: "Montenegro",
        de: "Montenegro",
        el: "Μαυροβούνιο",
        en: "Montenegro",
        eo: "Montenegro",
        es: "Montenegro",
        et: "Montenegro",
        eu: "Montenegro",
        fi: "Montenegro",
        fr: "Mont\xe9n\xe9gro",
        hu: "Montenegr\xf3",
        hy: "Չեռնոգորիա",
        it: "Montenegro",
        ja: "モンテネグロ",
        ko: "몬테네그로",
        lt: "Juodkalnija",
        nl: "Montenegro",
        no: "Montenegro",
        pl: "Czarnog\xf3ra",
        pt: "Montenegro",
        ro: "Muntenegru",
        ru: "Черногория",
        sk: "Čierna Hora",
        sv: "Montenegro",
        th: "มอนเตเนโกร",
        uk: "Чорногорія",
        zh: "黑山",
        "zh-tw": "蒙特內哥羅"
    },
    {
        id: "mz",
        ar: "موزمبيق",
        bg: "Мозамбик",
        cs: "Mosambik",
        da: "Mozambique",
        de: "Mosambik",
        el: "Μοζαμβίκη",
        en: "Mozambique",
        eo: "Mozambiko",
        es: "Mozambique",
        et: "Mosambiik",
        eu: "Mozambike",
        fi: "Mosambik",
        fr: "Mozambique",
        hu: "Mozambik",
        hy: "Մոզամբիկ",
        it: "Mozambico",
        ja: "モザンビーク",
        ko: "모잠비크",
        lt: "Mozambikas",
        nl: "Mozambique",
        no: "Mosambik",
        pl: "Mozambik",
        pt: "Mo\xe7ambique",
        ro: "Mozambic",
        ru: "Мозамбик",
        sk: "Mozambik",
        sv: "Mo\xe7ambique",
        th: "โมซัมบิก",
        uk: "Мозамбік",
        zh: "莫桑比克",
        "zh-tw": "莫三比克"
    },
    {
        id: "mm",
        ar: "ميانمار",
        bg: "Мианмар",
        cs: "Myanmar",
        da: "Burma",
        de: "Myanmar",
        el: "Μιανμάρ",
        en: "Myanmar",
        eo: "Birmo",
        es: "Birmania",
        et: "Birma",
        eu: "Myanmar",
        fi: "Myanmar",
        fr: "Birmanie",
        hu: "Mianmar",
        hy: "Մյանմա",
        it: "Birmania",
        ja: "ミャンマー",
        ko: "미얀마",
        lt: "Mianmaras",
        nl: "Myanmar",
        no: "Myanmar",
        pl: "Mjanma",
        pt: "Mianmar",
        ro: "Myanmar",
        ru: "Мьянма",
        sk: "Mjanmarsko",
        sv: "Myanmar",
        th: "พม่า",
        uk: "М'янма",
        zh: "缅甸",
        "zh-tw": "緬甸"
    },
    {
        id: "na",
        ar: "ناميبيا",
        bg: "Намибия",
        cs: "Namibie",
        da: "Namibia",
        de: "Namibia",
        el: "Ναμίμπια",
        en: "Namibia",
        eo: "Namibio",
        es: "Namibia",
        et: "Namiibia",
        eu: "Namibia",
        fi: "Namibia",
        fr: "Namibie",
        hu: "Nam\xedbia",
        hy: "Նամիբիա",
        it: "Namibia",
        ja: "ナミビア",
        ko: "나미비아",
        lt: "Namibija",
        nl: "Namibi\xeb",
        no: "Namibia",
        pl: "Namibia",
        pt: "Nam\xedbia",
        ro: "Namibia",
        ru: "Намибия",
        sk: "Nam\xedbia",
        sv: "Namibia",
        th: "นามิเบีย",
        uk: "Намібія",
        zh: "纳米比亚",
        "zh-tw": "納米比亞"
    },
    {
        id: "nr",
        ar: "ناورو",
        bg: "Науру",
        cs: "Nauru",
        da: "Nauru",
        de: "Nauru",
        el: "Ναουρού",
        en: "Nauru",
        eo: "Nauro",
        es: "Nauru",
        et: "Nauru",
        eu: "Nauru",
        fi: "Nauru",
        fr: "Nauru",
        hu: "Nauru",
        hy: "Նաուրու",
        it: "Nauru",
        ja: "ナウル",
        ko: "나우루",
        lt: "Nauru",
        nl: "Nauru",
        no: "Nauru",
        pl: "Nauru",
        pt: "Nauru",
        ro: "Nauru",
        ru: "Науру",
        sk: "Nauru",
        sv: "Nauru",
        th: "นาอูรู",
        uk: "Науру",
        zh: "瑙鲁",
        "zh-tw": "諾魯"
    },
    {
        id: "np",
        ar: "نيبال",
        bg: "Непал",
        cs: "Nep\xe1l",
        da: "Nepal",
        de: "Nepal",
        el: "Νεπάλ",
        en: "Nepal",
        eo: "Nepalo",
        es: "Nepal",
        et: "Nepal",
        eu: "Nepal",
        fi: "Nepal",
        fr: "N\xe9pal",
        hu: "Nep\xe1l",
        hy: "Նեպալ",
        it: "Nepal",
        ja: "ネパール",
        ko: "네팔",
        lt: "Nepalas",
        nl: "Nepal",
        no: "Nepal",
        pl: "Nepal",
        pt: "Nepal",
        ro: "Nepal",
        ru: "Непал",
        sk: "Nep\xe1l",
        sv: "Nepal",
        th: "เนปาล",
        uk: "Непал",
        zh: "尼泊尔",
        "zh-tw": "尼泊爾"
    },
    {
        id: "nl",
        ar: "هولندا",
        bg: "Нидерландия",
        cs: "Nizozemsko",
        da: "Holland",
        de: "Niederlande",
        el: "Ολλανδία (Κάτω Χώρες)",
        en: "Netherlands",
        eo: "Nederlando",
        es: "Pa\xedses Bajos",
        et: "Holland",
        eu: "Herbehereak",
        fi: "Alankomaat",
        fr: "Pays-Bas",
        hu: "Hollandia",
        hy: "Նիդերլանդներ",
        it: "Paesi Bassi",
        ja: "オランダ",
        ko: "네덜란드",
        lt: "Nyderlandai",
        nl: "Nederland",
        no: "Nederland",
        pl: "Holandia",
        pt: "Pa\xedses Baixos",
        ro: "Țările de Jos",
        ru: "Нидерланды",
        sk: "Holandsko",
        sv: "Nederl\xe4nderna",
        th: "เนเธอร์แลนด์",
        uk: "Нідерланди",
        zh: "荷兰",
        "zh-tw": "荷蘭"
    },
    {
        id: "nz",
        ar: "نيوزيلندا",
        bg: "Нова Зеландия",
        cs: "Nov\xfd Z\xe9land",
        da: "New Zealand",
        de: "Neuseeland",
        el: "Νέα Ζηλανδία",
        en: "New Zealand",
        eo: "Nov-Zelando",
        es: "Nueva Zelanda",
        et: "Uus-Meremaa",
        eu: "Zeelanda Berria",
        fi: "Uusi-Seelanti",
        fr: "Nouvelle-Z\xe9lande",
        hu: "\xdaj-Z\xe9land",
        hy: "Նոր Զելանդիա",
        it: "Nuova Zelanda",
        ja: "ニュージーランド",
        ko: "뉴질랜드",
        lt: "Naujoji Zelandija",
        nl: "Nieuw-Zeeland",
        no: "New Zealand",
        pl: "Nowa Zelandia",
        pt: "Nova Zel\xe2ndia",
        ro: "Noua Zeelandă",
        ru: "Новая Зеландия",
        sk: "Nov\xfd Z\xe9land",
        sv: "Nya Zeeland",
        th: "นิวซีแลนด์",
        uk: "Нова Зеландія",
        zh: "新西兰",
        "zh-tw": "紐西蘭"
    },
    {
        id: "ni",
        ar: "نيكاراغوا",
        bg: "Никарагуа",
        cs: "Nikaragua",
        da: "Nicaragua",
        de: "Nicaragua",
        el: "Νικαράγουα",
        en: "Nicaragua",
        eo: "Nikaragvo",
        es: "Nicaragua",
        et: "Nicaragua",
        eu: "Nikaragua",
        fi: "Nicaragua",
        fr: "Nicaragua",
        hu: "Nicaragua",
        hy: "Նիկարագուա",
        it: "Nicaragua",
        ja: "ニカラグア",
        ko: "니카라과",
        lt: "Nikaragva",
        nl: "Nicaragua",
        no: "Nicaragua",
        pl: "Nikaragua",
        pt: "Nicar\xe1gua",
        ro: "Nicaragua",
        ru: "Никарагуа",
        sk: "Nikaragua",
        sv: "Nicaragua",
        th: "นิการากัว",
        uk: "Нікарагуа",
        zh: "尼加拉瓜",
        "zh-tw": "尼加拉瓜"
    },
    {
        id: "ne",
        ar: "النيجر",
        bg: "Нигер",
        cs: "Niger",
        da: "Niger",
        de: "Niger",
        el: "Νίγηρας",
        en: "Niger",
        eo: "Niĝero",
        es: "N\xedger",
        et: "Niger",
        eu: "Niger",
        fi: "Niger",
        fr: "Niger",
        hu: "Niger",
        hy: "Նիգեր",
        it: "Niger",
        ja: "ニジェール",
        ko: "니제르",
        lt: "Nigeris",
        nl: "Niger",
        no: "Niger",
        pl: "Niger",
        pt: "N\xedger",
        ro: "Niger",
        ru: "Нигер",
        sk: "Niger",
        sv: "Niger",
        th: "ไนเจอร์",
        uk: "Нігер",
        zh: "尼日尔",
        "zh-tw": "尼日"
    },
    {
        id: "ng",
        ar: "نيجيريا",
        bg: "Нигерия",
        cs: "Nig\xe9rie",
        da: "Nigeria",
        de: "Nigeria",
        el: "Νιγηρία",
        en: "Nigeria",
        eo: "Niĝerio",
        es: "Nigeria",
        et: "Nigeeria",
        eu: "Nigeria",
        fi: "Nigeria",
        fr: "Nigeria",
        hu: "Nig\xe9ria",
        hy: "Նիգերիա",
        it: "Nigeria",
        ja: "ナイジェリア",
        ko: "나이지리아",
        lt: "Nigerija",
        nl: "Nigeria",
        no: "Nigeria",
        pl: "Nigeria",
        pt: "Nig\xe9ria",
        ro: "Nigeria",
        ru: "Нигерия",
        sk: "Nig\xe9ria",
        sv: "Nigeria",
        th: "ไนจีเรีย",
        uk: "Нігерія",
        zh: "尼日利亚",
        "zh-tw": "奈及利亞"
    },
    {
        id: "no",
        ar: "النرويج",
        bg: "Норвегия",
        cs: "Norsko",
        da: "Norge",
        de: "Norwegen",
        el: "Νορβηγία",
        en: "Norway",
        eo: "Norvegio",
        es: "Noruega",
        et: "Norra",
        eu: "Norvegia",
        fi: "Norja",
        fr: "Norv\xe8ge",
        hu: "Norv\xe9gia",
        hy: "Նորվեգիա",
        it: "Norvegia",
        ja: "ノルウェー",
        ko: "노르웨이",
        lt: "Norvegija",
        nl: "Noorwegen",
        no: "Norge",
        pl: "Norwegia",
        pt: "Noruega",
        ro: "Norvegia",
        ru: "Норвегия",
        sk: "N\xf3rsko",
        sv: "Norge",
        th: "นอร์เวย์",
        uk: "Норвегія",
        zh: "挪威",
        "zh-tw": "挪威"
    },
    {
        id: "om",
        ar: "عمان",
        bg: "Оман",
        cs: "Om\xe1n",
        da: "Oman",
        de: "Oman",
        el: "Ομάν",
        en: "Oman",
        eo: "Omano",
        es: "Om\xe1n",
        et: "Omaan",
        eu: "Oman",
        fi: "Oman",
        fr: "Oman",
        hu: "Om\xe1n",
        hy: "Օման",
        it: "Oman",
        ja: "オマーン",
        ko: "오만",
        lt: "Omanas",
        nl: "Oman",
        no: "Oman",
        pl: "Oman",
        pt: "Om\xe3",
        ro: "Oman",
        ru: "Оман",
        sk: "Om\xe1n",
        sv: "Oman",
        th: "โอมาน",
        uk: "Оман",
        zh: "阿曼",
        "zh-tw": "阿曼"
    },
    {
        id: "pk",
        ar: "باكستان",
        bg: "Пакистан",
        cs: "P\xe1kist\xe1n",
        da: "Pakistan",
        de: "Pakistan",
        el: "Πακιστάν",
        en: "Pakistan",
        eo: "Pakistano",
        es: "Pakist\xe1n",
        et: "Pakistan",
        eu: "Pakistan",
        fi: "Pakistan",
        fr: "Pakistan",
        hu: "Pakiszt\xe1n",
        hy: "Պակիստան",
        it: "Pakistan",
        ja: "パキスタン",
        ko: "파키스탄",
        lt: "Pakistanas",
        nl: "Pakistan",
        no: "Pakistan",
        pl: "Pakistan",
        pt: "Paquist\xe3o",
        ro: "Pakistan",
        ru: "Пакистан",
        sk: "Pakistan",
        sv: "Pakistan",
        th: "ปากีสถาน",
        uk: "Пакистан",
        zh: "巴基斯坦",
        "zh-tw": "巴基斯坦"
    },
    {
        id: "pw",
        ar: "بالاو",
        bg: "Палау",
        cs: "Palau",
        da: "Palau",
        de: "Palau",
        el: "Παλάου",
        en: "Palau",
        eo: "Palaŭo",
        es: "Palaos",
        et: "Belau",
        eu: "Palau",
        fi: "Palau",
        fr: "Palaos",
        hu: "Palau",
        hy: "Պալաու",
        it: "Palau",
        ja: "パラオ",
        ko: "팔라우",
        lt: "Palau",
        nl: "Palau",
        no: "Palau",
        pl: "Palau",
        pt: "Palau",
        ro: "Palau",
        ru: "Палау",
        sk: "Palau",
        sv: "Palau",
        th: "ปาเลา",
        uk: "Палау",
        zh: "帕劳",
        "zh-tw": "帛琉"
    },
    {
        id: "pa",
        ar: "بنما",
        bg: "Панама",
        cs: "Panama",
        da: "Panama",
        de: "Panama",
        el: "Παναμάς",
        en: "Panama",
        eo: "Panamo",
        es: "Panam\xe1",
        et: "Panama",
        eu: "Panama",
        fi: "Panama",
        fr: "Panama",
        hu: "Panama",
        hy: "Պանամա",
        it: "Panama",
        ja: "パナマ",
        ko: "파나마",
        lt: "Panama",
        nl: "Panama",
        no: "Panama",
        pl: "Panama",
        pt: "Panam\xe1",
        ro: "Panama",
        ru: "Панама",
        sk: "Panama",
        sv: "Panama",
        th: "ปานามา",
        uk: "Панама",
        zh: "巴拿马",
        "zh-tw": "巴拿馬"
    },
    {
        id: "pg",
        ar: "بابوا غينيا الجديدة",
        bg: "Папуа Нова Гвинея",
        cs: "Papua Nov\xe1 Guinea",
        da: "Papua Ny Guinea",
        de: "Papua-Neuguinea",
        el: "Παπούα Νέα Γουινέα",
        en: "Papua New Guinea",
        eo: "Papuo-Nov-Gvineo",
        es: "Pap\xfaa Nueva Guinea",
        et: "Paapua Uus-Guinea",
        eu: "Papua Ginea Berria",
        fi: "Papua-Uusi-Guinea",
        fr: "Papouasie-Nouvelle-Guin\xe9e",
        hu: "P\xe1pua \xdaj-Guinea",
        hy: "Պապուա Նոր Գվինեա",
        it: "Papua Nuova Guinea",
        ja: "パプアニューギニア",
        ko: "파푸아뉴기니",
        lt: "Papua Naujoji Gvinėja",
        nl: "Papoea-Nieuw-Guinea",
        no: "Papua Ny-Guinea",
        pl: "Papua-Nowa Gwinea",
        pt: "Papua-Nova Guin\xe9",
        ro: "Papua Noua Guinee",
        ru: "Папуа — Новая Гвинея",
        sk: "Papua-Nov\xe1 Guinea",
        sv: "Papua Nya Guinea",
        th: "ปาปัวนิวกินี",
        uk: "Папуа Нова Гвінея",
        zh: "巴布亚新几内亚",
        "zh-tw": "巴布亞紐幾內亞"
    },
    {
        id: "py",
        ar: "باراغواي",
        bg: "Парагвай",
        cs: "Paraguay",
        da: "Paraguay",
        de: "Paraguay",
        el: "Παραγουάη",
        en: "Paraguay",
        eo: "Paragvajo",
        es: "Paraguay",
        et: "Paraguay",
        eu: "Paraguai",
        fi: "Paraguay",
        fr: "Paraguay",
        hu: "Paraguay",
        hy: "Պարագվայ",
        it: "Paraguay",
        ja: "パラグアイ",
        ko: "파라과이",
        lt: "Paragvajus",
        nl: "Paraguay",
        no: "Paraguay",
        pl: "Paragwaj",
        pt: "Paraguai",
        ro: "Paraguay",
        ru: "Парагвай",
        sk: "Paraguaj",
        sv: "Paraguay",
        th: "ปารากวัย",
        uk: "Парагвай",
        zh: "巴拉圭",
        "zh-tw": "巴拉圭"
    },
    {
        id: "pe",
        ar: "بيرو",
        bg: "Перу",
        cs: "Peru",
        da: "Peru",
        de: "Peru",
        el: "Περού",
        en: "Peru",
        eo: "Peruo",
        es: "Per\xfa",
        et: "Peruu",
        eu: "Peru",
        fi: "Peru",
        fr: "P\xe9rou",
        hu: "Peru",
        hy: "Պերու",
        it: "Per\xf9",
        ja: "ペルー",
        ko: "페루",
        lt: "Peru",
        nl: "Peru",
        no: "Peru",
        pl: "Peru",
        pt: "Peru",
        ro: "Peru",
        ru: "Перу",
        sk: "Peru",
        sv: "Peru",
        th: "เปรู",
        uk: "Перу",
        zh: "秘鲁",
        "zh-tw": "秘魯"
    },
    {
        id: "ph",
        ar: "الفلبين",
        bg: "Филипини",
        cs: "Filip\xedny",
        da: "Filippinerne",
        de: "Philippinen",
        el: "Φιλιππίνες",
        en: "Philippines",
        eo: "Filipinoj",
        es: "Filipinas",
        et: "Filipiinid",
        eu: "Filipinak",
        fi: "Filippiinit",
        fr: "Philippines",
        hu: "F\xfcl\xf6p-szigetek",
        hy: "Ֆիլիպիններ",
        it: "Filippine",
        ja: "フィリピン",
        ko: "필리핀",
        lt: "Filipinai",
        nl: "Filipijnen",
        no: "Filippinene",
        pl: "Filipiny",
        pt: "Filipinas",
        ro: "Filipine",
        ru: "Филиппины",
        sk: "Filip\xedny",
        sv: "Filippinerna",
        th: "ฟิลิปปินส์",
        uk: "Філіппіни",
        zh: "菲律宾",
        "zh-tw": "菲律賓"
    },
    {
        id: "pl",
        ar: "بولندا",
        bg: "Полша",
        cs: "Polsko",
        da: "Polen",
        de: "Polen",
        el: "Πολωνία",
        en: "Poland",
        eo: "Pollando",
        es: "Polonia",
        et: "Poola",
        eu: "Polonia",
        fi: "Puola",
        fr: "Pologne",
        hu: "Lengyelorsz\xe1g",
        hy: "Լեհաստան",
        it: "Polonia",
        ja: "ポーランド",
        ko: "폴란드",
        lt: "Lenkija",
        nl: "Polen",
        no: "Polen",
        pl: "Polska",
        pt: "Pol\xf3nia",
        ro: "Polonia",
        ru: "Польша",
        sk: "Poľsko",
        sv: "Polen",
        th: "โปแลนด์",
        uk: "Польща",
        zh: "波兰",
        "zh-tw": "波蘭"
    },
    {
        id: "pt",
        ar: "البرتغال",
        bg: "Португалия",
        cs: "Portugalsko",
        da: "Portugal",
        de: "Portugal",
        el: "Πορτογαλία",
        en: "Portugal",
        eo: "Portugalio",
        es: "Portugal",
        et: "Portugal",
        eu: "Portugal",
        fi: "Portugali",
        fr: "Portugal",
        hu: "Portug\xe1lia",
        hy: "Պորտուգալիա",
        it: "Portogallo",
        ja: "ポルトガル",
        ko: "포르투갈",
        lt: "Portugalija",
        nl: "Portugal",
        no: "Portugal",
        pl: "Portugalia",
        pt: "Portugal",
        ro: "Portugalia",
        ru: "Португалия",
        sk: "Portugalsko",
        sv: "Portugal",
        th: "โปรตุเกส",
        uk: "Португалія",
        zh: "葡萄牙",
        "zh-tw": "葡萄牙"
    },
    {
        id: "qa",
        ar: "قطر",
        bg: "Катар",
        cs: "Katar",
        da: "Qatar",
        de: "Katar",
        el: "Κατάρ",
        en: "Qatar",
        eo: "Kataro",
        es: "Catar",
        et: "Katar",
        eu: "Qatar",
        fi: "Qatar",
        fr: "Qatar",
        hu: "Katar",
        hy: "Կատար",
        it: "Qatar",
        ja: "カタール",
        ko: "카타르",
        lt: "Kataras",
        nl: "Qatar",
        no: "Qatar",
        pl: "Katar",
        pt: "Catar",
        ro: "Qatar",
        ru: "Катар",
        sk: "Katar",
        sv: "Qatar",
        th: "กาตาร์",
        uk: "Катар",
        zh: "卡塔尔",
        "zh-tw": "卡達"
    },
    {
        id: "ro",
        ar: "رومانيا",
        bg: "Румъния",
        cs: "Rumunsko",
        da: "Rum\xe6nien",
        de: "Rum\xe4nien",
        el: "Ρουμανία",
        en: "Romania",
        eo: "Rumanio",
        es: "Rumania",
        et: "Rumeenia",
        eu: "Errumania",
        fi: "Romania",
        fr: "Roumanie",
        hu: "Rom\xe1nia",
        hy: "Ռումինիա",
        it: "Romania",
        ja: "ルーマニア",
        ko: "루마니아",
        lt: "Rumunija",
        nl: "Roemeni\xeb",
        no: "Romania",
        pl: "Rumunia",
        pt: "Rom\xe9nia",
        ro: "Rom\xe2nia",
        ru: "Румыния",
        sk: "Rumunsko",
        sv: "Rum\xe4nien",
        th: "โรมาเนีย",
        uk: "Румунія",
        zh: "罗马尼亚",
        "zh-tw": "羅馬尼亞"
    },
    {
        id: "ru",
        ar: "روسيا",
        bg: "Русия",
        cs: "Rusko",
        da: "Rusland",
        de: "Russland",
        el: "Ρωσία",
        en: "Russian Federation",
        eo: "Rusio",
        es: "Rusia",
        et: "Venemaa",
        eu: "Errusia",
        fi: "Ven\xe4j\xe4",
        fr: "Russie",
        hu: "Oroszorsz\xe1g",
        hy: "Ռուսաստան",
        it: "Russia",
        ja: "ロシア連邦",
        ko: "러시아",
        lt: "Rusija",
        nl: "Rusland",
        no: "Russland",
        pl: "Rosja",
        pt: "R\xfassia",
        ro: "Rusia",
        ru: "Россия",
        sk: "Rusko",
        sv: "Ryssland",
        th: "รัสเซีย",
        uk: "Росія",
        zh: "俄罗斯",
        "zh-tw": "俄羅斯"
    },
    {
        id: "rw",
        ar: "رواندا",
        bg: "Руанда",
        cs: "Rwanda",
        da: "Rwanda",
        de: "Ruanda",
        el: "Ρουάντα",
        en: "Rwanda",
        eo: "Ruando",
        es: "Ruanda",
        et: "Rwanda",
        eu: "Ruanda",
        fi: "Ruanda",
        fr: "Rwanda",
        hu: "Ruanda",
        hy: "Ռուանդա",
        it: "Ruanda",
        ja: "ルワンダ",
        ko: "르완다",
        lt: "Ruanda",
        nl: "Rwanda",
        no: "Rwanda",
        pl: "Rwanda",
        pt: "Ruanda",
        ro: "Rwanda",
        ru: "Руанда",
        sk: "Rwanda",
        sv: "Rwanda",
        th: "รวันดา",
        uk: "Руанда",
        zh: "卢旺达",
        "zh-tw": "盧安達"
    },
    {
        id: "kn",
        ar: "سانت كيتس ونيفيس",
        bg: "Сейнт Китс и Невис",
        cs: "Svat\xfd Kryštof a Nevis",
        da: "Saint Kitts og Nevis",
        de: "St. Kitts und Nevis",
        el: "Άγιος Χριστόφορος και Νέβις",
        en: "Saint Kitts and Nevis",
        eo: "Sankta-Kito kaj Neviso",
        es: "San Crist\xf3bal y Nieves",
        et: "Saint Kitts ja Nevis",
        eu: "Saint Kitts eta Nevis",
        fi: "Saint Kitts ja Nevis",
        fr: "Saint-Christophe-et-Ni\xe9v\xe8s",
        hu: "Saint Kitts \xe9s Nevis",
        hy: "Սենտ Կիտս և Նևիս",
        it: "Saint Kitts e Nevis",
        ja: "セントクリストファー・ネイビス",
        ko: "세인트키츠 네비스",
        lt: "Sent Kitsas ir Nevis",
        nl: "Saint Kitts en Nevis",
        no: "Saint Kitts og Nevis",
        pl: "Saint Kitts i Nevis",
        pt: "S\xe3o Crist\xf3v\xe3o e Neves",
        ro: "Sf\xe2ntul Kitts și Nevis",
        ru: "Сент-Китс и Невис",
        sk: "Sv\xe4t\xfd Krištof a Nevis",
        sv: "Saint Kitts och Nevis",
        th: "เซนต์คิตส์และเนวิส",
        uk: "Сент-Кіттс і Невіс",
        zh: "圣基茨和尼维斯",
        "zh-tw": "聖克里斯多福及尼維斯"
    },
    {
        id: "lc",
        ar: "سانت لوسيا",
        bg: "Сейнт Лусия",
        cs: "Svat\xe1 Lucie",
        da: "Saint Lucia",
        de: "St. Lucia",
        el: "Αγία Λουκία",
        en: "Saint Lucia",
        eo: "Sankta Lucio",
        es: "Santa Luc\xeda",
        et: "Saint Lucia",
        eu: "Santa Luzia",
        fi: "Saint Lucia",
        fr: "Sainte-Lucie",
        hu: "Saint Lucia",
        hy: "Սենթ Լյուսիա",
        it: "Saint Lucia",
        ja: "セントルシア",
        ko: "세인트루시아",
        lt: "Sent Lusija",
        nl: "Saint Lucia",
        no: "Saint Lucia",
        pl: "Saint Lucia",
        pt: "Santa L\xfacia",
        ro: "Sf\xe2nta Lucia",
        ru: "Сент-Люсия",
        sk: "Sv\xe4t\xe1 Lucia",
        sv: "Saint Lucia",
        th: "เซนต์ลูเชีย",
        uk: "Сент-Люсія",
        zh: "圣卢西亚",
        "zh-tw": "聖露西亞"
    },
    {
        id: "vc",
        ar: "سانت فينسنت والغرينادين",
        bg: "Сейнт Винсент и Гренадини",
        cs: "Svat\xfd Vincenc a Grenadiny",
        da: "Saint Vincent og Grenadinerne",
        de: "St. Vincent und die Grenadinen",
        el: "Άγιος Βικέντιος και Γρεναδίνες",
        en: "Saint Vincent and the Grenadines",
        eo: "Sankta Vincento kaj la Grenadinoj",
        es: "San Vicente y las Granadinas",
        et: "Saint Vincent ja Grenadiinid",
        eu: "Saint Vincent eta Grenadinak",
        fi: "Saint Vincent ja Grenadiinit",
        fr: "Saint-Vincent-et-les-Grenadines",
        hu: "Saint Vincent \xe9s a Grenadine-szigetek",
        hy: "Սենտ Վինսենտ և Գրենադիներ",
        it: "Saint Vincent e Grenadine",
        ja: "セントビンセントおよびグレナディーン諸島",
        ko: "세인트빈센트 그레나딘",
        lt: "Sent Vinsentas ir Grenadinai",
        nl: "Saint Vincent en de Grenadines",
        no: "Saint Vincent og Grenadinene",
        pl: "Saint Vincent i Grenadyny",
        pt: "S\xe3o Vicente e Granadinas",
        ro: "Sf\xe2ntul Vincent și Grenadine",
        ru: "Сент-Винсент и Гренадины",
        sk: "Sv\xe4t\xfd Vincent a Grenad\xedny",
        sv: "Saint Vincent och Grenadinerna",
        th: "เซนต์วินเซนต์และเกรนาดีนส์",
        uk: "Сент-Вінсент і Гренадини",
        zh: "圣文森特和格林纳丁斯",
        "zh-tw": "聖文森及格瑞那丁"
    },
    {
        id: "ws",
        ar: "ساموا",
        bg: "Самоа",
        cs: "Samoa",
        da: "Samoa",
        de: "Samoa",
        el: "Σαμόα",
        en: "Samoa",
        eo: "Samoo",
        es: "Samoa",
        et: "Samoa",
        eu: "Samoa",
        fi: "Samoa",
        fr: "Samoa",
        hu: "Szamoa",
        hy: "Սամոա",
        it: "Samoa",
        ja: "サモア",
        ko: "사모아",
        lt: "Samoa",
        nl: "Samoa",
        no: "Samoa",
        pl: "Samoa",
        pt: "Samoa",
        ro: "Samoa",
        ru: "Самоа",
        sk: "Samoa",
        sv: "Samoa",
        th: "ซามัว",
        uk: "Самоа",
        zh: "萨摩亚",
        "zh-tw": "薩摩亞"
    },
    {
        id: "sm",
        ar: "سان مارينو",
        bg: "Сан Марино",
        cs: "San Marino",
        da: "San Marino",
        de: "San Marino",
        el: "Άγιος Μαρίνος",
        en: "San Marino",
        eo: "San-Marino",
        es: "San Marino",
        et: "San Marino",
        eu: "San Marino",
        fi: "San Marino",
        fr: "Saint-Marin",
        hu: "San Marino",
        hy: "Սան Մարինո",
        it: "San Marino",
        ja: "サンマリノ",
        ko: "산마리노",
        lt: "San Marinas",
        nl: "San Marino",
        no: "San Marino",
        pl: "San Marino",
        pt: "San Marino",
        ro: "San Marino",
        ru: "Сан-Марино",
        sk: "San Mar\xedno",
        sv: "San Marino",
        th: "ซานมารีโน",
        uk: "Сан-Марино",
        zh: "圣马力诺",
        "zh-tw": "聖馬利諾"
    },
    {
        id: "st",
        ar: "ساو تومي وبرينسيب",
        bg: "Сао Томе и Принсипи",
        cs: "Svat\xfd Tom\xe1š a Princův ostrov",
        da: "S\xe3o Tom\xe9 og Pr\xedncipe",
        de: "S\xe3o Tom\xe9 und Pr\xedncipe",
        el: "Σάο Τομέ και Πρίνσιπε",
        en: "Sao Tome and Principe",
        eo: "Santomeo kaj Principeo",
        es: "Santo Tom\xe9 y Pr\xedncipe",
        et: "S\xe3o Tom\xe9 ja Pr\xedncipe",
        eu: "Sao Tome eta Principe",
        fi: "S\xe3o Tom\xe9 ja Pr\xedncipe",
        fr: "Sao Tom\xe9-et-Principe",
        hu: "S\xe3o Tom\xe9 \xe9s Pr\xedncipe",
        hy: "Սան Տոմե և Պրինսիպի",
        it: "S\xe3o Tom\xe9 e Pr\xedncipe",
        ja: "サントメ・プリンシペ",
        ko: "상투메 프린시페",
        lt: "San Tomė ir Prinsipė",
        nl: "Sao Tom\xe9 en Principe",
        no: "S\xe3o Tom\xe9 og Pr\xedncipe",
        pl: "Wyspy Świętego Tomasza i Książęca",
        pt: "S\xe3o Tom\xe9 e Pr\xedncipe",
        ro: "Sao Tome și Principe",
        ru: "Сан-Томе и Принсипи",
        sk: "Sv\xe4t\xfd Tom\xe1š a Princov ostrov",
        sv: "S\xe3o Tom\xe9 och Pr\xedncipe",
        th: "เซาตูแมอีปริงซีป",
        uk: "Сан-Томе і Принсіпі",
        zh: "圣多美和普林西比",
        "zh-tw": "聖多美普林西比"
    },
    {
        id: "sa",
        ar: "السعودية",
        bg: "Саудитска Арабия",
        cs: "Sa\xfadsk\xe1 Ar\xe1bie",
        da: "Saudi-Arabien",
        de: "Saudi-Arabien",
        el: "Σαουδική Αραβία",
        en: "Saudi Arabia",
        eo: "Sauda Arabio",
        es: "Arabia Saudita",
        et: "Saudi Araabia",
        eu: "Saudi Arabia",
        fi: "Saudi-Arabia",
        fr: "Arabie saoudite",
        hu: "Sza\xfad-Ar\xe1bia",
        hy: "Սաուդյան Արաբիա",
        it: "Arabia Saudita",
        ja: "サウジアラビア",
        ko: "사우디아라비아",
        lt: "Saudo Arabija",
        nl: "Saoedi-Arabi\xeb",
        no: "Saudi-Arabia",
        pl: "Arabia Saudyjska",
        pt: "Ar\xe1bia Saudita",
        ro: "Arabia Saudită",
        ru: "Саудовская Аравия",
        sk: "Saudsk\xe1 Ar\xe1bia",
        sv: "Saudiarabien",
        th: "ซาอุดีอาระเบีย",
        uk: "Саудівська Аравія",
        zh: "沙特阿拉伯",
        "zh-tw": "沙烏地阿拉伯"
    },
    {
        id: "sn",
        ar: "السنغال",
        bg: "Сенегал",
        cs: "Senegal",
        da: "Senegal",
        de: "Senegal",
        el: "Σενεγάλη",
        en: "Senegal",
        eo: "Senegalo",
        es: "Senegal",
        et: "Senegal",
        eu: "Senegal",
        fi: "Senegal",
        fr: "S\xe9n\xe9gal",
        hu: "Szeneg\xe1l",
        hy: "Սենեգալ",
        it: "Senegal",
        ja: "セネガル",
        ko: "세네갈",
        lt: "Senegalas",
        nl: "Senegal",
        no: "Senegal",
        pl: "Senegal",
        pt: "Senegal",
        ro: "Senegal",
        ru: "Сенегал",
        sk: "Senegal",
        sv: "Senegal",
        th: "เซเนกัล",
        uk: "Сенегал",
        zh: "塞内加尔",
        "zh-tw": "塞內加爾"
    },
    {
        id: "rs",
        ar: "صربيا",
        bg: "Сърбия",
        cs: "Srbsko",
        da: "Serbien",
        de: "Serbien",
        el: "Σερβία",
        en: "Serbia",
        eo: "Serbio",
        es: "Serbia",
        et: "Serbia",
        eu: "Serbia",
        fi: "Serbia",
        fr: "Serbie",
        hu: "Szerbia",
        hy: "Սերբիա",
        it: "Serbia",
        ja: "セルビア",
        ko: "세르비아",
        lt: "Serbija",
        nl: "Servi\xeb",
        no: "Serbia",
        pl: "Serbia",
        pt: "S\xe9rvia",
        ro: "Serbia",
        ru: "Сербия",
        sk: "Srbsko",
        sv: "Serbien",
        th: "เซอร์เบีย",
        uk: "Сербія",
        zh: "塞尔维亚",
        "zh-tw": "塞爾維亞"
    },
    {
        id: "sc",
        ar: "سيشل",
        bg: "Сейшелски острови",
        cs: "Seychely",
        da: "Seychellerne",
        de: "Seychellen",
        el: "Σεϋχέλλες",
        en: "Seychelles",
        eo: "Sejŝeloj",
        es: "Seychelles",
        et: "Seišellid",
        eu: "Seychelleak",
        fi: "Seychellit",
        fr: "Seychelles",
        hu: "Seychelle-szigetek",
        hy: "Սեյշելներ",
        it: "Seychelles",
        ja: "セーシェル",
        ko: "세이셸",
        lt: "Seišeliai",
        nl: "Seychellen",
        no: "Seychellene",
        pl: "Seszele",
        pt: "Seicheles",
        ro: "Seychelles",
        ru: "Сейшельские Острова",
        sk: "Seychely",
        sv: "Seychellerna",
        th: "เซเชลส์",
        uk: "Сейшельські Острови",
        zh: "塞舌尔",
        "zh-tw": "塞席爾"
    },
    {
        id: "sl",
        ar: "سيراليون",
        bg: "Сиера Леоне",
        cs: "Sierra Leone",
        da: "Sierra Leone",
        de: "Sierra Leone",
        el: "Σιέρα Λεόνε",
        en: "Sierra Leone",
        eo: "Sieraleono",
        es: "Sierra Leona",
        et: "Sierra Leone",
        eu: "Sierra Leona",
        fi: "Sierra Leone",
        fr: "Sierra Leone",
        hu: "Sierra Leone",
        hy: "Սիեռա Լեոնե",
        it: "Sierra Leone",
        ja: "シエラレオネ",
        ko: "시에라리온",
        lt: "Siera Leonė",
        nl: "Sierra Leone",
        no: "Sierra Leone",
        pl: "Sierra Leone",
        pt: "Serra Leoa",
        ro: "Sierra Leone",
        ru: "Сьерра-Леоне",
        sk: "Sierra Leone",
        sv: "Sierra Leone",
        th: "เซียร์ราลีโอน",
        uk: "Сьєрра-Леоне",
        zh: "塞拉利昂",
        "zh-tw": "獅子山"
    },
    {
        id: "sg",
        ar: "سنغافورة",
        bg: "Сингапур",
        cs: "Singapur",
        da: "Singapore",
        de: "Singapur",
        el: "Σιγκαπούρη",
        en: "Singapore",
        eo: "Singapuro",
        es: "Singapur",
        et: "Singapur",
        eu: "Singapur",
        fi: "Singapore",
        fr: "Singapour",
        hu: "Szingap\xfar",
        hy: "Սինգապուր",
        it: "Singapore",
        ja: "シンガポール",
        ko: "싱가포르",
        lt: "Singapūras",
        nl: "Singapore",
        no: "Singapore",
        pl: "Singapur",
        pt: "Singapura",
        ro: "Singapore",
        ru: "Сингапур",
        sk: "Singapur",
        sv: "Singapore",
        th: "สิงคโปร์",
        uk: "Сінгапур",
        zh: "新加坡",
        "zh-tw": "新加坡"
    },
    {
        id: "sk",
        ar: "سلوفاكيا",
        bg: "Словакия",
        cs: "Slovensko",
        da: "Slovakiet",
        de: "Slowakei",
        el: "Σλοβακία",
        en: "Slovakia",
        eo: "Slovakio",
        es: "Eslovaquia",
        et: "Slovakkia",
        eu: "Eslovakia",
        fi: "Slovakia",
        fr: "Slovaquie",
        hu: "Szlov\xe1kia",
        hy: "Սլովակիա",
        it: "Slovacchia",
        ja: "スロバキア",
        ko: "슬로바키아",
        lt: "Slovakija",
        nl: "Slowakije",
        no: "Slovakia",
        pl: "Słowacja",
        pt: "Eslov\xe1quia",
        ro: "Slovacia",
        ru: "Словакия",
        sk: "Slovensko",
        sv: "Slovakien",
        th: "สโลวาเกีย",
        uk: "Словаччина",
        zh: "斯洛伐克",
        "zh-tw": "斯洛伐克"
    },
    {
        id: "si",
        ar: "سلوفينيا",
        bg: "Словения",
        cs: "Slovinsko",
        da: "Slovenien",
        de: "Slowenien",
        el: "Σλοβενία",
        en: "Slovenia",
        eo: "Slovenio",
        es: "Eslovenia",
        et: "Sloveenia",
        eu: "Eslovenia",
        fi: "Slovenia",
        fr: "Slov\xe9nie",
        hu: "Szlov\xe9nia",
        hy: "Սլովենիա",
        it: "Slovenia",
        ja: "スロベニア",
        ko: "슬로베니아",
        lt: "Slovėnija",
        nl: "Sloveni\xeb",
        no: "Slovenia",
        pl: "Słowenia",
        pt: "Eslov\xeania",
        ro: "Slovenia",
        ru: "Словения",
        sk: "Slovinsko",
        sv: "Slovenien",
        th: "สโลวีเนีย",
        uk: "Словенія",
        zh: "斯洛文尼亚",
        "zh-tw": "斯洛維尼亞"
    },
    {
        id: "sb",
        ar: "جزر سليمان",
        bg: "Соломонови острови",
        cs: "Šalomounovy ostrovy",
        da: "Salomon\xf8erne",
        de: "Salomonen",
        el: "Νήσοι Σολομώντα",
        en: "Solomon Islands",
        eo: "Salomonoj",
        es: "Islas Salom\xf3n",
        et: "Saalomoni Saared",
        eu: "Salomon Uharteak",
        fi: "Salomonsaaret",
        fr: "\xceles Salomon",
        hu: "Salamon-szigetek",
        hy: "Սողոմոնյան Կղզիներ",
        it: "Isole Salomone",
        ja: "ソロモン諸島",
        ko: "솔로몬 제도",
        lt: "Saliamono Salos",
        nl: "Salomonseilanden",
        no: "Salomon\xf8yene",
        pl: "Wyspy Salomona",
        pt: "Ilhas Salom\xe3o",
        ro: "Insulele Solomon",
        ru: "Соломоновы Острова",
        sk: "Šalam\xfanove ostrovy",
        sv: "Salomon\xf6arna",
        th: "หมู่เกาะโซโลมอน",
        uk: "Соломонові Острови",
        zh: "所罗门群岛",
        "zh-tw": "索羅門群島"
    },
    {
        id: "so",
        ar: "الصومال",
        bg: "Сомалия",
        cs: "Som\xe1lsko",
        da: "Somalia",
        de: "Somalia",
        el: "Σομαλία",
        en: "Somalia",
        eo: "Somalio",
        es: "Somalia",
        et: "Somaalia",
        eu: "Somalia",
        fi: "Somalia",
        fr: "Somalie",
        hu: "Szom\xe1lia",
        hy: "Սոմալի",
        it: "Somalia",
        ja: "ソマリア",
        ko: "소말리아",
        lt: "Somalis",
        nl: "Somali\xeb",
        no: "Somalia",
        pl: "Somalia",
        pt: "Som\xe1lia",
        ro: "Somalia",
        ru: "Сомали",
        sk: "Som\xe1lsko",
        sv: "Somalia",
        th: "โซมาเลีย",
        uk: "Сомалі",
        zh: "索马里",
        "zh-tw": "索馬利亞"
    },
    {
        id: "za",
        ar: "جنوب أفريقيا",
        bg: "ЮАР",
        cs: "Jihoafrick\xe1 republika",
        da: "Sydafrika",
        de: "S\xfcdafrika",
        el: "Νότια Αφρική",
        en: "South Africa",
        eo: "Sud-Afriko",
        es: "Sud\xe1frica",
        et: "L\xf5una-Aafrika Vabariik",
        eu: "Hegoafrika",
        fi: "Etel\xe4-Afrikka",
        fr: "Afrique du Sud",
        hu: "D\xe9l-afrikai K\xf6zt\xe1rsas\xe1g",
        hy: "Հարավաֆրիկյան Հանրապետություն",
        it: "Sudafrica",
        ja: "南アフリカ",
        ko: "남아프리카 공화국",
        lt: "PAR",
        nl: "Zuid-Afrika",
        no: "S\xf8r-Afrika",
        pl: "Południowa Afryka",
        pt: "\xc1frica do Sul",
        ro: "Africa de Sud",
        ru: "ЮАР",
        sk: "Južn\xe1 Afrika",
        sv: "Sydafrika",
        th: "แอฟริกาใต้",
        uk: "ПАР",
        zh: "南非",
        "zh-tw": "南非"
    },
    {
        id: "ss",
        ar: "جنوب السودان",
        bg: "Южен Судан",
        cs: "Jižn\xed S\xfad\xe1n",
        da: "Sydsudan",
        de: "S\xfcdsudan",
        el: "Νότιο Σουδάν",
        en: "South Sudan",
        eo: "Sud-Sudano",
        es: "Sud\xe1n del Sur",
        et: "L\xf5una-Sudaan",
        eu: "Hego Sudan",
        fi: "Etel\xe4-Sudan",
        fr: "Soudan du Sud",
        hu: "D\xe9l-Szud\xe1n",
        hy: "Հարավային Սուդան",
        it: "Sudan del Sud",
        ja: "南スーダン",
        ko: "남수단",
        lt: "Pietų Sudanas",
        nl: "Zuid-Soedan",
        no: "S\xf8r-Sudan",
        pl: "Sudan Południowy",
        pt: "Sud\xe3o do Sul",
        ro: "Sudanul de Sud",
        ru: "Южный Судан",
        sk: "Južn\xfd Sud\xe1n",
        sv: "Sydsudan",
        th: "ซูดานใต้",
        uk: "Південний Судан",
        zh: "南苏丹",
        "zh-tw": "南蘇丹"
    },
    {
        id: "es",
        ar: "إسبانيا",
        bg: "Испания",
        cs: "Španělsko",
        da: "Spanien",
        de: "Spanien",
        el: "Ισπανία",
        en: "Spain",
        eo: "Hispanio",
        es: "Espa\xf1a",
        et: "Hispaania",
        eu: "Espainia",
        fi: "Espanja",
        fr: "Espagne",
        hu: "Spanyolorsz\xe1g",
        hy: "Իսպանիա",
        it: "Spagna",
        ja: "スペイン",
        ko: "스페인",
        lt: "Ispanija",
        nl: "Spanje",
        no: "Spania",
        pl: "Hiszpania",
        pt: "Espanha",
        ro: "Spania",
        ru: "Испания",
        sk: "Španielsko",
        sv: "Spanien",
        th: "สเปน",
        uk: "Іспанія",
        zh: "西班牙",
        "zh-tw": "西班牙"
    },
    {
        id: "lk",
        ar: "سريلانكا",
        bg: "Шри Ланка",
        cs: "Sr\xed Lanka",
        da: "Sri Lanka",
        de: "Sri Lanka",
        el: "Σρι Λάνκα",
        en: "Sri Lanka",
        eo: "Srilanko",
        es: "Sri Lanka",
        et: "Sri Lanka",
        eu: "Sri Lanka",
        fi: "Sri Lanka",
        fr: "Sri Lanka",
        hu: "Sr\xed Lanka",
        hy: "Շրի Լանկա",
        it: "Sri Lanka",
        ja: "スリランカ",
        ko: "스리랑카",
        lt: "Šri Lanka",
        nl: "Sri Lanka",
        no: "Sri Lanka",
        pl: "Sri Lanka",
        pt: "Seri Lanca",
        ro: "Sri Lanka",
        ru: "Шри-Ланка",
        sk: "Sr\xed Lanka",
        sv: "Sri Lanka",
        th: "ศรีลังกา",
        uk: "Шрі-Ланка",
        zh: "斯里兰卡",
        "zh-tw": "斯里蘭卡"
    },
    {
        id: "sd",
        ar: "السودان",
        bg: "Судан",
        cs: "S\xfad\xe1n",
        da: "Sudan",
        de: "Sudan",
        el: "Σουδάν",
        en: "Sudan",
        eo: "Sudano",
        es: "Sud\xe1n",
        et: "Sudaan",
        eu: "Sudan",
        fi: "Sudan",
        fr: "Soudan",
        hu: "Szud\xe1n",
        hy: "Սուդան",
        it: "Sudan",
        ja: "スーダン",
        ko: "수단",
        lt: "Sudanas",
        nl: "Soedan",
        no: "Sudan",
        pl: "Sudan",
        pt: "Sud\xe3o",
        ro: "Sudan",
        ru: "Судан",
        sk: "Sud\xe1n",
        sv: "Sudan",
        th: "ซูดาน",
        uk: "Судан",
        zh: "苏丹",
        "zh-tw": "蘇丹"
    },
    {
        id: "sr",
        ar: "سورينام",
        bg: "Суринам",
        cs: "Surinam",
        da: "Surinam",
        de: "Suriname",
        el: "Σουρινάμ",
        en: "Suriname",
        eo: "Surinamo",
        es: "Surinam",
        et: "Suriname",
        eu: "Surinam",
        fi: "Suriname",
        fr: "Suriname",
        hu: "Suriname",
        hy: "Սուրինամ",
        it: "Suriname",
        ja: "スリナム",
        ko: "수리남",
        lt: "Surinamas",
        nl: "Suriname",
        no: "Surinam",
        pl: "Surinam",
        pt: "Suriname",
        ro: "Surinam",
        ru: "Суринам",
        sk: "Surinam",
        sv: "Surinam",
        th: "ซูรินาม",
        uk: "Суринам",
        zh: "苏里南",
        "zh-tw": "蘇利南"
    },
    {
        id: "sz",
        ar: "إسواتيني",
        bg: "Есватини",
        cs: "Svazijsko",
        da: "Swaziland",
        de: "Eswatini",
        el: "Εσουατίνι",
        en: "Eswatini",
        eo: "Svazilando",
        es: "Suazilandia",
        et: "Svaasimaa",
        eu: "Eswatini",
        fi: "Swazimaa",
        fr: "Eswatini",
        hu: "Szv\xe1zif\xf6ld",
        hy: "Էսվատինի",
        it: "eSwatini",
        ja: "エスワティニ",
        ko: "에스와티니",
        lt: "Svazilendas",
        nl: "Swaziland",
        no: "Eswatini",
        pl: "Eswatini",
        pt: "Essuat\xedni",
        ro: "Eswatini",
        ru: "Эсватини",
        sk: "Svazijsko",
        sv: "Swaziland",
        th: "เอสวาตีนี",
        uk: "Есватіні",
        zh: "斯威士兰",
        "zh-tw": "史瓦帝尼"
    },
    {
        id: "se",
        ar: "السويد",
        bg: "Швеция",
        cs: "Šv\xe9dsko",
        da: "Sverige",
        de: "Schweden",
        el: "Σουηδία",
        en: "Sweden",
        eo: "Svedio",
        es: "Suecia",
        et: "Rootsi",
        eu: "Suedia",
        fi: "Ruotsi",
        fr: "Su\xe8de",
        hu: "Sv\xe9dorsz\xe1g",
        hy: "Շվեդիա",
        it: "Svezia",
        ja: "スウェーデン",
        ko: "스웨덴",
        lt: "Švedija",
        nl: "Zweden",
        no: "Sverige",
        pl: "Szwecja",
        pt: "Su\xe9cia",
        ro: "Suedia",
        ru: "Швеция",
        sk: "Šv\xe9dsko",
        sv: "Sverige",
        th: "สวีเดน",
        uk: "Швеція",
        zh: "瑞典",
        "zh-tw": "瑞典"
    },
    {
        id: "ch",
        ar: "سويسرا",
        bg: "Швейцария",
        cs: "Šv\xfdcarsko",
        da: "Schweiz",
        de: "Schweiz",
        el: "Ελβετία",
        en: "Switzerland",
        eo: "Svislando",
        es: "Suiza",
        et: "Šveits",
        eu: "Suitza",
        fi: "Sveitsi",
        fr: "Suisse",
        hu: "Sv\xe1jc",
        hy: "Շվեյցարիա",
        it: "Svizzera",
        ja: "スイス",
        ko: "스위스",
        lt: "Šveicarija",
        nl: "Zwitserland",
        no: "Sveits",
        pl: "Szwajcaria",
        pt: "Su\xed\xe7a",
        ro: "Elveția",
        ru: "Швейцария",
        sk: "Švajčiarsko",
        sv: "Schweiz",
        th: "สวิตเซอร์แลนด์",
        uk: "Швейцарія",
        zh: "瑞士",
        "zh-tw": "瑞士"
    },
    {
        id: "sy",
        ar: "سوريا",
        bg: "Сирия",
        cs: "S\xfdrie",
        da: "Syrien",
        de: "Syrien",
        el: "Συρία",
        en: "Syrian Arab Republic",
        eo: "Sirio",
        es: "Siria",
        et: "S\xfc\xfcria",
        eu: "Siria",
        fi: "Syyria",
        fr: "Syrie",
        hu: "Sz\xedria",
        hy: "Սիրիա",
        it: "Siria",
        ja: "シリア・アラブ共和国",
        ko: "시리아",
        lt: "Sirija",
        nl: "Syri\xeb",
        no: "Syria",
        pl: "Syria",
        pt: "S\xedria",
        ro: "Siria",
        ru: "Сирия",
        sk: "S\xfdria",
        sv: "Syrien",
        th: "ซีเรีย",
        uk: "Сирія",
        zh: "叙利亚",
        "zh-tw": "敘利亞"
    },
    {
        id: "tj",
        ar: "طاجيكستان",
        bg: "Таджикистан",
        cs: "T\xe1džikist\xe1n",
        da: "Tadsjikistan",
        de: "Tadschikistan",
        el: "Τατζικιστάν",
        en: "Tajikistan",
        eo: "Taĝikio",
        es: "Tayikist\xe1n",
        et: "Tadžikistan",
        eu: "Tajikistan",
        fi: "Tadžikistan",
        fr: "Tadjikistan",
        hu: "T\xe1dzsikiszt\xe1n",
        hy: "Տաջիկստան",
        it: "Tagikistan",
        ja: "タジキスタン",
        ko: "타지키스탄",
        lt: "Tadžikija",
        nl: "Tadzjikistan",
        no: "Tadsjikistan",
        pl: "Tadżykistan",
        pt: "Tajiquist\xe3o",
        ro: "Tadjikistan",
        ru: "Таджикистан",
        sk: "Tadžikistan",
        sv: "Tadzjikistan",
        th: "ทาจิกิสถาน",
        uk: "Таджикистан",
        zh: "塔吉克斯坦",
        "zh-tw": "塔吉克"
    },
    {
        id: "tz",
        ar: "تنزانيا",
        bg: "Танзания",
        cs: "Tanzanie",
        da: "Tanzania",
        de: "Tansania",
        el: "Τανζανία",
        en: "Tanzania, United Republic of",
        eo: "Tanzanio",
        es: "Tanzania",
        et: "Tansaania",
        eu: "Tanzania",
        fi: "Tansania",
        fr: "Tanzanie",
        hu: "Tanz\xe1nia",
        hy: "Տանզանիա",
        it: "Tanzania",
        ja: "タンザニア",
        ko: "탄자니아",
        lt: "Tanzanija",
        nl: "Tanzania",
        no: "Tanzania",
        pl: "Tanzania",
        pt: "Tanz\xe2nia",
        ro: "Tanzania",
        ru: "Танзания",
        sk: "Tanz\xe1nia",
        sv: "Tanzania",
        th: "แทนซาเนีย",
        uk: "Танзанія",
        zh: "坦桑尼亚",
        "zh-tw": "坦尚尼亞"
    },
    {
        id: "th",
        ar: "تايلاند",
        bg: "Тайланд",
        cs: "Thajsko",
        da: "Thailand",
        de: "Thailand",
        el: "Ταϊλάνδη",
        en: "Thailand",
        eo: "Tajlando",
        es: "Tailandia",
        et: "Tai",
        eu: "Thailandia",
        fi: "Thaimaa",
        fr: "Tha\xeflande",
        hu: "Thaif\xf6ld",
        hy: "Թաիլանդ",
        it: "Thailandia",
        ja: "タイ",
        ko: "태국",
        lt: "Tailandas",
        nl: "Thailand",
        no: "Thailand",
        pl: "Tajlandia",
        pt: "Tail\xe2ndia",
        ro: "Thailanda",
        ru: "Таиланд",
        sk: "Thajsko",
        sv: "Thailand",
        th: "ไทย",
        uk: "Таїланд",
        zh: "泰国",
        "zh-tw": "泰國"
    },
    {
        id: "tl",
        ar: "تيمور الشرقية",
        bg: "Източен Тимор",
        cs: "V\xfdchodn\xed Timor",
        da: "\xd8sttimor",
        de: "Osttimor",
        el: "Ανατολικό Τιμόρ",
        en: "Timor-Leste",
        eo: "Orienta Timoro",
        es: "Timor Oriental",
        et: "Ida-Timor",
        eu: "Ekialdeko Timor",
        fi: "It\xe4-Timor",
        fr: "Timor oriental",
        hu: "Kelet-Timor",
        hy: "Արևելյան Թիմոր",
        it: "Timor Est",
        ja: "東ティモール",
        ko: "동티모르",
        lt: "Rytų Timoras",
        nl: "Oost-Timor",
        no: "\xd8st-Timor",
        pl: "Timor Wschodni",
        pt: "Timor-Leste",
        ro: "Timorul de Est",
        ru: "Восточный Тимор",
        sk: "V\xfdchodn\xfd Timor",
        sv: "\xd6sttimor",
        th: "ติมอร์-เลสเต",
        uk: "Східний Тимор",
        zh: "东帝汶",
        "zh-tw": "東帝汶"
    },
    {
        id: "tg",
        ar: "توغو",
        bg: "Того",
        cs: "Togo",
        da: "Togo",
        de: "Togo",
        el: "Τόγκο",
        en: "Togo",
        eo: "Togolando",
        es: "Togo",
        et: "Togo",
        eu: "Togo",
        fi: "Togo",
        fr: "Togo",
        hu: "Togo",
        hy: "Տոգո",
        it: "Togo",
        ja: "トーゴ",
        ko: "토고",
        lt: "Togas",
        nl: "Togo",
        no: "Togo",
        pl: "Togo",
        pt: "Togo",
        ro: "Togo",
        ru: "Того",
        sk: "Togo",
        sv: "Togo",
        th: "โตโก",
        uk: "Того",
        zh: "多哥",
        "zh-tw": "多哥"
    },
    {
        id: "to",
        ar: "تونغا",
        bg: "Тонга",
        cs: "Tonga",
        da: "Tonga",
        de: "Tonga",
        el: "Τόγκα",
        en: "Tonga",
        eo: "Tongo",
        es: "Tonga",
        et: "Tonga",
        eu: "Tonga",
        fi: "Tonga",
        fr: "Tonga",
        hu: "Tonga",
        hy: "Տոնգա",
        it: "Tonga",
        ja: "トンガ",
        ko: "통가",
        lt: "Tonga",
        nl: "Tonga",
        no: "Tonga",
        pl: "Tonga",
        pt: "Tonga",
        ro: "Tonga",
        ru: "Тонга",
        sk: "Tonga",
        sv: "Tonga",
        th: "ตองงา",
        uk: "Тонга",
        zh: "汤加",
        "zh-tw": "東加"
    },
    {
        id: "tt",
        ar: "ترينيداد وتوباغو",
        bg: "Тринидад и Тобаго",
        cs: "Trinidad a Tobago",
        da: "Trinidad og Tobago",
        de: "Trinidad und Tobago",
        el: "Τρινιντάντ και Τομπάγκο",
        en: "Trinidad and Tobago",
        eo: "Trinidado kaj Tobago",
        es: "Trinidad y Tobago",
        et: "Trinidad ja Tobago",
        eu: "Trinidad eta Tobago",
        fi: "Trinidad ja Tobago",
        fr: "Trinit\xe9-et-Tobago",
        hu: "Trinidad \xe9s Tobago",
        hy: "Տրինիդադ և Տոբագո",
        it: "Trinidad e Tobago",
        ja: "トリニダード・トバゴ",
        ko: "트리니다드 토바고",
        lt: "Trinidadas ir Tobagas",
        nl: "Trinidad en Tobago",
        no: "Trinidad og Tobago",
        pl: "Trynidad i Tobago",
        pt: "Trinidad e Tobago",
        ro: "Trinidad și Tobago",
        ru: "Тринидад и Тобаго",
        sk: "Trinidad a Tobago",
        sv: "Trinidad och Tobago",
        th: "ตรินิแดดและโตเบโก",
        uk: "Тринідад і Тобаго",
        zh: "特立尼达和多巴哥",
        "zh-tw": "千里達及托巴哥"
    },
    {
        id: "tn",
        ar: "تونس",
        bg: "Тунис",
        cs: "Tunisko",
        da: "Tunesien",
        de: "Tunesien",
        el: "Τυνησία",
        en: "Tunisia",
        eo: "Tunizio",
        es: "T\xfanez",
        et: "Tuneesia",
        eu: "Tunisia",
        fi: "Tunisia",
        fr: "Tunisie",
        hu: "Tun\xe9zia",
        hy: "Թունիս",
        it: "Tunisia",
        ja: "チュニジア",
        ko: "튀니지",
        lt: "Tunisas",
        nl: "Tunesi\xeb",
        no: "Tunisia",
        pl: "Tunezja",
        pt: "Tun\xedsia",
        ro: "Tunisia",
        ru: "Тунис",
        sk: "Tunisko",
        sv: "Tunisien",
        th: "ตูนิเซีย",
        uk: "Туніс",
        zh: "突尼斯",
        "zh-tw": "突尼西亞"
    },
    {
        id: "tr",
        ar: "تركيا",
        bg: "Турция",
        cs: "Turecko",
        da: "Tyrkiet",
        de: "T\xfcrkei",
        el: "Τουρκία",
        en: "T\xfcrkiye",
        eo: "Turkio",
        es: "Turqu\xeda",
        et: "T\xfcrgi",
        eu: "Turkia",
        fi: "Turkki",
        fr: "Turquie",
        hu: "T\xf6r\xf6korsz\xe1g",
        hy: "Թուրքիա",
        it: "Turchia",
        ja: "トルコ",
        ko: "튀르키예",
        lt: "Turkija",
        nl: "Turkije",
        no: "Tyrkia",
        pl: "Turcja",
        pt: "Turquia",
        ro: "Turcia",
        ru: "Турция",
        sk: "Turecko",
        sv: "Turkiet",
        th: "ตุรกี",
        uk: "Туреччина",
        zh: "土耳其",
        "zh-tw": "土耳其"
    },
    {
        id: "tm",
        ar: "تركمانستان",
        bg: "Туркменистан",
        cs: "Turkmenist\xe1n",
        da: "Turkmenistan",
        de: "Turkmenistan",
        el: "Τουρκμενιστάν",
        en: "Turkmenistan",
        eo: "Turkmenio",
        es: "Turkmenist\xe1n",
        et: "T\xfcrkmenistan",
        eu: "Turkmenistan",
        fi: "Turkmenistan",
        fr: "Turkm\xe9nistan",
        hu: "T\xfcrkmeniszt\xe1n",
        hy: "Թուրքմենստան",
        it: "Turkmenistan",
        ja: "トルクメニスタン",
        ko: "투르크메니스탄",
        lt: "Turkmėnija",
        nl: "Turkmenistan",
        no: "Turkmenistan",
        pl: "Turkmenistan",
        pt: "Turcomenist\xe3o",
        ro: "Turkmenistan",
        ru: "Туркменистан",
        sk: "Turkm\xe9nsko",
        sv: "Turkmenistan",
        th: "เติร์กเมนิสถาน",
        uk: "Туркменістан",
        zh: "土库曼斯坦",
        "zh-tw": "土庫曼"
    },
    {
        id: "tv",
        ar: "توفالو",
        bg: "Тувалу",
        cs: "Tuvalu",
        da: "Tuvalu",
        de: "Tuvalu",
        el: "Τουβαλού",
        en: "Tuvalu",
        eo: "Tuvalo",
        es: "Tuvalu",
        et: "Tuvalu",
        eu: "Tuvalu",
        fi: "Tuvalu",
        fr: "Tuvalu",
        hu: "Tuvalu",
        hy: "Տուվալու",
        it: "Tuvalu",
        ja: "ツバル",
        ko: "투발루",
        lt: "Tuvalu",
        nl: "Tuvalu",
        no: "Tuvalu",
        pl: "Tuvalu",
        pt: "Tuvalu",
        ro: "Tuvalu",
        ru: "Тувалу",
        sk: "Tuvalu",
        sv: "Tuvalu",
        th: "ตูวาลู",
        uk: "Тувалу",
        zh: "图瓦卢",
        "zh-tw": "吐瓦魯"
    },
    {
        id: "ug",
        ar: "أوغندا",
        bg: "Уганда",
        cs: "Uganda",
        da: "Uganda",
        de: "Uganda",
        el: "Ουγκάντα",
        en: "Uganda",
        eo: "Ugando",
        es: "Uganda",
        et: "Uganda",
        eu: "Uganda",
        fi: "Uganda",
        fr: "Ouganda",
        hu: "Uganda",
        hy: "Ուգանդա",
        it: "Uganda",
        ja: "ウガンダ",
        ko: "우간다",
        lt: "Uganda",
        nl: "Oeganda",
        no: "Uganda",
        pl: "Uganda",
        pt: "Uganda",
        ro: "Uganda",
        ru: "Уганда",
        sk: "Uganda",
        sv: "Uganda",
        th: "ยูกันดา",
        uk: "Уганда",
        zh: "乌干达",
        "zh-tw": "烏干達"
    },
    {
        id: "ua",
        ar: "أوكرانيا",
        bg: "Украйна",
        cs: "Ukrajina",
        da: "Ukraine",
        de: "Ukraine",
        el: "Ουκρανία",
        en: "Ukraine",
        eo: "Ukrainio",
        es: "Ucrania",
        et: "Ukraina",
        eu: "Ukraina",
        fi: "Ukraina",
        fr: "Ukraine",
        hu: "Ukrajna",
        hy: "Ուկրաինա",
        it: "Ucraina",
        ja: "ウクライナ",
        ko: "우크라이나",
        lt: "Ukraina",
        nl: "Oekra\xefne",
        no: "Ukraina",
        pl: "Ukraina",
        pt: "Ucr\xe2nia",
        ro: "Ucraina",
        ru: "Украина",
        sk: "Ukrajina",
        sv: "Ukraina",
        th: "ยูเครน",
        uk: "Україна",
        zh: "乌克兰",
        "zh-tw": "烏克蘭"
    },
    {
        id: "ae",
        ar: "الإمارات العربية المتحدة",
        bg: "ОАЕ",
        cs: "Spojen\xe9 arabsk\xe9 emir\xe1ty",
        da: "Forenede Arabiske Emirater",
        de: "Vereinigte Arabische Emirate",
        el: "Ηνωμένα Αραβικά Εμιράτα",
        en: "United Arab Emirates",
        eo: "Unuiĝintaj Arabaj Emirlandoj",
        es: "Emiratos \xc1rabes Unidos",
        et: "Araabia \xdchendemiraadid",
        eu: "Arabiar Emirerri Batuak",
        fi: "Arabiemiirikunnat",
        fr: "\xc9mirats arabes unis",
        hu: "Egyes\xfclt Arab Em\xedrs\xe9gek",
        hy: "Արաբական Միացյալ Էմիրություններ",
        it: "Emirati Arabi Uniti",
        ja: "アラブ首長国連邦",
        ko: "아랍에미리트",
        lt: "Jungtiniai Arabų Emyratai",
        nl: "Verenigde Arabische Emiraten",
        no: "De forente arabiske emirater",
        pl: "Zjednoczone Emiraty Arabskie",
        pt: "Emirados \xc1rabes Unidos",
        ro: "Emiratele Arabe Unite",
        ru: "ОАЭ",
        sk: "Spojen\xe9 arabsk\xe9 emir\xe1ty",
        sv: "F\xf6renade Arabemiraten",
        th: "สหรัฐอาหรับเอมิเรตส์",
        uk: "ОАЕ",
        zh: "阿联酋",
        "zh-tw": "阿聯"
    },
    {
        id: "gb",
        ar: "المملكة المتحدة",
        bg: "Великобритания",
        cs: "Spojen\xe9 kr\xe1lovstv\xed Velk\xe9 Brit\xe1nie a Severn\xedho Irska",
        da: "Storbritannien",
        de: "Vereinigtes K\xf6nigreich",
        el: "Ηνωμένο Βασίλειο",
        en: "United Kingdom of Great Britain and Northern Ireland",
        eo: "Britio",
        es: "Reino Unido",
        et: "Suurbritannia",
        eu: "Erresuma Batua",
        fi: "Yhdistynyt kuningaskunta",
        fr: "Royaume-Uni",
        hu: "Egyes\xfclt Kir\xe1lys\xe1g",
        hy: "Մեծ Բրիտանիա",
        it: "Regno Unito",
        ja: "イギリス",
        ko: "영국",
        lt: "Jungtinė Karalystė",
        nl: "Verenigd Koninkrijk",
        no: "Storbritannia",
        pl: "Wielka Brytania",
        pt: "Reino Unido",
        ro: "Regatul Unit",
        ru: "Великобритания",
        sk: "Spojen\xe9 kr\xe1ľovstvo",
        sv: "Storbritannien",
        th: "สหราชอาณาจักร",
        uk: "Велика Британія",
        zh: "英国",
        "zh-tw": "英國"
    },
    {
        id: "us",
        ar: "الولايات المتحدة",
        bg: "САЩ",
        cs: "Spojen\xe9 st\xe1ty americk\xe9",
        da: "USA",
        de: "Vereinigte Staaten",
        el: "Ηνωμένες Πολιτείες Αμερικής",
        en: "United States of America",
        eo: "Usono",
        es: "Estados Unidos",
        et: "Ameerika \xdchendriigid",
        eu: "AEB",
        fi: "Yhdysvallat",
        fr: "\xc9tats-Unis",
        hu: "Amerikai Egyes\xfclt \xc1llamok",
        hy: "ԱՄՆ",
        it: "Stati Uniti",
        ja: "アメリカ合衆国",
        ko: "미국",
        lt: "Jungtinės Valstijos",
        nl: "Verenigde Staten",
        no: "USA",
        pl: "Stany Zjednoczone",
        pt: "Estados Unidos",
        ro: "Statele Unite ale Americii",
        ru: "США",
        sk: "Spojen\xe9 št\xe1ty",
        sv: "USA",
        th: "สหรัฐ",
        uk: "США",
        zh: "美国",
        "zh-tw": "美國"
    },
    {
        id: "uy",
        ar: "الأوروغواي",
        bg: "Уругвай",
        cs: "Uruguay",
        da: "Uruguay",
        de: "Uruguay",
        el: "Ουρουγουάη",
        en: "Uruguay",
        eo: "Urugvajo",
        es: "Uruguay",
        et: "Uruguay",
        eu: "Uruguai",
        fi: "Uruguay",
        fr: "Uruguay",
        hu: "Uruguay",
        hy: "Ուրուգվայ",
        it: "Uruguay",
        ja: "ウルグアイ",
        ko: "우루과이",
        lt: "Urugvajus",
        nl: "Uruguay",
        no: "Uruguay",
        pl: "Urugwaj",
        pt: "Uruguai",
        ro: "Uruguay",
        ru: "Уругвай",
        sk: "Uruguaj",
        sv: "Uruguay",
        th: "อุรุกวัย",
        uk: "Уругвай",
        zh: "乌拉圭",
        "zh-tw": "烏拉圭"
    },
    {
        id: "uz",
        ar: "أوزبكستان",
        bg: "Узбекистан",
        cs: "Uzbekist\xe1n",
        da: "Usbekistan",
        de: "Usbekistan",
        el: "Ουζμπεκιστάν",
        en: "Uzbekistan",
        eo: "Uzbekio",
        es: "Uzbekist\xe1n",
        et: "Usbekistan",
        eu: "Uzbekistan",
        fi: "Uzbekistan",
        fr: "Ouzb\xe9kistan",
        hu: "\xdczbegiszt\xe1n",
        hy: "Ուզբեկստան",
        it: "Uzbekistan",
        ja: "ウズベキスタン",
        ko: "우즈베키스탄",
        lt: "Uzbekistanas",
        nl: "Oezbekistan",
        no: "Usbekistan",
        pl: "Uzbekistan",
        pt: "Uzbequist\xe3o",
        ro: "Uzbekistan",
        ru: "Узбекистан",
        sk: "Uzbekistan",
        sv: "Uzbekistan",
        th: "อุซเบกิสถาน",
        uk: "Узбекистан",
        zh: "乌兹别克斯坦",
        "zh-tw": "烏茲別克"
    },
    {
        id: "vu",
        ar: "فانواتو",
        bg: "Вануату",
        cs: "Vanuatu",
        da: "Vanuatu",
        de: "Vanuatu",
        el: "Βανουάτου",
        en: "Vanuatu",
        eo: "Vanuatuo",
        es: "Vanuatu",
        et: "Vanuatu",
        eu: "Vanuatu",
        fi: "Vanuatu",
        fr: "Vanuatu",
        hu: "Vanuatu",
        hy: "Վանուատու",
        it: "Vanuatu",
        ja: "バヌアツ",
        ko: "바누아투",
        lt: "Vanuatu",
        nl: "Vanuatu",
        no: "Vanuatu",
        pl: "Vanuatu",
        pt: "Vanuatu",
        ro: "Vanuatu",
        ru: "Вануату",
        sk: "Vanuatu",
        sv: "Vanuatu",
        th: "วานูวาตู",
        uk: "Вануату",
        zh: "瓦努阿图",
        "zh-tw": "萬那杜"
    },
    {
        id: "ve",
        ar: "فنزويلا",
        bg: "Венецуела",
        cs: "Venezuela",
        da: "Venezuela",
        de: "Venezuela",
        el: "Βενεζουέλα",
        en: "Venezuela (Bolivarian Republic of)",
        eo: "Venezuelo",
        es: "Venezuela",
        et: "Venezuela",
        eu: "Venezuela",
        fi: "Venezuela",
        fr: "Venezuela",
        hu: "Venezuela",
        hy: "Վենեսուելա",
        it: "Venezuela",
        ja: "ベネズエラ・ボリバル共和国",
        ko: "베네수엘라",
        lt: "Venesuela",
        nl: "Venezuela",
        no: "Venezuela",
        pl: "Wenezuela",
        pt: "Venezuela",
        ro: "Venezuela",
        ru: "Венесуэла",
        sk: "Venezuela",
        sv: "Venezuela",
        th: "เวเนซุเอลา",
        uk: "Венесуела",
        zh: "委内瑞拉",
        "zh-tw": "委內瑞拉"
    },
    {
        id: "vn",
        ar: "فيتنام",
        bg: "Виетнам",
        cs: "Vietnam",
        da: "Vietnam",
        de: "Vietnam",
        el: "Βιετνάμ",
        en: "Viet Nam",
        eo: "Vjetnamio",
        es: "Vietnam",
        et: "Vietnam",
        eu: "Vietnam",
        fi: "Vietnam",
        fr: "Vi\xeat Nam",
        hu: "Vietn\xe1m",
        hy: "Վիետնամ",
        it: "Vietnam",
        ja: "ベトナム",
        ko: "베트남",
        lt: "Vietnamas",
        nl: "Vietnam",
        no: "Vietnam",
        pl: "Wietnam",
        pt: "Vietname",
        ro: "Vietnam",
        ru: "Вьетнам",
        sk: "Vietnam",
        sv: "Vietnam",
        th: "เวียดนาม",
        uk: "В'єтнам",
        zh: "越南",
        "zh-tw": "越南"
    },
    {
        id: "ye",
        ar: "اليمن",
        bg: "Йемен",
        cs: "Jemen",
        da: "Yemen",
        de: "Jemen",
        el: "Υεμένη",
        en: "Yemen",
        eo: "Jemeno",
        es: "Yemen",
        et: "Jeemen",
        eu: "Yemen",
        fi: "Jemen",
        fr: "Y\xe9men",
        hu: "Jemen",
        hy: "Եմեն",
        it: "Yemen",
        ja: "イエメン",
        ko: "예멘",
        lt: "Jemenas",
        nl: "Jemen",
        no: "Jemen",
        pl: "Jemen",
        pt: "I\xeamen",
        ro: "Yemen",
        ru: "Йемен",
        sk: "Jemen",
        sv: "Jemen",
        th: "เยเมน",
        uk: "Ємен",
        zh: "也门",
        "zh-tw": "葉門"
    },
    {
        id: "zm",
        ar: "زامبيا",
        bg: "Замбия",
        cs: "Zambie",
        da: "Zambia",
        de: "Sambia",
        el: "Ζάμπια",
        en: "Zambia",
        eo: "Zambio",
        es: "Zambia",
        et: "Sambia",
        eu: "Zambia",
        fi: "Sambia",
        fr: "Zambie",
        hu: "Zambia",
        hy: "Զամբիա",
        it: "Zambia",
        ja: "ザンビア",
        ko: "잠비아",
        lt: "Zambija",
        nl: "Zambia",
        no: "Zambia",
        pl: "Zambia",
        pt: "Z\xe2mbia",
        ro: "Zambia",
        ru: "Замбия",
        sk: "Zambia",
        sv: "Zambia",
        th: "แซมเบีย",
        uk: "Замбія",
        zh: "赞比亚",
        "zh-tw": "尚比亞"
    },
    {
        id: "zw",
        ar: "زيمبابوي",
        bg: "Зимбабве",
        cs: "Zimbabwe",
        da: "Zimbabwe",
        de: "Simbabwe",
        el: "Ζιμπάμπουε",
        en: "Zimbabwe",
        eo: "Zimbabvo",
        es: "Zimbabue",
        et: "Zimbabwe",
        eu: "Zimbabwe",
        fi: "Zimbabwe",
        fr: "Zimbabwe",
        hu: "Zimbabwe",
        hy: "Զիմբաբվե",
        it: "Zimbabwe",
        ja: "ジンバブエ",
        ko: "짐바브웨",
        lt: "Zimbabvė",
        nl: "Zimbabwe",
        no: "Zimbabwe",
        pl: "Zimbabwe",
        pt: "Zimb\xe1bue",
        ro: "Zimbabwe",
        ru: "Зимбабве",
        sk: "Zimbabwe",
        sv: "Zimbabwe",
        th: "ซิมบับเว",
        uk: "Зімбабве",
        zh: "津巴布韦",
        "zh-tw": "辛巴威"
    }
];
/* harmony default export */ var components_countries = (countries);

;// CONCATENATED MODULE: ./src/sections/parentLogin/components/ParentLogin.js














const validationSchema = es/* object */.Ry().shape({
    country: es/* mixed */.nK().required(),
    selected_school: es/* mixed */.nK().required()
});
function ParentLogin() {
    var _formik_values_country, _schoolsQuery_data;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { locale  } = (0,router.useRouter)();
    // const countryCodeQuery = useGetCountryCode()
    // const defaultCountry = countryCodeQuery?.data ?? ''
    // const registerMutation = useRegister()
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            country: null,
            school_name: "",
            selected_school: null
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values, actions)=>{
            window.location.href = "".concat(values.selected_school.main_url, "/").concat(locale);
            actions.setSubmitting(false);
        }
    });
    const [search, setSearch] = react.useState("");
    const handleSearchChange = react.useCallback((0,lodash.debounce)((value)=>setSearch(value), 500), []);
    react.useEffect(()=>{
        handleSearchChange(formik.values.school_name);
    }, [
        formik.values.school_name
    ]);
    const schoolsQuery = useSchools((_formik_values_country = formik.values.country) === null || _formik_values_country === void 0 ? void 0 : _formik_values_country.en, search);
    var _option_locale, _option_locale1, _schoolsQuery_data_data;
    // const schoolsQuery = useSchools(formik.values.country?.code, search)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateAccountLayout, {
            title: t("parent-login:Parents_Log_In"),
            subtitle: t("parent-login:Log_in_with_your_school_name"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 5,
                    component: "form",
                    onSubmit: formik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                fullWidth: true,
                                id: "country",
                                name: "country",
                                autoComplete: true,
                                onChange: (_, value)=>formik.setFieldValue("country", value),
                                value: formik.values.country,
                                renderOption: (props, option)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        ...props,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        loading: "lazy",
                                                        width: "20",
                                                        src: "https://flagcdn.com/w20/".concat(option.id.toLowerCase(), ".png"),
                                                        srcSet: "https://flagcdn.com/w40/".concat(option.id.toLowerCase(), ".png 2x"),
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    children: (_option_locale = option === null || option === void 0 ? void 0 : option[locale]) !== null && _option_locale !== void 0 ? _option_locale : option.en
                                                })
                                            ]
                                        })
                                    });
                                },
                                getOptionLabel: (option)=>{
                                    return (_option_locale1 = option === null || option === void 0 ? void 0 : option[locale]) !== null && _option_locale1 !== void 0 ? _option_locale1 : option.en;
                                },
                                options: components_countries,
                                noOptionsText: t("parent-login:noOptions"),
                                renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                                        ...params,
                                        onBlur: formik.handleBlur,
                                        name: "country",
                                        label: t("parent-login:Select_Country"),
                                        backgroundColor: "neutral.main",
                                        size: "large",
                                        error: formik.touched.country && Boolean(formik.errors.country),
                                        helperText: formik.touched.country && formik.errors.country,
                                        StartIcon: Public,
                                        inputProps: {
                                            "aria-label": t("parent-login:Select_Country"),
                                            ...params.inputProps
                                        }
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                fullWidth: true,
                                id: "selected-school",
                                name: "selected_school",
                                disabled: !formik.values.country,
                                autoComplete: true,
                                onInputChange: (_, newInputValue)=>formik.setFieldValue("school_name", newInputValue),
                                onChange: (_, value)=>formik.setFieldValue("selected_school", value),
                                value: formik.values.selected_school,
                                inputValue: formik.values.school_name,
                                filterOptions: (x)=>x,
                                getOptionLabel: (option)=>option.name,
                                options: (_schoolsQuery_data_data = (_schoolsQuery_data = schoolsQuery.data) === null || _schoolsQuery_data === void 0 ? void 0 : _schoolsQuery_data.data) !== null && _schoolsQuery_data_data !== void 0 ? _schoolsQuery_data_data : [],
                                loading: schoolsQuery.isFetching,
                                noOptionsText: search.length < 3 ? t("parent-login:Enter_at_least_3_characters_to_show_results") : t("parent-login:noOptions"),
                                loadingText: "".concat(t("parent-login:loading"), "..."),
                                renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                                        ...params,
                                        onBlur: formik.handleBlur,
                                        name: "selected_school",
                                        label: t("parent-login:Enter_School_Name"),
                                        placeholder: t("parent-login:Enter_at_least_3_characters_to_show_results"),
                                        backgroundColor: "neutral.main",
                                        size: "large",
                                        error: formik.touched.selected_school && Boolean(formik.errors.selected_school),
                                        helperText: formik.touched.selected_school && formik.errors.selected_school,
                                        StartIcon: SchoolOutlined,
                                        inputProps: {
                                            "aria-label": t("parent-login:School_Name"),
                                            ...params.inputProps
                                        },
                                        // eslint-disable-next-line react/jsx-no-duplicate-props
                                        InputProps: {
                                            ...params.InputProps,
                                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    schoolsQuery.isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                        color: "inherit",
                                                        size: 20
                                                    }) : null,
                                                    params.InputProps.endAdornment
                                                ]
                                            })
                                        }
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatButton/* default */.Z, {
                                variant: "contained",
                                sx: {
                                    mb: 2
                                },
                                onClick: formik.handleSubmit,
                                "aria-label": t("parent-login:visit_school_Website"),
                                type: "submit",
                                children: t("parent-login:visit_school_Website")
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var components_ParentLogin = (ParentLogin);

;// CONCATENATED MODULE: ./src/sections/parentLogin/ParentLoginSection.js







function ParentLoginSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            position: "relative",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            flexDirection: "column",
            sx: {
                minHeight: "100vh"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                width: "100%",
                                display: {
                                    xs: "none",
                                    md: "block"
                                },
                                zIndex: -1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(register_drawings/* default */.Z, {
                                width: "100%",
                                height: "100%"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                width: "100%",
                                display: {
                                    xs: "block",
                                    md: "none"
                                },
                                zIndex: -1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(register_drawings_small/* default */.Z, {
                                width: "100%",
                                height: "100%"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ParentLogin, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    flexGrow: 1,
                    justifyContent: "center",
                    alignItems: "flex-end",
                    container: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sx: {
                            my: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelect/* default */.Z, {})
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var parentLogin_ParentLoginSection = ((/* unused pure expression or super */ null && (ParentLoginSection)));

;// CONCATENATED MODULE: ./src/sections/parentLogin/index.js


// EXTERNAL MODULE: ./src/contexts/CaptchaProvider/index.js + 1 modules
var CaptchaProvider = __webpack_require__(28248);
;// CONCATENATED MODULE: ./pages/parent-login.js






function parent_login_ParentLogin() {
    const { t  } = (0,esm/* useTranslation */.$G)([
        "meta"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptchaProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: "".concat(t("meta:parentLogin.title"), " - Blue Assembly")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: t("meta:parentLogin.description")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentLoginSection, {})
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var parent_login = ((0,esm/* withTranslation */.Zh)([
    "common"
])(parent_login_ParentLogin));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6,809,558,367,616,894,774,888,179], function() { return __webpack_exec__(96897); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);